export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  JSON: unknown;
  JSONObject: unknown;
  PastDate: string;
  Time: string;
};

export type ActivateCardError = CardInUseError | IsPatientsCardError | PatientNotFoundError | VoidCardError;

export type ActivateCardInput = {
  readonly cardId?: InputMaybe<Scalars['String']>;
  readonly patientId: Scalars['ID'];
  readonly url?: InputMaybe<Scalars['String']>;
};

export type ActivateCardResponse = {
  readonly __typename?: 'ActivateCardResponse';
  readonly cardId: Scalars['String'];
  readonly errors: ReadonlyArray<ActivateCardError>;
};

export type ActivateSkuInput = {
  readonly id: Scalars['ID'];
};

export type ActivityDetails = DiagnosisReceivedDetails | InvestigationPerformedDetails | InvestigationRequestedDetails | PrescriptionDispensedDetails | PrescriptionIssuedDetails;

export type AddCareEventToVisitInput = {
  readonly careEvents: ReadonlyArray<InputMaybe<VisitCareEventInput>>;
  /** @deprecated Use patientUuid */
  readonly patientId?: InputMaybe<Scalars['String']>;
  readonly patientUuid: Scalars['String'];
};

export type AddClinicInsuranceInput = {
  readonly apiKeyName?: InputMaybe<Scalars['String']>;
  readonly apiKeySecret?: InputMaybe<Scalars['String']>;
  readonly cpc?: InputMaybe<Scalars['String']>;
  readonly dailyRebateAmount?: InputMaybe<Scalars['Float']>;
  readonly eclaimAuthorizationNumber?: InputMaybe<Scalars['String']>;
  readonly facilityType?: InputMaybe<FacilityType>;
  readonly healthProviderCode?: InputMaybe<Scalars['String']>;
  readonly hpn?: InputMaybe<Scalars['String']>;
  readonly providerAccreditationNumber?: InputMaybe<Scalars['String']>;
};

export type AddEpocusProgramMemberInput = {
  readonly elephantUserId: Scalars['ID'];
  /**
   * Used only to create the EpocusUser when elephantUserId is new to
   * ePOCUS. Ignored if that person is already an EpocusUser (idempotent
   * re-runs reuse the existing profile rather than overwriting it).
   */
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly programId: Scalars['ID'];
  readonly role: EpocusRole;
  readonly telephone?: InputMaybe<Scalars['String']>;
};

export type AddNoteToVisitInput = {
  readonly notes: Scalars['String'];
  readonly patientUuid: Scalars['String'];
  readonly visitId?: InputMaybe<Scalars['ID']>;
};

export type AddPatientToLocationInput = {
  readonly locationID: Scalars['ID'];
  readonly patient: AddPatientToLocationInputPatient;
};

export type AddPatientToLocationInputPatient = {
  readonly _id?: InputMaybe<Scalars['ID']>;
  readonly diagnoses: ReadonlyArray<I18nStringInput>;
  readonly dob: Scalars['DateTime'];
  readonly gender: Gender;
  readonly name: Scalars['String'];
  readonly uuid: Scalars['ID'];
};

export type AddPayersInput = {
  readonly _id: Scalars['String'];
  readonly payers: ReadonlyArray<InputMaybe<PayerInput>>;
};

export type AddQueuePatientInput = {
  readonly patientUuid: Scalars['ID'];
  readonly queueId: Scalars['ID'];
};

export type AddStockTakeLotInput = {
  readonly expiryDate: Scalars['Date'];
  readonly facilityId: Scalars['ID'];
  readonly reviewedQuantity: Scalars['Int'];
  readonly skuId: Scalars['ID'];
  readonly stockTakeId: Scalars['ID'];
};

export type Address = {
  readonly __typename?: 'Address';
  readonly country?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly subCounty?: Maybe<Scalars['String']>;
  readonly ward?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  readonly country?: InputMaybe<Scalars['String']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly street?: InputMaybe<Scalars['String']>;
  readonly subCounty?: InputMaybe<Scalars['String']>;
  readonly ward?: InputMaybe<Scalars['String']>;
};

export type AdministerScheduledDoseInput = {
  readonly administeredFacilityId: Scalars['String'];
  readonly administeredLocationId?: InputMaybe<Scalars['String']>;
  readonly administeredMedicationTakenFrom: AdministeredMedicationTakenFrom;
  readonly administeredSkuId?: InputMaybe<Scalars['String']>;
  readonly administeredSkuQuantity?: InputMaybe<Scalars['Int']>;
  readonly id: Scalars['String'];
};

export type AdministerUnscheduledDoseInput = {
  readonly administeredFacilityId: Scalars['String'];
  readonly administeredLocationId?: InputMaybe<Scalars['String']>;
  readonly administeredMedicationTakenFrom: AdministeredMedicationTakenFrom;
  readonly administeredSkuId?: InputMaybe<Scalars['String']>;
  readonly administeredSkuQuantity?: InputMaybe<Scalars['Int']>;
  readonly prescriptionId: Scalars['String'];
};

export enum AdministeredMedicationTakenFrom {
  NewInventory = 'NEW_INVENTORY',
  OpenInventory = 'OPEN_INVENTORY',
  PatientPurchased = 'PATIENT_PURCHASED'
}

export enum AdministeredOutcome {
  Cancelled = 'CANCELLED',
  Missed = 'MISSED',
  Refused = 'REFUSED',
  Taken = 'TAKEN'
}

export enum AdministrationApproach {
  AsRequired = 'AS_REQUIRED',
  Outpatient = 'OUTPATIENT',
  Scheduled = 'SCHEDULED',
  Stat = 'STAT'
}

export type AdministrationSchedule = {
  readonly __typename?: 'AdministrationSchedule';
  readonly administeredBy?: Maybe<User>;
  readonly administeredDateTime?: Maybe<Scalars['DateTime']>;
  readonly administeredFacilityId?: Maybe<Scalars['String']>;
  readonly administeredLocationId?: Maybe<Scalars['String']>;
  readonly administeredMedicationTakenFrom?: Maybe<AdministeredMedicationTakenFrom>;
  readonly administeredOutcome?: Maybe<AdministeredOutcome>;
  readonly administeredSku?: Maybe<Sku>;
  readonly administeredSkuId?: Maybe<Scalars['String']>;
  readonly administeredSkuQuantity?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly prescription?: Maybe<InpatientPrescription>;
  readonly prescriptionId: Scalars['String'];
  readonly scheduleDateTime: Scalars['DateTime'];
  readonly updatedAt: Scalars['DateTime'];
};

export type AdministrationScheduleConnection = {
  readonly __typename?: 'AdministrationScheduleConnection';
  readonly edges: ReadonlyArray<AdministrationScheduleEdge>;
};

export type AdministrationScheduleEdge = {
  readonly __typename?: 'AdministrationScheduleEdge';
  readonly cursor: Scalars['ID'];
  readonly node: AdministrationSchedule;
};

export type AdministrationScheduleResponse = {
  readonly __typename?: 'AdministrationScheduleResponse';
  readonly administrationSchedules: ReadonlyArray<Maybe<AdministrationSchedule>>;
};

export enum AdministrationScheduleSummaryStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING'
}

export type AiFinding = {
  readonly __typename?: 'AiFinding';
  readonly id: Scalars['ID'];
  readonly payload: Scalars['JSON'];
  readonly receivedAt: Scalars['DateTime'];
  readonly resolutionPath: Scalars['String'];
  readonly sourceSystem?: Maybe<Scalars['String']>;
};

export type Amount = {
  readonly __typename?: 'Amount';
  readonly currency: BillingCurrency;
  readonly value: Scalars['Int'];
};

export type AmountInput = {
  readonly currency: BillingCurrency;
  readonly value: Scalars['Int'];
};

export type Amp = ClinicalProduct & ClinicalProductInventorySummary & {
  readonly __typename?: 'Amp';
  readonly id: Scalars['String'];
  readonly inventory: ExternalReferenceInventorySummary;
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly meta: ProductMeta;
  readonly productType: ProductType;
  readonly title: Scalars['String'];
  readonly vmpId: Scalars['String'];
};


export type AmpInventoryArgs = {
  input: ClinicalProductInventorySummaryInput;
};

export type AmpByVmpInput = {
  readonly vmpId: Scalars['String'];
};

export enum AncBloodGroup {
  A = 'A',
  Ab = 'AB',
  B = 'B',
  O = 'O'
}

export enum AncDangerSign {
  BlurredVision = 'BLURRED_VISION',
  Convulsions = 'CONVULSIONS',
  Oedema = 'OEDEMA',
  ReducedFetalMovement = 'REDUCED_FETAL_MOVEMENT',
  SevereAbdominalPain = 'SEVERE_ABDOMINAL_PAIN',
  SevereHeadache = 'SEVERE_HEADACHE',
  VaginalBleeding = 'VAGINAL_BLEEDING'
}

export type AncEncounter = {
  readonly __typename?: 'AncEncounter';
  readonly ageOfPregnancy?: Maybe<Scalars['Int']>;
  readonly aliveBirths?: Maybe<Scalars['Int']>;
  readonly associatedProblems?: Maybe<Scalars['String']>;
  readonly bloodGroup?: Maybe<AncBloodGroup>;
  readonly clinic?: Maybe<Clinic>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy?: Maybe<User>;
  readonly dangerSigns: ReadonlyArray<AncDangerSign>;
  readonly dueDate?: Maybe<Scalars['DateTime']>;
  readonly earlyInitiationOfBreastfeeding?: Maybe<Scalars['Boolean']>;
  readonly exclusiveBreastfeeding?: Maybe<Scalars['Boolean']>;
  readonly femaleGenitalMutilation?: Maybe<Scalars['Boolean']>;
  readonly gravidity?: Maybe<Scalars['Int']>;
  readonly hepatitisBInvestigation: ReadonlyArray<Maybe<AncInvestigationOutcome>>;
  readonly hepatitisCInvestigation: ReadonlyArray<Maybe<AncInvestigationOutcome>>;
  readonly hivTesting?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly investigations?: Maybe<ReadonlyArray<Maybe<InvestigationActivity>>>;
  readonly iptpDoseOverride?: Maybe<Scalars['Int']>;
  readonly lastMenstrualPeriod?: Maybe<Scalars['DateTime']>;
  readonly livingChildren?: Maybe<Scalars['Int']>;
  readonly longLastingInsecticidalNet?: Maybe<Scalars['Boolean']>;
  readonly maritalStatus?: Maybe<AncMaritalStatus>;
  readonly maternalNutrition?: Maybe<Scalars['Boolean']>;
  readonly parityDeliveries?: Maybe<Scalars['Int']>;
  readonly parityMiscarriages?: Maybe<Scalars['Int']>;
  readonly patient?: Maybe<Patient>;
  readonly prescriptions?: Maybe<ReadonlyArray<Maybe<InpatientPrescription>>>;
  readonly priorPregnancies?: Maybe<ReadonlyArray<AncPriorPregnancy>>;
  readonly referralHospital?: Maybe<Scalars['String']>;
  readonly rhesusFactor?: Maybe<AncRhesusFactor>;
  readonly status: AncEncounterStatus;
  readonly syphilisInvestigation: ReadonlyArray<Maybe<AncInvestigationOutcome>>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  readonly visitNumber?: Maybe<Scalars['Int']>;
};

export type AncEncounterPage = {
  readonly __typename?: 'AncEncounterPage';
  readonly encounters: ReadonlyArray<Maybe<AncEncounter>>;
  readonly skip?: Maybe<Scalars['Int']>;
  readonly take?: Maybe<Scalars['Int']>;
  readonly total?: Maybe<Scalars['Int']>;
};

export enum AncEncounterStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Discharged = 'DISCHARGED',
  Discontinued = 'DISCONTINUED',
  EnteredInError = 'ENTERED_IN_ERROR',
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD',
  Planned = 'PLANNED',
  Unknown = 'UNKNOWN'
}

export type AncEncountersFilterOptions = {
  readonly skip?: InputMaybe<Scalars['Int']>;
  readonly take?: InputMaybe<Scalars['Int']>;
};

export type AncEncountersFilterParams = {
  readonly endDate?: InputMaybe<Scalars['Date']>;
  readonly patientId?: InputMaybe<Scalars['ID']>;
  readonly searchWholeTerritory?: InputMaybe<Scalars['Boolean']>;
  readonly startDate?: InputMaybe<Scalars['Date']>;
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<AncEncounterStatus>>>;
};

export enum AncInvestigationOutcome {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE',
  Referred = 'REFERRED',
  Treated = 'TREATED'
}

export enum AncMaritalStatus {
  Cohabiting = 'COHABITING',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Other = 'OTHER',
  Separated = 'SEPARATED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type AncPatientRiskRecord = {
  readonly __typename?: 'AncPatientRiskRecord';
  readonly createdAt: Scalars['DateTime'];
  readonly highRisk: Scalars['Boolean'];
  readonly highRiskClearedAt?: Maybe<Scalars['DateTime']>;
  readonly highRiskClearedByUserId?: Maybe<Scalars['String']>;
  readonly highRiskSetAt?: Maybe<Scalars['DateTime']>;
  readonly highRiskSetByUserId?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly patientId: Scalars['ID'];
  readonly updatedAt: Scalars['DateTime'];
};

export type AncPriorPregnancy = {
  readonly __typename?: 'AncPriorPregnancy';
  readonly birthWeightG?: Maybe<Scalars['Int']>;
  readonly dateOfDelivery?: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly modeOfDelivery?: Maybe<AncPriorPregnancyModeOfDelivery>;
  readonly outcome?: Maybe<AncPriorPregnancyOutcome>;
  readonly sexOfBaby?: Maybe<AncPriorPregnancySexOfBaby>;
};

export type AncPriorPregnancyInput = {
  readonly birthWeightG?: InputMaybe<Scalars['Int']>;
  readonly dateOfDelivery?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly modeOfDelivery?: InputMaybe<AncPriorPregnancyModeOfDelivery>;
  readonly outcome?: InputMaybe<AncPriorPregnancyOutcome>;
  readonly sexOfBaby?: InputMaybe<AncPriorPregnancySexOfBaby>;
};

export enum AncPriorPregnancyModeOfDelivery {
  Assisted = 'ASSISTED',
  EmergencyCSection = 'EMERGENCY_C_SECTION',
  PlannedCSection = 'PLANNED_C_SECTION',
  Svd = 'SVD'
}

export enum AncPriorPregnancyOutcome {
  Alive = 'ALIVE',
  Miscarriage = 'MISCARRIAGE',
  NeonatalDeath = 'NEONATAL_DEATH',
  Stillbirth = 'STILLBIRTH'
}

export enum AncPriorPregnancySexOfBaby {
  Female = 'FEMALE',
  Male = 'MALE'
}

export enum AncRhesusFactor {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type AssignCardInput = {
  readonly cardId?: InputMaybe<Scalars['String']>;
  /** Either patientId or uuid is required. Use patientId, and once all migrated, remove uuid and make patientId required. */
  readonly patientId?: InputMaybe<Scalars['ID']>;
  readonly url?: InputMaybe<Scalars['String']>;
  /**
   * Either patientId or uuid is required. Use patientId, and once all migrated, remove uuid and make patientId required.
   * @deprecated Use patientId instead
   */
  readonly uuid?: InputMaybe<Scalars['String']>;
};

export type BackfillEpocusProgramScopeInput = {
  readonly programId: Scalars['ID'];
};

export type Balance = {
  readonly __typename?: 'Balance';
  readonly currency?: Maybe<BillingCurrency>;
  readonly due?: Maybe<Scalars['Int']>;
  readonly exempt?: Maybe<Scalars['Int']>;
  readonly paid?: Maybe<Scalars['Int']>;
  readonly total?: Maybe<Scalars['Int']>;
  readonly waived?: Maybe<Scalars['Int']>;
};

export type BalanceInput = {
  readonly due: Scalars['Int'];
  readonly paid: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type BaseActivity = {
  readonly _id: Scalars['ID'];
  readonly meta: Meta;
};

export type BaseError = {
  readonly message: Scalars['String'];
  readonly path: ReadonlyArray<Scalars['String']>;
};

export enum BillingCurrency {
  Ghs = 'GHS',
  Kes = 'KES',
  Lrd = 'LRD',
  Ngn = 'NGN',
  Pkr = 'PKR',
  Usd = 'USD'
}

export type BillingDataReportInput = {
  readonly endDate: Scalars['DateTime'];
  readonly startDate: Scalars['DateTime'];
  readonly timezone?: InputMaybe<Scalars['String']>;
};

export enum BillingMode {
  PostService = 'POST_SERVICE',
  PreService = 'PRE_SERVICE'
}

export type Blocks = {
  readonly __typename?: 'Blocks';
  readonly hasBlockedIPs?: Maybe<Scalars['Boolean']>;
  readonly isBlockedByAdmin?: Maybe<Scalars['Boolean']>;
};

export type BulkDownloadResult = {
  readonly __typename?: 'BulkDownloadResult';
  readonly csv: Scalars['String'];
  readonly totalCount: Scalars['Int'];
};

export type BulkUploadError = {
  readonly __typename?: 'BulkUploadError';
  readonly errorMessage?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly unflattenedData?: Maybe<Scalars['JSONObject']>;
};

export type BulkUploadInput = {
  readonly csv: Scalars['String'];
};

export type BulkUploadItemValidationResult = {
  readonly __typename?: 'BulkUploadItemValidationResult';
  readonly errorMessage?: Maybe<Scalars['String']>;
  readonly hasError?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['String'];
  readonly isAddition?: Maybe<Scalars['Boolean']>;
  readonly isUpdate?: Maybe<Scalars['Boolean']>;
  readonly unflattenedValue?: Maybe<Scalars['JSONObject']>;
  readonly validationBreakdown?: Maybe<Scalars['JSONObject']>;
};

export type BulkUploadResult = {
  readonly __typename?: 'BulkUploadResult';
  readonly errors: ReadonlyArray<BulkUploadError>;
  readonly totalAdditions: Scalars['Int'];
  readonly totalErrors: Scalars['Int'];
  readonly totalSent: Scalars['Int'];
  readonly totalUpdates: Scalars['Int'];
};

export type BulkUploadValidationResult = {
  readonly __typename?: 'BulkUploadValidationResult';
  readonly items: ReadonlyArray<BulkUploadItemValidationResult>;
  readonly totalAdditions: Scalars['Int'];
  readonly totalErrors: Scalars['Int'];
  readonly totalSent: Scalars['Int'];
  readonly totalUpdates: Scalars['Int'];
};

export type CancelPrescriptionInput = {
  readonly cancelledReason: Scalars['String'];
  readonly id: Scalars['ID'];
};

export type CancelPrescriptionsInput = {
  readonly prescriptions: ReadonlyArray<CancelPrescriptionInput>;
};

export type CancellationDetails = {
  readonly __typename?: 'CancellationDetails';
  readonly at: Scalars['DateTime'];
  readonly by?: Maybe<User>;
  readonly reason: Scalars['String'];
};

export type CardDetailsInput = {
  readonly active?: InputMaybe<Scalars['Boolean']>;
  readonly cardAssignedDate?: InputMaybe<Scalars['DateTime']>;
  readonly cardUpdatedDate?: InputMaybe<Scalars['DateTime']>;
  readonly rateLimit?: InputMaybe<RateLimit>;
};

export type CardInUseError = BaseError & {
  readonly __typename?: 'CardInUseError';
  readonly message: Scalars['String'];
  readonly path: ReadonlyArray<Scalars['String']>;
};

export enum CardType {
  Nhiscard = 'NHISCARD'
}

export type CardVoided = {
  readonly __typename?: 'CardVoided';
  readonly at: Scalars['DateTime'];
};

export type CareActivity = {
  readonly _id: Scalars['ID'];
  readonly careActivity?: Maybe<ActivityDetails>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly type: Scalars['String'];
};

export type CatalogueCoding = {
  readonly __typename?: 'CatalogueCoding';
  readonly elephant?: Maybe<SpecificationReference>;
  readonly loinc?: Maybe<SpecificationReference>;
};

export type CatalogueCodingInput = {
  readonly elephant?: InputMaybe<SpecificationReferenceInput>;
  readonly loinc?: InputMaybe<SpecificationReferenceInput>;
};

export type CatalogueInvestigationActivitiesInput = {
  readonly elephantCodes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly loincCodes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type Category = {
  readonly __typename?: 'Category';
  readonly displayName: Scalars['String'];
  readonly value: Scalars['String'];
};

export enum ChangeReason {
  Error = 'ERROR',
  Expired = 'EXPIRED',
  Other = 'OTHER',
  StockTake = 'STOCK_TAKE',
  TransferToAnotherFacility = 'TRANSFER_TO_ANOTHER_FACILITY',
  Wastage = 'WASTAGE'
}

export type ChildImmunisationRegisterInput = {
  readonly filterOptions: FilterOptions;
  readonly paginationOptions?: InputMaybe<PaginationOptions>;
};

export type ChildImmunisationRegisterRecord = {
  readonly __typename?: 'ChildImmunisationRegisterRecord';
  readonly bcg?: Maybe<Scalars['DateTime']>;
  readonly hepatitisB0?: Maybe<Scalars['DateTime']>;
  readonly hpv?: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly ipv1?: Maybe<Scalars['DateTime']>;
  readonly ipv2?: Maybe<Scalars['DateTime']>;
  readonly measles1?: Maybe<Scalars['DateTime']>;
  readonly measles2?: Maybe<Scalars['DateTime']>;
  readonly meningitisA?: Maybe<Scalars['DateTime']>;
  readonly opv0?: Maybe<Scalars['DateTime']>;
  readonly opv1?: Maybe<Scalars['DateTime']>;
  readonly opv2?: Maybe<Scalars['DateTime']>;
  readonly opv3?: Maybe<Scalars['DateTime']>;
  readonly patient: Patient;
  readonly pcv1?: Maybe<Scalars['DateTime']>;
  readonly pcv2?: Maybe<Scalars['DateTime']>;
  readonly pcv3?: Maybe<Scalars['DateTime']>;
  readonly penta1?: Maybe<Scalars['DateTime']>;
  readonly penta2?: Maybe<Scalars['DateTime']>;
  readonly penta3?: Maybe<Scalars['DateTime']>;
  readonly rota1?: Maybe<Scalars['DateTime']>;
  readonly rota2?: Maybe<Scalars['DateTime']>;
  readonly rota3?: Maybe<Scalars['DateTime']>;
  readonly vitaminA1?: Maybe<Scalars['DateTime']>;
  readonly vitaminA2?: Maybe<Scalars['DateTime']>;
  readonly yellowFever?: Maybe<Scalars['DateTime']>;
};

export enum CineStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY'
}

export type ClearAncHighRiskInput = {
  readonly patientId: Scalars['ID'];
};

export type Clinic = {
  readonly __typename?: 'Clinic';
  readonly addresses: ReadonlyArray<Address>;
  readonly name: Scalars['String'];
  readonly organisation: Scalars['String'];
  readonly service?: Maybe<Scalars['String']>;
  readonly settings: ClinicSettings;
  readonly uuid: Scalars['String'];
};

export type ClinicInput = {
  readonly addresses?: InputMaybe<ReadonlyArray<InputMaybe<AddressInput>>>;
  readonly name: Scalars['String'];
  readonly organisation?: InputMaybe<Scalars['String']>;
  readonly settings?: InputMaybe<CreateClinicSettings>;
};

export type ClinicInsurance = {
  readonly __typename?: 'ClinicInsurance';
  readonly apiKeyName?: Maybe<Scalars['String']>;
  readonly apiKeySecret?: Maybe<Scalars['String']>;
  readonly clinic?: Maybe<Scalars['String']>;
  readonly cpc?: Maybe<Scalars['String']>;
  readonly created?: Maybe<Scalars['DateTime']>;
  readonly dailyRebateAmount?: Maybe<Scalars['Float']>;
  readonly eclaimAuthorizationNumber?: Maybe<Scalars['String']>;
  readonly facilityType?: Maybe<FacilityType>;
  readonly healthProviderCode?: Maybe<Scalars['String']>;
  readonly hpn?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['ID']>;
  readonly providerAccreditationNumber?: Maybe<Scalars['String']>;
  readonly updated?: Maybe<Scalars['DateTime']>;
};

export type ClinicInsuranceDetailsForClaimsInput = {
  readonly clinicUuid?: InputMaybe<Scalars['String']>;
};

export type ClinicSettings = {
  readonly __typename?: 'ClinicSettings';
  readonly billingMode: BillingMode;
  readonly inventoryManagement: Scalars['Boolean'];
};

export type ClinicalEvent = {
  readonly __typename?: 'ClinicalEvent';
  readonly id: Scalars['ID'];
  readonly type: ClinicalEventType;
};

export type ClinicalEventRefInput = {
  readonly id: Scalars['ID'];
  readonly type: ClinicalEventType;
};

export enum ClinicalEventType {
  AncEncounter = 'ANC_ENCOUNTER',
  Consultation = 'CONSULTATION',
  Visit = 'VISIT'
}

export type ClinicalProduct = {
  readonly id: Scalars['String'];
  readonly meta: ProductMeta;
  readonly productType: ProductType;
  readonly title: Scalars['String'];
};

export type ClinicalProductCategory = {
  readonly __typename?: 'ClinicalProductCategory';
  readonly id: Scalars['String'];
  readonly title: ClinicalProductCategoryTitle;
};

export type ClinicalProductCategoryTitle = {
  readonly __typename?: 'ClinicalProductCategoryTitle';
  readonly en: Scalars['String'];
};

export type ClinicalProductForm = {
  readonly __typename?: 'ClinicalProductForm';
  readonly id: Scalars['String'];
  readonly meta: ProductMeta;
  readonly title: Scalars['String'];
};

export type ClinicalProductFormInput = {
  readonly id: Scalars['String'];
  readonly title: Scalars['String'];
};

export type ClinicalProductFormTitle = {
  readonly __typename?: 'ClinicalProductFormTitle';
  readonly en: Scalars['String'];
  readonly es?: Maybe<Scalars['String']>;
  readonly fr?: Maybe<Scalars['String']>;
};

export type ClinicalProductInventorySummary = {
  readonly inventory: ExternalReferenceInventorySummary;
};


export type ClinicalProductInventorySummaryInventoryArgs = {
  input: ClinicalProductInventorySummaryInput;
};

export type ClinicalProductInventorySummaryInput = {
  readonly facilityId: Scalars['ID'];
  readonly locationId?: InputMaybe<Scalars['ID']>;
};

export type ClinicalProductRef = {
  readonly __typename?: 'ClinicalProductRef';
  readonly id: Scalars['String'];
  readonly type: ClinicalProductType;
};

export type ClinicalProductRefInput = {
  readonly id: Scalars['String'];
  readonly type: ClinicalProductType;
};

export enum ClinicalProductType {
  Amp = 'AMP',
  Vmp = 'VMP'
}

export type Codification = {
  readonly __typename?: 'Codification';
  /** Category entered by the clinician during the consultation */
  readonly category?: Maybe<Scalars['String']>;
  /** Free-text diagnosis entered by the clinician during the consultation */
  readonly name?: Maybe<Scalars['String']>;
};

export type CodificationInput = {
  readonly category: Scalars['String'];
  readonly name: Scalars['String'];
};

export enum Comparator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ'
}

export type Comparison = {
  readonly comparator: Comparator;
  readonly value: Scalars['Int'];
};

export type ComparisonDate = {
  readonly comparator: Comparator;
  readonly value: Scalars['Date'];
};

export type CompleteInvestigationInput = {
  readonly id: Scalars['ID'];
  readonly isInpatient?: InputMaybe<Scalars['Boolean']>;
  readonly outcome: Scalars['JSONObject'];
};

export type Condition = {
  readonly __typename?: 'Condition';
  /** @deprecated Legacy field */
  readonly code?: Maybe<Scalars['String']>;
  readonly codification?: Maybe<Codification>;
  readonly id: Scalars['ID'];
  /** @deprecated Legacy field */
  readonly note?: Maybe<Scalars['String']>;
  /** @deprecated Legacy field */
  readonly onsetDateTime?: Maybe<Scalars['Date']>;
  /** @deprecated Legacy field */
  readonly severity?: Maybe<Scalars['String']>;
  /** @deprecated duplicated field, use id instead */
  readonly uuid?: Maybe<Scalars['String']>;
};

export type ConnectOrganisationPriceListInput = {
  readonly priceListId: Scalars['ID'];
};

export type ConnectOrganisationPriceListResponse = {
  readonly __typename?: 'ConnectOrganisationPriceListResponse';
  readonly organisationPriceListId: Scalars['ID'];
};

export type Consent = {
  readonly __typename?: 'Consent';
  readonly accessToHealthRecords: Scalars['Boolean'];
  readonly elephantUseOfAnonData: Scalars['Boolean'];
  readonly healthcareComms: Scalars['Boolean'];
  readonly productMarketing: Scalars['Boolean'];
  /** Consent to have patient data to be shared between multiple organisations inside a federal territory */
  readonly territoryUseOfData: Scalars['Boolean'];
};

export type ConsentInput = {
  readonly accessToHealthRecords?: InputMaybe<Scalars['Boolean']>;
  readonly elephantUseOfAnonData?: InputMaybe<Scalars['Boolean']>;
  readonly healthcareComms?: InputMaybe<Scalars['Boolean']>;
  readonly productMarketing?: InputMaybe<Scalars['Boolean']>;
  /** Consent to have patient data to be shared between multiple organisations inside a federal territory */
  readonly territoryUseOfData?: InputMaybe<Scalars['Boolean']>;
};

export type Consultation = {
  readonly __typename?: 'Consultation';
  readonly _id?: Maybe<Scalars['ID']>;
  /** @deprecated Use facilityId */
  readonly clinic?: Maybe<Scalars['String']>;
  readonly clinician?: Maybe<Scalars['String']>;
  /** @deprecated Use meta.created */
  readonly created?: Maybe<Scalars['DateTime']>;
  readonly deliveredBy?: Maybe<User>;
  /** List of free-text diagnoses entered by the clinician during the consultation */
  readonly diagnoses: ReadonlyArray<Condition>;
  /** @deprecated Use diagnoses */
  readonly diagnosis?: Maybe<ReadonlyArray<Maybe<Condition>>>;
  readonly diseases?: Maybe<ReadonlyArray<Maybe<Disease>>>;
  readonly facility: Clinic;
  readonly facilityId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly location?: Maybe<Location>;
  readonly locationId?: Maybe<Scalars['String']>;
  readonly meta: ConsultationMeta;
  readonly organisation: Organisation;
  readonly organisationId: Scalars['String'];
  readonly patient?: Maybe<Scalars['String']>;
  readonly plan?: Maybe<Scalars['String']>;
  /** @deprecated Prescriptions are now managed by api-prescription service */
  readonly prescriptions?: Maybe<ReadonlyArray<Maybe<Prescription>>>;
  /** Patient's own description of their health problem */
  readonly presentingComplaint?: Maybe<Scalars['String']>;
  readonly problem?: Maybe<Scalars['String']>;
  readonly unit?: Maybe<Scalars['String']>;
  /** @deprecated Use meta.updated */
  readonly updated?: Maybe<Scalars['DateTime']>;
  readonly uuid?: Maybe<Scalars['String']>;
};

export type ConsultationMeta = {
  readonly __typename?: 'ConsultationMeta';
  readonly active: Scalars['Boolean'];
  readonly created: Scalars['DateTime'];
  readonly persistedAt: Scalars['DateTime'];
  readonly updated?: Maybe<Scalars['DateTime']>;
};

export type ConsultationSyncPushInput = {
  readonly backdatedTo?: InputMaybe<Scalars['DateTime']>;
  readonly diseaseIds: ReadonlyArray<Scalars['ID']>;
  readonly facilityId: Scalars['ID'];
  readonly freeTextDiagnoses: ReadonlyArray<FreeTextDiagnosisInput>;
  readonly id: Scalars['ID'];
  readonly isImmunisation?: InputMaybe<Scalars['Boolean']>;
  readonly isPerformedAtOtherClinic?: InputMaybe<Scalars['Boolean']>;
  readonly meta: SyncableMetaInput;
  readonly organisationId: Scalars['ID'];
  readonly patientId: Scalars['ID'];
  readonly plan?: InputMaybe<Scalars['String']>;
  readonly presentingComplaint?: InputMaybe<Scalars['String']>;
  readonly problem?: InputMaybe<Scalars['String']>;
  readonly symptomIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type ConsultationSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<ConsultationSyncPushInput>;
  readonly newDocumentState: ConsultationSyncPushInput;
};

export type ConsultationsExportInput = {
  readonly options: ConsultationsExportOptions;
  readonly params: ConsultationsExportParams;
};

export type ConsultationsExportOptions = {
  readonly clinicUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly organisationUuid: Scalars['ID'];
};

export type ConsultationsExportPage = {
  readonly __typename?: 'ConsultationsExportPage';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<Consultation>>;
  readonly total: Scalars['Int'];
};

export type ConsultationsExportParams = {
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
};

export type Contact = {
  readonly __typename?: 'Contact';
  readonly address?: Maybe<Address>;
  readonly contactPoints: ReadonlyArray<Maybe<ContactPoint>>;
  readonly name?: Maybe<Name>;
  readonly relationship: ContactRelationship;
};

export type ContactPoint = {
  readonly __typename?: 'ContactPoint';
  readonly ownership?: Maybe<ContactPointOwnership>;
  readonly system: ContactPointSystem;
  readonly value: Scalars['String'];
};

export enum ContactPointOwnership {
  Personal = 'personal',
  Shared = 'shared'
}

export enum ContactPointSystem {
  Email = 'email',
  Fax = 'fax',
  Other = 'other',
  Pager = 'pager',
  Phone = 'phone'
}

export enum ContactRelationship {
  N = 'N',
  S = 'S'
}

export type CreateAmpInput = {
  readonly keywords?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly vmpId: Scalars['String'];
};

export type CreateAncEncounterInput = {
  readonly ageOfPregnancy?: InputMaybe<Scalars['Int']>;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly dangerSigns?: InputMaybe<ReadonlyArray<AncDangerSign>>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']>;
  readonly earlyInitiationOfBreastfeeding?: InputMaybe<Scalars['Boolean']>;
  readonly exclusiveBreastfeeding?: InputMaybe<Scalars['Boolean']>;
  readonly femaleGenitalMutilation?: InputMaybe<Scalars['Boolean']>;
  readonly hepatitisBInvestigation?: InputMaybe<ReadonlyArray<InputMaybe<AncInvestigationOutcome>>>;
  readonly hepatitisCInvestigation?: InputMaybe<ReadonlyArray<InputMaybe<AncInvestigationOutcome>>>;
  readonly hivTesting?: InputMaybe<Scalars['Boolean']>;
  readonly lastMenstrualPeriod?: InputMaybe<Scalars['DateTime']>;
  readonly longLastingInsecticidalNet?: InputMaybe<Scalars['Boolean']>;
  readonly maternalNutrition?: InputMaybe<Scalars['Boolean']>;
  readonly parityDeliveries?: InputMaybe<Scalars['Int']>;
  readonly parityMiscarriages?: InputMaybe<Scalars['Int']>;
  readonly patientUuid: Scalars['ID'];
  readonly syphilisInvestigation?: InputMaybe<ReadonlyArray<InputMaybe<AncInvestigationOutcome>>>;
};

export type CreateCardResult = {
  readonly __typename?: 'CreateCardResult';
  readonly cardId: Scalars['String'];
  readonly cvv: Scalars['String'];
};

export type CreateClinicSettings = {
  readonly billingMode?: InputMaybe<BillingMode>;
  readonly inventoryManagement?: InputMaybe<Scalars['Boolean']>;
};

export type CreateConsultation = {
  readonly created?: InputMaybe<Scalars['DateTime']>;
  readonly diagnoses: ReadonlyArray<InputMaybe<DiagnosesInput>>;
  readonly diseaseIds: ReadonlyArray<InputMaybe<Scalars['ID']>>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly patientId: Scalars['ID'];
  readonly plan?: InputMaybe<Scalars['String']>;
  readonly prescriptions?: InputMaybe<ReadonlyArray<InputMaybe<PrescriptionInput>>>;
  readonly presentingComplaint?: InputMaybe<Scalars['String']>;
  readonly problem?: InputMaybe<Scalars['String']>;
};

export type CreateCustomItemsInput = {
  readonly language?: InputMaybe<PriceableItemLanguage>;
  readonly names: ReadonlyArray<Scalars['String']>;
  readonly priceListId: Scalars['ID'];
};

export type CreateCustomItemsResponse = {
  readonly __typename?: 'CreateCustomItemsResponse';
  readonly items: ReadonlyArray<PriceableItem>;
};

export type CreateDataExportRequestInput = {
  readonly facilityIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly organisationId: Scalars['String'];
};

export type CreateDepartmentInput = {
  readonly clinicId: Scalars['String'];
  readonly isInventoryLocation: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly orgId: Scalars['String'];
  readonly tag: StockLocationTag;
  readonly unit: Scalars['String'];
};

export type CreateEpocusConsentDocumentInput = {
  readonly items: ReadonlyArray<CreateEpocusConsentItemInput>;
  readonly version: Scalars['Int'];
};

export type CreateEpocusConsentItemInput = {
  readonly audience?: EpocusConsentAudience;
  readonly bodyText: Scalars['String'];
  readonly kind: EpocusConsentItemKind;
  readonly ordinal: Scalars['Int'];
};

export type CreateEpocusPrivacyPolicyInput = {
  readonly bodyText: Scalars['String'];
  readonly effectiveFrom: Scalars['DateTime'];
  readonly version: Scalars['Int'];
};

export type CreateEpocusProgramInput = {
  readonly elephantFacilityId?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
};

export type CreateInpatientVisitInput = {
  readonly departmentId?: InputMaybe<Scalars['ID']>;
  readonly diagnosisList?: InputMaybe<ReadonlyArray<InputMaybe<InpatientDiagnosis>>>;
  readonly locationId?: InputMaybe<Scalars['String']>;
  readonly notes?: InputMaybe<Scalars['String']>;
  readonly patientId: Scalars['ID'];
};

export type CreateInvestigationInput = {
  readonly catalogueItemId: Scalars['ID'];
  readonly clinicalEvent?: InputMaybe<ClinicalEventRefInput>;
  readonly isInpatient?: InputMaybe<Scalars['Boolean']>;
  readonly outcome?: InputMaybe<Scalars['JSONObject']>;
  readonly patientUuid: Scalars['ID'];
};

export type CreateInvoiceInput = {
  readonly patientUuid: Scalars['String'];
};

export type CreateLocationInput = {
  readonly active?: InputMaybe<Scalars['Boolean']>;
  readonly bedCount?: InputMaybe<Scalars['Int']>;
  readonly name: Scalars['String'];
};

export type CreateNonPharmaItemInput = {
  readonly brand?: InputMaybe<Scalars['String']>;
  readonly categoryId: Scalars['String'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly snomedId?: InputMaybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type CreateOutpatientPrescriptionsInput = {
  readonly prescriptions: ReadonlyArray<OutpatientPrescriptionInput>;
};

export type CreatePatientQueueInput = {
  readonly name: Scalars['String'];
};

export type CreatePatientTriageStatus = {
  readonly doNotExpire?: InputMaybe<Scalars['Boolean']>;
  readonly isInAQueue?: InputMaybe<Scalars['Boolean']>;
  readonly isInpatient?: InputMaybe<Scalars['Boolean']>;
  readonly patientUuid: Scalars['ID'];
  readonly triageStatus: TriageStatusType;
};

export type CreatePinResult = {
  readonly __typename?: 'CreatePinResult';
  readonly pin: Scalars['String'];
};

export type CreatePrescriptionInput = {
  readonly administrationTimes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly asRequired?: InputMaybe<Scalars['Boolean']>;
  readonly clinicalEventRef: ClinicalEventRefInput;
  readonly clinicalProductRef?: InputMaybe<ClinicalProductRefInput>;
  readonly dosage: DoseMeasurementInput;
  readonly facilityId: Scalars['String'];
  readonly isStat?: InputMaybe<Scalars['Boolean']>;
  readonly minimumDoseInterval?: InputMaybe<MinimumDoseIntervalInput>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly patientId: Scalars['String'];
  readonly rate?: InputMaybe<RateMeasurementInput>;
  readonly route: Route;
  readonly startsAtLocal: Scalars['String'];
  readonly stopsAtLocal: Scalars['String'];
};

export type CreatePrescriptionsInput = {
  readonly prescriptions: ReadonlyArray<CreatePrescriptionInput>;
};

export type CreatePriceListInput = {
  readonly facilityId?: InputMaybe<Scalars['ID']>;
};

export type CreatePriceListResponse = {
  readonly __typename?: 'CreatePriceListResponse';
  readonly priceListId: Scalars['ID'];
};

export type CreateSkuInput = {
  readonly externalReferences?: InputMaybe<ReadonlyArray<SkuExternalReferenceInput>>;
  /** @deprecated Use externalReferences */
  readonly foreignIdMappings?: InputMaybe<ReadonlyArray<SkuExternalReferenceInput>>;
  readonly measurement?: InputMaybe<SkuMeasurementInput>;
  readonly name: Scalars['String'];
};

export type CreateUserInput = {
  readonly clinic?: InputMaybe<Scalars['String']>;
  readonly createOnAuth0?: InputMaybe<Scalars['Boolean']>;
  readonly email: Scalars['String'];
  readonly emailVerified?: InputMaybe<Scalars['Boolean']>;
  readonly password?: InputMaybe<Scalars['String']>;
  readonly person?: InputMaybe<PersonInput>;
  readonly role_id: Scalars['String'];
};

export type CreateVisitInput = {
  readonly patientId: Scalars['ID'];
  readonly visitInsuranceDetails?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateVmpInput = {
  readonly categoryId?: InputMaybe<Scalars['String']>;
  readonly formulationId: Scalars['String'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly snomedId?: InputMaybe<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly vtmId: Scalars['String'];
};

export type CreateVtmInput = {
  readonly keywords?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly snomedId?: InputMaybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type CurrencyExchange = {
  readonly __typename?: 'CurrencyExchange';
  readonly exchangeRate: CurrencyExchangeRate;
  /**
   * Money converted from, in minor units. PAYMENT: the other currency handed over.
   * REFUND: the invoice currency refunded, equal to -amount.value.
   */
  readonly from: Amount;
  /**
   * Money converted to, in minor units. PAYMENT: the invoice currency credited, equal to
   * amount.value. REFUND: the other currency handed back.
   */
  readonly to: Amount;
};

export type CurrencyExchangeInput = {
  readonly exchangeRate: CurrencyExchangeRateInput;
  /**
   * Money converted from, in minor units. PAYMENT: the other currency handed over.
   * REFUND: the invoice currency refunded, equal to -amount.value.
   */
  readonly from: AmountInput;
  /**
   * Money converted to, in minor units. PAYMENT: the invoice currency credited, equal to
   * amount.value. REFUND: the other currency handed back.
   */
  readonly to: AmountInput;
};

/**
 * The rate applied: 1 baseCurrency = rate quoteCurrency. Base and quote follow FX quoting
 * (USD/LRD); they are not the invoice or home currency.
 */
export type CurrencyExchangeRate = {
  readonly __typename?: 'CurrencyExchangeRate';
  readonly baseCurrency: BillingCurrency;
  readonly effectiveDate: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly quoteCurrency: BillingCurrency;
  readonly rate: Scalars['String'];
};

/**
 * The rate applied: 1 baseCurrency = rate quoteCurrency. Base and quote follow FX quoting
 * (USD/LRD); they are not the invoice or home currency.
 */
export type CurrencyExchangeRateInput = {
  readonly baseCurrency: BillingCurrency;
  readonly effectiveDate: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly quoteCurrency: BillingCurrency;
  readonly rate: Scalars['String'];
};

export type CustomItem = {
  readonly __typename?: 'CustomItem';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type CustomItemsInput = {
  readonly priceListId: Scalars['ID'];
};

export type CustomItemsResponse = {
  readonly __typename?: 'CustomItemsResponse';
  readonly items: ReadonlyArray<CustomItem>;
};

export type DailyAdministrationScheduleSummary = {
  readonly __typename?: 'DailyAdministrationScheduleSummary';
  readonly administrationSchedulesForDay?: Maybe<ReadonlyArray<Maybe<AdministrationSchedule>>>;
  readonly count: Scalars['Int'];
  readonly date: Scalars['DateTime'];
  readonly status?: Maybe<AdministrationScheduleSummaryStatus>;
};

export type DataExportInpatientPrescriptionsConnection = {
  readonly __typename?: 'DataExportInpatientPrescriptionsConnection';
  readonly items: ReadonlyArray<DataExportInpatientPrescriptionsEdge>;
};

export type DataExportInpatientPrescriptionsEdge = {
  readonly __typename?: 'DataExportInpatientPrescriptionsEdge';
  readonly asRequired: Scalars['Boolean'];
  readonly cancelledAt?: Maybe<Scalars['DateTime']>;
  readonly cancelledById?: Maybe<Scalars['ID']>;
  readonly cancelledReason?: Maybe<Scalars['String']>;
  readonly clinicalEventId: Scalars['ID'];
  readonly clinicalEventType: Scalars['String'];
  readonly clinicalProductId?: Maybe<Scalars['ID']>;
  readonly clinicalProductType?: Maybe<ClinicalProductType>;
  readonly createdAt: Scalars['DateTime'];
  readonly dosageUnit: Scalars['String'];
  readonly dosageValue: Scalars['Float'];
  readonly facilityId: Scalars['ID'];
  readonly frequencyUnit: TimeUnit;
  readonly frequencyValue: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly isStat: Scalars['Boolean'];
  readonly minimumDoseIntervalUnit?: Maybe<TimeUnit>;
  readonly minimumDoseIntervalValue?: Maybe<Scalars['Int']>;
  readonly note?: Maybe<Scalars['String']>;
  readonly patientId: Scalars['ID'];
  readonly prescribedById: Scalars['ID'];
  readonly rateUnit?: Maybe<RateUnit>;
  readonly rateValue?: Maybe<Scalars['Int']>;
  readonly route?: Maybe<Route>;
  readonly startsAt: Scalars['DateTime'];
  readonly stopsAt: Scalars['DateTime'];
  readonly updatedAt: Scalars['DateTime'];
};

export type DataExportInpatientPrescriptionsInput = {
  readonly facilityIds: ReadonlyArray<Scalars['ID']>;
};

export type DataExportInpatientPrescriptionsOptions = {
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export type DataExportInpatientVisit = {
  readonly __typename?: 'DataExportInpatientVisit';
  readonly admissionDate: Scalars['DateTime'];
  readonly admissionDepartmentId?: Maybe<Scalars['ID']>;
  readonly admissionLocationId?: Maybe<Scalars['ID']>;
  readonly admissionNotes?: Maybe<Scalars['String']>;
  readonly admittedByUserId: Scalars['ID'];
  readonly admittedDiagnosisNames: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly clinicUuid: Scalars['ID'];
  readonly dischargeDate?: Maybe<Scalars['DateTime']>;
  readonly dischargeDepartmentId?: Maybe<Scalars['ID']>;
  readonly dischargeDiagnosisNames: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly dischargeLocationId?: Maybe<Scalars['ID']>;
  readonly dischargeNotes?: Maybe<Scalars['String']>;
  readonly dischargedByUserId?: Maybe<Scalars['ID']>;
  readonly patientUuid: Scalars['ID'];
  readonly uuid: Scalars['ID'];
};

export type DataExportInventoryConnection = {
  readonly __typename?: 'DataExportInventoryConnection';
  readonly items: ReadonlyArray<DataExportInventoryEdge>;
};

export type DataExportInventoryEdge = {
  readonly __typename?: 'DataExportInventoryEdge';
  readonly expiryDate: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly locationId?: Maybe<Scalars['ID']>;
  readonly quantity: Scalars['Int'];
  readonly skuName: Scalars['String'];
};

export type DataExportInventoryInput = {
  readonly facilityIds: ReadonlyArray<Scalars['ID']>;
};

export type DataExportInventoryOptions = {
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export type DataExportPricesConnection = {
  readonly __typename?: 'DataExportPricesConnection';
  readonly items: ReadonlyArray<DataExportPricesEdge>;
};

export type DataExportPricesEdge = {
  readonly __typename?: 'DataExportPricesEdge';
  readonly facilityId?: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly itemId: Scalars['ID'];
  readonly itemNames: ReadonlyArray<Scalars['String']>;
  readonly organisationId: Scalars['ID'];
  readonly revenueDepartmentId: Scalars['ID'];
  readonly revenueDepartmentName: Scalars['String'];
  readonly tariffId: Scalars['ID'];
  readonly tariffName: Scalars['String'];
  readonly value: Scalars['Int'];
};

export type DataExportPricesInput = {
  readonly facilityIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly organisationId: Scalars['ID'];
};

export type DataExportPricesOptions = {
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export type DataExportQueries = {
  readonly __typename?: 'DataExportQueries';
  readonly consultations: ConsultationsExportPage;
  readonly inpatientPrescriptions: DataExportInpatientPrescriptionsConnection;
  readonly inpatientVisits: InpatientVisitsExportPage;
  readonly inventory: DataExportInventoryConnection;
  readonly investigations: InvestigationsExportPage;
  readonly invoices: InvoicesExportPage;
  readonly patients: PatientsExportPage;
  readonly prices: DataExportPricesConnection;
  readonly testResults: TestResultsExportPage;
};


export type DataExportQueriesConsultationsArgs = {
  input: ConsultationsExportInput;
};


export type DataExportQueriesInpatientPrescriptionsArgs = {
  input: DataExportInpatientPrescriptionsInput;
  options?: InputMaybe<DataExportInpatientPrescriptionsOptions>;
};


export type DataExportQueriesInpatientVisitsArgs = {
  input: InpatientVisitsExportInput;
};


export type DataExportQueriesInventoryArgs = {
  input: DataExportInventoryInput;
  options?: InputMaybe<DataExportInventoryOptions>;
};


export type DataExportQueriesInvestigationsArgs = {
  input: InvestigationsExportInput;
};


export type DataExportQueriesInvoicesArgs = {
  input: InvoicesExportInput;
};


export type DataExportQueriesPatientsArgs = {
  input: PatientsExportInput;
};


export type DataExportQueriesPricesArgs = {
  input: DataExportPricesInput;
  options?: InputMaybe<DataExportPricesOptions>;
};


export type DataExportQueriesTestResultsArgs = {
  input: TestResultsExportInput;
};

export type DataExportRequest = {
  readonly __typename?: 'DataExportRequest';
  readonly actionedBy: User;
  readonly exportStatus: DataExportStatus;
  readonly facilities?: Maybe<ReadonlyArray<Maybe<Clinic>>>;
  readonly id: Scalars['ID'];
  readonly meta: Meta;
  readonly organisation: Organisation;
};

export type DataExportResult = {
  readonly __typename?: 'DataExportResult';
  readonly requestId: Scalars['ID'];
  readonly signedUrl: Scalars['String'];
  readonly urlExpiresAt: Scalars['DateTime'];
  readonly zipPassword: Scalars['String'];
};

export type DataExportResultInput = {
  readonly requestId: Scalars['String'];
};

export enum DataExportStatus {
  Complete = 'Complete',
  Error = 'Error',
  Expired = 'Expired',
  Processing = 'Processing'
}

export type DeactivateSkuInput = {
  readonly id: Scalars['ID'];
};

export enum DefaultScope {
  Clinic = 'CLINIC',
  Organisation = 'ORGANISATION',
  User = 'USER'
}

export type DeleteCareEventsInput = {
  readonly careEventIds: ReadonlyArray<Scalars['ID']>;
  readonly visitId: Scalars['ID'];
};

export type DeleteDepartmentInput = {
  readonly id: Scalars['String'];
};

export type DeleteDepartmentResult = {
  readonly __typename?: 'DeleteDepartmentResult';
  readonly _id?: Maybe<Scalars['String']>;
  readonly message: Scalars['String'];
  readonly success: Scalars['Boolean'];
};

export type DeleteInvoiceInput = {
  readonly _id: Scalars['String'];
};

export type DeletePatientQueueInput = {
  readonly _id: Scalars['String'];
};

export type Department = {
  readonly __typename?: 'Department';
  readonly _id: Scalars['String'];
  readonly clinic: Clinic;
  readonly color?: Maybe<DepartmentColor>;
  readonly name: Scalars['String'];
  readonly organisation: Organisation;
  readonly stock: Stock;
};

export enum DepartmentColor {
  Blue = 'BLUE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Turquoise = 'TURQUOISE',
  Yellow = 'YELLOW'
}

export type DepartmentDefinition = {
  readonly __typename?: 'DepartmentDefinition';
  readonly _id: Scalars['ID'];
  readonly color?: Maybe<DepartmentColor>;
  readonly formSchema?: Maybe<Scalars['JSONObject']>;
  readonly title?: Maybe<Scalars['String']>;
};

export type DepartmentFilter = {
  readonly clinicId: Scalars['String'];
  readonly orgId?: InputMaybe<Scalars['String']>;
};

export type DepartmentFormWithValuesSchema = {
  readonly __typename?: 'DepartmentFormWithValuesSchema';
  readonly departmentId: Scalars['ID'];
  readonly populatedFormSchema?: Maybe<OperationalFormWithValuesSchema>;
};

export enum Dependent {
  Child = 'CHILD',
  Dependentchild = 'DEPENDENTCHILD',
  Dependentspouse = 'DEPENDENTSPOUSE',
  Member = 'MEMBER',
  Spouse = 'SPOUSE'
}

export type DeviceSecret = {
  readonly __typename?: 'DeviceSecret';
  readonly id: Scalars['ID'];
  readonly lookupKey: Scalars['String'];
  readonly lookupKeyOrigin: LookupKeyOrigin;
  readonly meta: SyncableMeta;
  readonly purpose: DeviceSecretPurpose;
  readonly value: Scalars['String'];
};

export type DeviceSecretInput = {
  readonly lookupKey: Scalars['ID'];
  readonly lookupKeyOrigin: LookupKeyOrigin;
  readonly purpose: DeviceSecretPurpose;
};

export enum DeviceSecretPurpose {
  RxdbEncryption = 'RXDB_ENCRYPTION'
}

export type DiagnosesInput = {
  readonly codification: CodificationInput;
};

export type Diagnosis = {
  readonly __typename?: 'Diagnosis';
  readonly diseaseSnapshot?: Maybe<Scalars['JSONObject']>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly type?: Maybe<DiagnosisType>;
  readonly uuid?: Maybe<Scalars['String']>;
};

export type DiagnosisReceived = CareActivity & {
  readonly __typename?: 'DiagnosisReceived';
  readonly _id: Scalars['ID'];
  readonly careActivity?: Maybe<DiagnosisReceivedDetails>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly type: Scalars['String'];
};

export type DiagnosisReceivedDetails = {
  readonly __typename?: 'DiagnosisReceivedDetails';
  readonly consultationId?: Maybe<Scalars['ID']>;
  readonly name?: Maybe<Scalars['String']>;
};

export enum DiagnosisType {
  Disease = 'DISEASE',
  Freetext = 'FREETEXT'
}

export enum DischargeOutcome {
  Absconded = 'ABSCONDED',
  Death = 'DEATH',
  DischargedHome = 'DISCHARGED_HOME',
  Referral = 'REFERRAL',
  SelfDischarge = 'SELF_DISCHARGE'
}

export type DischargePatientInput = {
  readonly diagnosisList?: InputMaybe<ReadonlyArray<InputMaybe<InpatientDiagnosis>>>;
  readonly notes?: InputMaybe<Scalars['String']>;
  readonly outcome: DischargeOutcome;
  readonly patientId: Scalars['ID'];
  readonly visitId: Scalars['ID'];
};

export type DischargePatientResponse = {
  readonly __typename?: 'DischargePatientResponse';
  readonly visit?: Maybe<Visit>;
};

export type DisconnectOrganisationPriceListInput = {
  readonly priceListId: Scalars['ID'];
};

export type DisconnectOrganisationPriceListResponse = {
  readonly __typename?: 'DisconnectOrganisationPriceListResponse';
  readonly priceListId: Scalars['ID'];
};

export type Disease = {
  readonly __typename?: 'Disease';
  /** @deprecated Use externalCoding instead */
  readonly catalogueCoding?: Maybe<DiseaseCatalogueCoding>;
  readonly category?: Maybe<Scalars['String']>;
  readonly categoryDisplayName?: Maybe<Scalars['String']>;
  /** The main ICD code for the disease */
  readonly code?: Maybe<Scalars['String']>;
  /** The main ICD revision for the disease (ICD-10 or ICD-11) */
  readonly coding?: Maybe<Scalars['String']>;
  readonly displayName: Scalars['String'];
  readonly keywords?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly uuid: Scalars['String'];
};

export type DiseaseCatalogueCoding = {
  readonly __typename?: 'DiseaseCatalogueCoding';
  readonly icd10?: Maybe<DiseaseSpecificationReference>;
  readonly icd11?: Maybe<DiseaseSpecificationReference>;
};

export type DiseaseEntry = {
  readonly __typename?: 'DiseaseEntry';
  readonly date: Scalars['DateTime'];
  readonly diseaseCode: Scalars['String'];
  readonly diseaseId: Scalars['ID'];
  readonly isPerformedAtOtherClinic: Scalars['Boolean'];
};

export type DiseaseSpecificationReference = {
  readonly __typename?: 'DiseaseSpecificationReference';
  readonly code: Scalars['String'];
  readonly system?: Maybe<Scalars['String']>;
};

export type DiseasesPage = {
  readonly __typename?: 'DiseasesPage';
  readonly categoryItems: ReadonlyArray<Maybe<Category>>;
  readonly id: Scalars['ID'];
  readonly items: ReadonlyArray<Maybe<Disease>>;
  readonly listHash: Scalars['String'];
};

export enum DispensationStrategy {
  IssuedPaperPrescription = 'ISSUED_PAPER_PRESCRIPTION',
  ProvidedAlternativeClinicalProduct = 'PROVIDED_ALTERNATIVE_CLINICAL_PRODUCT',
  ProvidedIntendedClinicalProduct = 'PROVIDED_INTENDED_CLINICAL_PRODUCT'
}

export type DispensationSyncPushInput = {
  readonly dispensationStrategy: DispensationStrategy;
  readonly dispensedByUserId: Scalars['ID'];
  readonly facilityId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly locationId: Scalars['ID'];
  readonly meta: SyncableMetaInput;
  readonly prescriptionId: Scalars['ID'];
  readonly quantity?: InputMaybe<Scalars['Int']>;
  readonly skuId?: InputMaybe<Scalars['String']>;
};

export type DispensationSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<DispensationSyncPushInput>;
  readonly newDocumentState: DispensationSyncPushInput;
};

export type Dispense = {
  readonly __typename?: 'Dispense';
  readonly category?: Maybe<Scalars['String']>;
  /** @deprecated Legacy, use dispensedBy */
  readonly clinician?: Maybe<Scalars['String']>;
  /** @deprecated Legacy, use dispensedAtLocationId */
  readonly dispensedAtLocation?: Maybe<Location>;
  readonly dispensedAtLocationId?: Maybe<Scalars['String']>;
  readonly dispensedBy?: Maybe<User>;
  /** @deprecated Legacy, use dispensedBy */
  readonly dispenser?: Maybe<Scalars['String']>;
  /** @deprecated Legacy */
  readonly doses?: Maybe<Scalars['Float']>;
  /** @deprecated Legacy */
  readonly note?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Float']>;
  readonly status?: Maybe<DispenseStatus>;
  readonly substituteMedication?: Maybe<SubstituteMedication>;
  readonly validityPeriod?: Maybe<Scalars['DateTime']>;
  readonly whenHandedOver?: Maybe<Scalars['DateTime']>;
};

export type DispenseInpatientPrescriptionInput = {
  readonly alternativeDispensed?: InputMaybe<Scalars['Boolean']>;
  readonly facilityId: Scalars['String'];
  readonly locationId: Scalars['String'];
  readonly prescriptionId: Scalars['String'];
  readonly quantity: Scalars['Int'];
  readonly skuId: Scalars['String'];
};

export type DispenseInpatientPrescriptionsInput = {
  readonly dispensations: ReadonlyArray<DispenseInpatientPrescriptionInput>;
};

export type DispenseInpatientPrescriptionsResponse = {
  readonly __typename?: 'DispenseInpatientPrescriptionsResponse';
  readonly dispensations: ReadonlyArray<InpatientPrescriptionDispensation>;
};

export enum DispenseMethod {
  Alternative = 'ALTERNATIVE',
  Paper = 'PAPER',
  Prescribed = 'PRESCRIBED'
}

export type DispensePrescription = {
  readonly dispenseMethod: DispenseMethod;
  readonly locationId?: InputMaybe<Scalars['String']>;
  readonly prescriptionId: Scalars['String'];
  readonly quantity?: InputMaybe<Scalars['Int']>;
  readonly skuId?: InputMaybe<Scalars['String']>;
};

export enum DispenseStatus {
  Dispensed = 'dispensed',
  PaperPrescriptionIssued = 'paper_prescription_issued',
  ReadyToDispense = 'ready_to_dispense'
}

export type DispenseStockInput = {
  readonly externalReferences: ReadonlyArray<ExternalReference>;
  readonly facilityId: Scalars['String'];
  readonly locationId?: InputMaybe<Scalars['String']>;
  /**
   * When provided, dispense from this specific lot instead of the default FEFO
   * (first-expired-first-out) allocation. Used by flows that let the operator
   * override lot selection (e.g. non-pharma Ward Supplies, manual pharmacist override).
   * The lot must belong to the given skuId / facilityId / locationId and have
   * sufficient quantity, otherwise the mutation fails.
   */
  readonly lotId?: InputMaybe<Scalars['String']>;
  readonly quantity: Scalars['Int'];
  readonly skuId: Scalars['String'];
};

export type Dose = {
  readonly __typename?: 'Dose';
  readonly asNeeded?: Maybe<Scalars['Boolean']>;
  /** @deprecated Legacy field */
  readonly codification?: Maybe<Scalars['String']>;
  readonly doseQuantity?: Maybe<Quantity>;
  readonly durationQuantity?: Maybe<Quantity>;
  readonly rateQuantity?: Maybe<Quantity>;
};

export type DoseInput = {
  readonly asNeeded?: InputMaybe<Scalars['Boolean']>;
  readonly doseQuantity: QuantityInput;
  readonly durationQuantity: QuantityInput;
  readonly rateQuantity: QuantityInput;
};

export type DoseMeasurement = {
  readonly __typename?: 'DoseMeasurement';
  readonly unit: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type DoseMeasurementInput = {
  readonly unit: Scalars['String'];
  readonly value: Scalars['Float'];
};

export enum DownloadColumnFilterValues {
  Address = 'address',
  Age = 'age',
  Date = 'date',
  Diagnoses = 'diagnoses',
  InvestigationTests = 'investigationTests',
  Investigations = 'investigations',
  Name = 'name',
  Phone = 'phone',
  Prescriptions = 'prescriptions',
  Sex = 'sex',
  TestValues = 'testValues'
}

export type DownloadRegisterFilterOptions = {
  readonly endDate: Scalars['Date'];
  readonly startDate: Scalars['Date'];
};

export type DownloadRegisterFilters = {
  readonly __typename?: 'DownloadRegisterFilters';
  readonly endDate: Scalars['Date'];
  readonly startDate: Scalars['Date'];
};

export type DownloadRegisterInput = {
  readonly columnFilter: ReadonlyArray<DownloadColumnFilterValues>;
  readonly filterOptions: DownloadRegisterFilterOptions;
  /** @deprecated All queries are now using RegisterRecordDatasource */
  readonly useAggregation?: InputMaybe<Scalars['Boolean']>;
};

export type Education = {
  readonly __typename?: 'Education';
  readonly isStudent: Scalars['Boolean'];
  readonly nemisNumber?: Maybe<Scalars['String']>;
  readonly school?: Maybe<Scalars['String']>;
};

export type EducationInput = {
  readonly isStudent?: InputMaybe<Scalars['Boolean']>;
  readonly nemisNumber?: InputMaybe<Scalars['String']>;
  readonly school?: InputMaybe<Scalars['String']>;
};

export type ElephantActor = {
  readonly __typename?: 'ElephantActor';
  readonly _id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type ElephantActorInput = {
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type EpocusAuditEventSyncPushDocument = {
  readonly clientActionTime: Scalars['DateTime'];
  readonly entityId: Scalars['ID'];
  readonly entityType: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly userId: Scalars['ID'];
  readonly verb: Scalars['String'];
};

export type EpocusAuditEventSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<EpocusAuditEventSyncPushDocument>;
  readonly newDocumentState: EpocusAuditEventSyncPushDocument;
};

export type EpocusBillerExport = {
  readonly __typename?: 'EpocusBillerExport';
  /** Per program, counting from 1. */
  readonly batchNumber: Scalars['Int'];
  readonly builtAt?: Maybe<Scalars['DateTime']>;
  readonly chargeLineCount: Scalars['Int'];
  readonly createdAt: Scalars['DateTime'];
  readonly createdByUserId: Scalars['ID'];
  readonly dateFrom?: Maybe<Scalars['DateTime']>;
  readonly dateTo?: Maybe<Scalars['DateTime']>;
  readonly expiresAt?: Maybe<Scalars['DateTime']>;
  readonly failureReason?: Maybe<Scalars['String']>;
  readonly fileName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly programId: Scalars['ID'];
  readonly sizeBytes?: Maybe<Scalars['Int']>;
  readonly status: EpocusBillerExportStatus;
  readonly studyCount: Scalars['Int'];
};

export type EpocusBillerExportDownload = {
  readonly __typename?: 'EpocusBillerExportDownload';
  readonly export: EpocusBillerExport;
  /**
   * A signed link to the ZIP, minted for this request and valid for minutes.
   * Null while the export is building or being rebuilt after expiry.
   */
  readonly url?: Maybe<Scalars['String']>;
  readonly urlExpiresAt?: Maybe<Scalars['DateTime']>;
  /**
   * The ZIP's password, returned only with a link. The admin passes it to the
   * biller separately from the file.
   */
  readonly zipPassword?: Maybe<Scalars['String']>;
};

export type EpocusBillerExportScope = {
  readonly __typename?: 'EpocusBillerExportScope';
  readonly amendedCount: Scalars['Int'];
  /** Studies QA review holds back in the same range, listed at the foot of the export's summary. */
  readonly heldCount: Scalars['Int'];
  /** Incomplete studies in the same range, which an export leaves out. */
  readonly incompleteCount: Scalars['Int'];
  /** Ready-to-bill studies an export would carry now, amended ones included. */
  readonly readyCount: Scalars['Int'];
};

export enum EpocusBillerExportStatus {
  /** Built, and past retention. Downloading it again rebuilds it from what was exported. */
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Ready = 'READY'
}

export type EpocusBillingBatch = {
  readonly __typename?: 'EpocusBillingBatch';
  readonly compiledAt: Scalars['DateTime'];
  readonly deliveryMethod: EpocusBillingDeliveryMethod;
  readonly deliveryNote?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly isSupplementary: Scalars['Boolean'];
  readonly items: ReadonlyArray<EpocusBillingBatchItem>;
  readonly portalToken?: Maybe<Scalars['String']>;
  readonly programId: Scalars['ID'];
  readonly recipientEmail?: Maybe<Scalars['String']>;
  readonly recipientName: Scalars['String'];
  readonly sentAt?: Maybe<Scalars['DateTime']>;
  readonly sentById?: Maybe<Scalars['ID']>;
  readonly serviceDate: Scalars['DateTime'];
  readonly status: EpocusBillingBatchStatus;
  readonly studyCount: Scalars['Int'];
};

export type EpocusBillingBatchItem = {
  readonly __typename?: 'EpocusBillingBatchItem';
  readonly billingId: Scalars['ID'];
  readonly cptCode: Scalars['String'];
  readonly encounterId: Scalars['ID'];
  readonly examId: Scalars['ID'];
  readonly id: Scalars['ID'];
};

export enum EpocusBillingBatchStatus {
  Compiled = 'COMPILED',
  Failed = 'FAILED',
  Sent = 'SENT'
}

export enum EpocusBillingComplianceReason {
  NeedsArchivedImage = 'NEEDS_ARCHIVED_IMAGE',
  NeedsClinicalIndication = 'NEEDS_CLINICAL_INDICATION',
  NeedsConfirmedProcedureCode = 'NEEDS_CONFIRMED_PROCEDURE_CODE',
  NeedsPatientIdentifiers = 'NEEDS_PATIENT_IDENTIFIERS',
  NeedsSignedFindings = 'NEEDS_SIGNED_FINDINGS'
}

export type EpocusBillingDay = {
  readonly __typename?: 'EpocusBillingDay';
  /** Ready to bill, or already exported. */
  readonly billable: ReadonlyArray<EpocusBillingDayRow>;
  readonly deliveryMethod: EpocusBillingDeliveryMethod;
  readonly feeTotals: EpocusBillingFeeTotals;
  /** Draft or Incomplete. */
  readonly heldBack: ReadonlyArray<EpocusBillingDayRow>;
  readonly programId: Scalars['ID'];
  readonly recipientEmail?: Maybe<Scalars['String']>;
  /** Who a compiled batch would be addressed to, from the program's config. */
  readonly recipientName?: Maybe<Scalars['String']>;
  /**
   * Always empty: the daily batch was replaced by the biller export.
   * @deprecated The daily batch was replaced by the biller export.
   */
  readonly sentBatches: ReadonlyArray<EpocusBillingBatch>;
  readonly serviceDate: Scalars['DateTime'];
};

export type EpocusBillingDayRow = {
  readonly __typename?: 'EpocusBillingDayRow';
  readonly accessionNumber?: Maybe<Scalars['String']>;
  /** True while the study is Exported and unchanged since. */
  readonly alreadySent: Scalars['Boolean'];
  readonly amendedAfterExportAt?: Maybe<Scalars['DateTime']>;
  /** Null when no billing row has been authored for this exam yet. */
  readonly billingId?: Maybe<Scalars['ID']>;
  /** Null until the study's status has been computed. Non-billable studies are listed only while QA holds them. */
  readonly billingStatus?: Maybe<EpocusBillingState>;
  /** @deprecated Read billingStatus and missingItems. */
  readonly complianceReasons: ReadonlyArray<EpocusBillingComplianceReason>;
  /** The first confirmed CPT, which is what a batch line carries. */
  readonly cptCode?: Maybe<Scalars['String']>;
  readonly device?: Maybe<Scalars['String']>;
  readonly encounterId: Scalars['ID'];
  readonly examId: Scalars['ID'];
  readonly examLabel: Scalars['String'];
  readonly examType: Scalars['String'];
  /** Null for a draft, a non-billable study, or one with no charge lines. */
  readonly feeEstimate?: Maybe<EpocusStudyFeeEstimate>;
  /** Why QA review holds the study back from billing, if it does. */
  readonly holdReason?: Maybe<EpocusBillingHoldReason>;
  /** The identifiers actually on file, rendered for display. Two are required. */
  readonly identifiers: ReadonlyArray<Scalars['String']>;
  readonly missingItems: ReadonlyArray<EpocusBillingMissingItem>;
  readonly modifier?: Maybe<Scalars['String']>;
  readonly patientName?: Maybe<Scalars['String']>;
  readonly procedureCodes: ReadonlyArray<EpocusBillingProcedureCode>;
  readonly renderingProvider: EpocusRenderingProvider;
};

export enum EpocusBillingDeliveryMethod {
  EncryptedEmail = 'ENCRYPTED_EMAIL',
  Portal = 'PORTAL'
}

export enum EpocusBillingDocumentationStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  Reviewed = 'REVIEWED'
}

export type EpocusBillingFeeTotals = {
  readonly __typename?: 'EpocusBillingFeeTotals';
  /** Held-back studies with confirmed codes. Null when none could be estimated. */
  readonly incompleteCents?: Maybe<Scalars['Int']>;
  readonly needsProgramPostalCode: Scalars['Boolean'];
  /** Null when no billable study could be estimated, so it never reads as $0. */
  readonly readyToBillCents?: Maybe<Scalars['Int']>;
  readonly unestimatedLineCount: Scalars['Int'];
};

/** Why QA review holds a study from billing. Both leave it Non-billable. */
export enum EpocusBillingHoldReason {
  /** A major discrepancy. Lifts once the performing clinician amends or confirms the report. */
  MajorDiscrepancy = 'MAJOR_DISCREPANCY',
  /** The reviewer scored the images 1 or 2 stars. Lifts if the reviewer raises the score. */
  NonDiagnostic = 'NON_DIAGNOSTIC'
}

/**
 * What stops a study being ready to bill. Stable codes: reminders, the export
 * and the admin views read them.
 */
export enum EpocusBillingMissingItem {
  /** Signed without a ticked billing code and not marked Non-billable. */
  NoCodes = 'NO_CODES',
  NoDob = 'NO_DOB',
  /** No date of service on the billing record or the encounter. */
  NoDos = 'NO_DOS',
  NoMrn = 'NO_MRN',
  /** A guided procedure with no image marked needle-in-target. */
  NoNeedleImage = 'NO_NEEDLE_IMAGE',
  /** The rendering provider has no NPI on their profile. */
  NoNpi = 'NO_NPI',
  /** No patient name on the encounter. */
  PatientNotLinked = 'PATIENT_NOT_LINKED'
}

export enum EpocusBillingMode {
  Component = 'COMPONENT',
  Global = 'GLOBAL'
}

export enum EpocusBillingModifierOverride {
  Mod_26 = 'MOD_26',
  None = 'NONE'
}

export type EpocusBillingProcedureCode = {
  readonly __typename?: 'EpocusBillingProcedureCode';
  readonly cpt: Scalars['String'];
  readonly modifier?: Maybe<Scalars['String']>;
  /** -RT, -LT or -50, kept apart from modifier. */
  readonly sideModifier?: Maybe<Scalars['String']>;
  readonly units?: Maybe<Scalars['Int']>;
};

/**
 * The compliant report payload for one exam: what a billing recipient is given.
 * Not a syncable document — it is rendered per request, and its image URLs
 * expire.
 */
export type EpocusBillingReport = {
  readonly __typename?: 'EpocusBillingReport';
  readonly billingStatus?: Maybe<EpocusBillingState>;
  readonly clinicalIndication?: Maybe<Scalars['String']>;
  /** @deprecated Read billingStatus and missingItems. */
  readonly complianceReasons: ReadonlyArray<EpocusBillingComplianceReason>;
  readonly dateOfService?: Maybe<Scalars['DateTime']>;
  readonly device?: Maybe<Scalars['String']>;
  readonly encounterId: Scalars['ID'];
  readonly examId: Scalars['ID'];
  readonly examLabel: Scalars['String'];
  readonly findings?: Maybe<Scalars['String']>;
  readonly identifiers: ReadonlyArray<Scalars['String']>;
  readonly images: ReadonlyArray<EpocusBillingReportImage>;
  readonly interpretation?: Maybe<Scalars['String']>;
  readonly missingItems: ReadonlyArray<EpocusBillingMissingItem>;
  readonly patientName?: Maybe<Scalars['String']>;
  readonly procedures: ReadonlyArray<EpocusBillingReportProcedure>;
  readonly renderingProvider: EpocusRenderingProvider;
  readonly signature: EpocusBillingReportSignature;
};

export type EpocusBillingReportImage = {
  readonly __typename?: 'EpocusBillingReportImage';
  readonly imagingInstanceId: Scalars['ID'];
  /** Time-limited. Minted per request, so a stored report snapshot holds none. */
  readonly previewUrl?: Maybe<Scalars['String']>;
  readonly thumbnailUrl?: Maybe<Scalars['String']>;
};

export type EpocusBillingReportProcedure = {
  readonly __typename?: 'EpocusBillingReportProcedure';
  /** The PRD's wording for a code the clinician accepted rather than the engine suggesting it. */
  readonly clinicianConfirmed: Scalars['Boolean'];
  readonly cpt: Scalars['String'];
  readonly description?: Maybe<Scalars['String']>;
  readonly modifier?: Maybe<Scalars['String']>;
  /** -RT, -LT or -50, kept apart from modifier. */
  readonly sideModifier?: Maybe<Scalars['String']>;
  readonly units?: Maybe<Scalars['Int']>;
};

export type EpocusBillingReportSignature = {
  readonly __typename?: 'EpocusBillingReportSignature';
  /** Always true — every signature on a report is written to the audit trail. */
  readonly auditLogged: Scalars['Boolean'];
  readonly signedAt?: Maybe<Scalars['DateTime']>;
  readonly signedById?: Maybe<Scalars['ID']>;
  readonly signedByName?: Maybe<Scalars['String']>;
};

/**
 * Where a study stands for billing. Draft until signed; then Incomplete or
 * Ready to bill as its missing items are found and fixed; Exported once a
 * biller export carries it. Non-billable studies are excluded from billing.
 */
export enum EpocusBillingState {
  Draft = 'DRAFT',
  Exported = 'EXPORTED',
  Incomplete = 'INCOMPLETE',
  NonBillable = 'NON_BILLABLE',
  ReadyToBill = 'READY_TO_BILL'
}

export type EpocusBillingSyncPushDocument = {
  readonly billingMode?: InputMaybe<EpocusBillingMode>;
  readonly clinicalSetting?: InputMaybe<EpocusClinicalSetting>;
  readonly dateOfService?: InputMaybe<Scalars['DateTime']>;
  readonly diagnosisCodes: Scalars['JSON'];
  readonly documentationStatus?: InputMaybe<EpocusBillingDocumentationStatus>;
  readonly encounterId: Scalars['ID'];
  readonly examId?: InputMaybe<Scalars['String']>;
  readonly exportedAt?: InputMaybe<Scalars['DateTime']>;
  readonly facilityNpi?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly imagesStored: Scalars['Boolean'];
  readonly locked: Scalars['Boolean'];
  readonly meta: SyncableMetaInput;
  readonly patientDob?: InputMaybe<Scalars['DateTime']>;
  readonly patientMrn?: InputMaybe<Scalars['String']>;
  readonly payerName?: InputMaybe<Scalars['String']>;
  readonly performingPhysicianName?: InputMaybe<Scalars['String']>;
  readonly performingPhysicianNpi?: InputMaybe<Scalars['String']>;
  readonly policyNumber?: InputMaybe<Scalars['String']>;
  readonly procedureCodes: Scalars['JSON'];
  readonly programId?: InputMaybe<Scalars['ID']>;
  readonly renderingProviderUserId?: InputMaybe<Scalars['ID']>;
  readonly supervisingPhysicianNpi?: InputMaybe<Scalars['String']>;
};

export type EpocusBillingSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<EpocusBillingSyncPushDocument>;
  readonly newDocumentState: EpocusBillingSyncPushDocument;
};

/**
 * A vendor whose calling AE title is fixed in firmware, so it must appear in the
 * gate's allow-list and cannot be chosen on the device.
 */
export type EpocusCallingAeTitleRule = {
  readonly __typename?: 'EpocusCallingAeTitleRule';
  readonly callingAeTitle: Scalars['String'];
  readonly vendor: Scalars['String'];
};

export type EpocusChargeLineFee = {
  readonly __typename?: 'EpocusChargeLineFee';
  readonly cpt: Scalars['String'];
  readonly estimate: EpocusFeeEstimate;
  readonly modifier?: Maybe<Scalars['String']>;
  readonly sideModifier?: Maybe<Scalars['String']>;
  readonly units: Scalars['Int'];
};

export type EpocusClearedSeededDemoStudies = {
  readonly __typename?: 'EpocusClearedSeededDemoStudies';
  readonly clearedCount: Scalars['Int'];
  readonly programId: Scalars['ID'];
};

export enum EpocusClinicalSetting {
  Asc = 'ASC',
  Ed = 'ED',
  HospitalOutpatient = 'HOSPITAL_OUTPATIENT',
  Inpatient = 'INPATIENT',
  Office = 'OFFICE',
  Outpatient = 'OUTPATIENT'
}

export enum EpocusConsentAudience {
  Adult = 'ADULT',
  Guardian = 'GUARDIAN'
}

export type EpocusConsentItem = {
  readonly __typename?: 'EpocusConsentItem';
  readonly audience: EpocusConsentAudience;
  readonly bodyText: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly kind: EpocusConsentItemKind;
  readonly ordinal: Scalars['Int'];
};

export enum EpocusConsentItemKind {
  ElephantDataUse = 'ELEPHANT_DATA_USE',
  HealthcareContact = 'HEALTHCARE_CONTACT',
  MarketingContact = 'MARKETING_CONTACT',
  TermsOfRegistration = 'TERMS_OF_REGISTRATION',
  ThirdPartyAiSharing = 'THIRD_PARTY_AI_SHARING'
}

export enum EpocusConsentResponse {
  No = 'NO',
  NoParentPresent = 'NO_PARENT_PRESENT',
  Yes = 'YES'
}

export type EpocusCredentialingCounts = {
  readonly __typename?: 'EpocusCredentialingCounts';
  readonly credentialed: Scalars['Int'];
  readonly inProgress: Scalars['Int'];
  readonly provisional: Scalars['Int'];
};

export type EpocusCredentialingRow = {
  readonly __typename?: 'EpocusCredentialingRow';
  readonly name?: Maybe<Scalars['String']>;
  /** The performer's principal id, as carried by EpocusEncounter.performerId. */
  readonly performerId: Scalars['ID'];
  /** Mean image-quality score / 5 * 100 over the window. Null when unscored. */
  readonly qaAveragePct?: Maybe<Scalars['Float']>;
  /** PROVISIONAL for a performer with no credential row — unassessed, not cleared. */
  readonly status: EpocusPerformerCredentialStatus;
  /** Signed reviews on this performer's exams, over the rolling window. */
  readonly supervisedStudies: Scalars['Int'];
  readonly supervisorId?: Maybe<Scalars['ID']>;
  readonly supervisorName?: Maybe<Scalars['String']>;
  readonly unit?: Maybe<Scalars['String']>;
};

export type EpocusDevice = {
  readonly __typename?: 'EpocusDevice';
  /** Exam types this device's probes are a reasonable choice for. */
  readonly examTypes: ReadonlyArray<EpocusExamType>;
  readonly formFactor: EpocusDeviceFormFactor;
  /** Stable id; the first three match the device ids encounters already carry. */
  readonly id: Scalars['ID'];
  readonly model: Scalars['String'];
  readonly probeTypes: ReadonlyArray<EpocusProbeType>;
  readonly vendor: Scalars['String'];
};

export enum EpocusDeviceFormFactor {
  Cart = 'CART',
  Handheld = 'HANDHELD',
  Portable = 'PORTABLE'
}

export type EpocusDeviceSecret = {
  readonly __typename?: 'EpocusDeviceSecret';
  readonly id: Scalars['ID'];
  readonly purpose: EpocusDeviceSecretPurpose;
  /**
   * The plaintext password. Never logged, and never stored unencrypted — the
   * row holds it sealed with EPOCUS_DEVICE_SECRET_ENCRYPTION_KEY.
   */
  readonly value: Scalars['String'];
};

export enum EpocusDeviceSecretPurpose {
  RxdbEncryption = 'RXDB_ENCRYPTION'
}

export enum EpocusEncounterAuditAction {
  Assign = 'ASSIGN',
  Claim = 'CLAIM',
  Escalate = 'ESCALATE',
  Sign = 'SIGN',
  StatusChange = 'STATUS_CHANGE'
}

export type EpocusEncounterAuditEntry = {
  readonly __typename?: 'EpocusEncounterAuditEntry';
  readonly action: EpocusEncounterAuditAction;
  readonly actorId: Scalars['ID'];
  /** Null where no membership was resolved for the actor. */
  readonly actorRole?: Maybe<EpocusRole>;
  readonly encounterId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly newStatus?: Maybe<EpocusEncounterStatus>;
  readonly occurredAt: Scalars['DateTime'];
  /** Both null for every action but STATUS_CHANGE. */
  readonly previousStatus?: Maybe<EpocusEncounterStatus>;
  readonly reason?: Maybe<Scalars['String']>;
};

export enum EpocusEncounterStatus {
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  Imported = 'IMPORTED',
  Ordered = 'ORDERED',
  PendingReview = 'PENDING_REVIEW',
  Reviewed = 'REVIEWED'
}

export type EpocusEncounterSyncPushDocument = {
  readonly accessionNumber?: InputMaybe<Scalars['String']>;
  readonly assignedAt?: InputMaybe<Scalars['DateTime']>;
  /** Null means the encounter sits in the unassigned review pool. */
  readonly assignedReviewerId?: InputMaybe<Scalars['ID']>;
  readonly deviceName?: InputMaybe<Scalars['String']>;
  readonly deviceSerialNumber?: InputMaybe<Scalars['String']>;
  readonly dicomStudyId?: InputMaybe<Scalars['ID']>;
  readonly elephantPatientId?: InputMaybe<Scalars['ID']>;
  readonly encounterDate?: InputMaybe<Scalars['DateTime']>;
  readonly escalatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly escalationReason?: InputMaybe<Scalars['String']>;
  readonly examTypes?: InputMaybe<Scalars['JSON']>;
  readonly id: Scalars['ID'];
  readonly imageCount?: InputMaybe<Scalars['Int']>;
  readonly indication?: InputMaybe<Scalars['String']>;
  readonly location?: InputMaybe<Scalars['String']>;
  readonly matchTier?: InputMaybe<EpocusMatchTier>;
  readonly meta: SyncableMetaInput;
  readonly operatorName?: InputMaybe<Scalars['String']>;
  readonly patientDob?: InputMaybe<Scalars['DateTime']>;
  readonly patientGender?: InputMaybe<Scalars['String']>;
  readonly patientId?: InputMaybe<Scalars['ID']>;
  readonly patientMrn?: InputMaybe<Scalars['String']>;
  readonly patientName?: InputMaybe<Scalars['String']>;
  readonly performerId?: InputMaybe<Scalars['String']>;
  readonly programId?: InputMaybe<Scalars['ID']>;
  readonly requestNotes?: InputMaybe<Scalars['String']>;
  readonly requestPriority?: InputMaybe<EpocusRequestPriority>;
  readonly requestedAt?: InputMaybe<Scalars['DateTime']>;
  readonly requestedById?: InputMaybe<Scalars['ID']>;
  readonly requestedExamType?: InputMaybe<Scalars['String']>;
  readonly reviewOutcome?: InputMaybe<EpocusReviewOutcome>;
  readonly status: Scalars['String'];
  readonly submittedForReviewAt?: InputMaybe<Scalars['DateTime']>;
};

export type EpocusEncounterSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<EpocusEncounterSyncPushDocument>;
  readonly newDocumentState: EpocusEncounterSyncPushDocument;
};

export type EpocusExamSyncPushDocument = {
  /** Omitted by devices that predate it, which leaves the stored list alone. */
  readonly amendments?: InputMaybe<Scalars['JSON']>;
  readonly encounterId: Scalars['ID'];
  readonly examType: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly images: Scalars['JSON'];
  readonly meta: SyncableMetaInput;
  /** Omitted by devices that predate it, which leaves the stored value alone. */
  readonly nonBillable?: InputMaybe<Scalars['Boolean']>;
  readonly nonBillableReason?: InputMaybe<EpocusNonBillableReason>;
  readonly signedAt?: InputMaybe<Scalars['DateTime']>;
  readonly signedByUserId?: InputMaybe<Scalars['ID']>;
  readonly status: Scalars['String'];
  readonly worksheetSummary: Scalars['JSON'];
};

export type EpocusExamSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<EpocusExamSyncPushDocument>;
  readonly newDocumentState: EpocusExamSyncPushDocument;
};

/**
 * The exam types ePOCUS supports, one per worksheet a performer can fill in.
 * An enum rather than free strings so a program's enabled set and the worksheets
 * it unlocks cannot drift apart unnoticed.
 */
export enum EpocusExamType {
  Aorta = 'AORTA',
  Bladder = 'BLADDER',
  Cardiac = 'CARDIAC',
  Efast = 'EFAST',
  GuidedJointInjection = 'GUIDED_JOINT_INJECTION',
  GuidedNerveBlock = 'GUIDED_NERVE_BLOCK',
  GuidedTendonInjection = 'GUIDED_TENDON_INJECTION',
  Lung = 'LUNG',
  Msk = 'MSK',
  Pregnancy = 'PREGNANCY',
  Renal = 'RENAL',
  UsAorta = 'US_AORTA',
  UsAppendix = 'US_APPENDIX',
  UsBiliary = 'US_BILIARY',
  UsBiliaryRenal = 'US_BILIARY_RENAL',
  UsBladder = 'US_BLADDER',
  UsCardiac = 'US_CARDIAC',
  UsCardiacThoracic = 'US_CARDIAC_THORACIC',
  UsDvt = 'US_DVT',
  UsEfast = 'US_EFAST',
  UsObTransabdominal = 'US_OB_TRANSABDOMINAL',
  UsObTransvaginal = 'US_OB_TRANSVAGINAL',
  UsOcular = 'US_OCULAR',
  UsRenal = 'US_RENAL',
  UsRush = 'US_RUSH',
  UsSbo = 'US_SBO',
  UsSoftTissue = 'US_SOFT_TISSUE',
  UsTesticular = 'US_TESTICULAR',
  UsThoracic = 'US_THORACIC'
}

export type EpocusExamTypeInfo = {
  readonly __typename?: 'EpocusExamTypeInfo';
  readonly description: Scalars['String'];
  readonly label: Scalars['String'];
  /** The lowercase form EpocusExam.examType carries on the wire. */
  readonly slug: Scalars['String'];
  readonly type: EpocusExamType;
};

/**
 * An estimate, based on Medicare: the PFS rate for the program's locality,
 * times its payer-mix multiplier. Not what the biller will be paid.
 */
export type EpocusFeeEstimate = {
  readonly __typename?: 'EpocusFeeEstimate';
  /** Set when status is PRICED or NOT_SEPARATELY_PAYABLE. */
  readonly amountCents?: Maybe<Scalars['Int']>;
  /** The CMS RVU release the line was priced from, e.g. RVU26D. */
  readonly cmsRelease?: Maybe<Scalars['String']>;
  /** Carrier and locality, e.g. 13202-01. */
  readonly medicareLocality?: Maybe<Scalars['String']>;
  readonly noEstimateReason?: Maybe<EpocusNoFeeEstimateReason>;
  readonly status: EpocusFeeEstimateStatus;
};

export enum EpocusFeeEstimateStatus {
  /** The program has no postal code, so it has no Medicare locality to price at. */
  NeedsProgramPostalCode = 'NEEDS_PROGRAM_POSTAL_CODE',
  /** Priced at $0: the code's fee schedule status is not separately payable. */
  NotSeparatelyPayable = 'NOT_SEPARATELY_PAYABLE',
  NoEstimate = 'NO_ESTIMATE',
  Priced = 'PRICED'
}

export type EpocusGateConfiguration = {
  readonly __typename?: 'EpocusGateConfiguration';
  /**
   * False when BOTH lists are empty. Check this before creating a program:
   * false means the create will silently produce an unreachable one.
   */
  readonly canRouteNewPrograms: Scalars['Boolean'];
  /**
   * Gates createEpocusProgram provisions a DICOMWEB ingress route on, keyed on
   * the program's AE title.
   */
  readonly dicomwebGateIds: ReadonlyArray<Scalars['String']>;
  /** Gates createEpocusProgram provisions a DIMSE ingress route on. */
  readonly dimseGateIds: ReadonlyArray<Scalars['String']>;
};

export type EpocusIdentity = {
  readonly __typename?: 'EpocusIdentity';
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  /**
   * The value this service later receives as the caller id, so an Auth0 Action
   * must stamp exactly this into the claim or the caller resolves to no
   * memberships. In a combo deployment it is the ElephantOS user id; in a
   * standalone one there is no ElephantOS user, so it is EpocusUser.id.
   */
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  /**
   * Every active membership, one per program, unflattened.
   *
   * The deprecated role and programIds fields below answer the same question
   * lossily: they collapse memberships to a single maximum role and a bare id
   * list, so a PERFORMER in one program who is PROGRAM_ADMIN in another is
   * indistinguishable from a PROGRAM_ADMIN everywhere. That is the PNE-642
   * over-grant, and it is a property of the shape rather than of any caller
   * reading it.
   */
  readonly memberships: ReadonlyArray<EpocusIdentityMembership>;
  readonly platformRole?: Maybe<EpocusPlatformRole>;
  /** @deprecated Carries no per-program role (PNE-725). Use memberships. Removed at the PNE-572 cutover. */
  readonly programIds: ReadonlyArray<Scalars['ID']>;
  /**
   * Highest-precedence active membership role; null for a caller with none.
   * @deprecated Flattens memberships to one maximum role and borrows an ElephantOS role uuid (PNE-725). Use memberships. Removed at the PNE-572 cutover.
   */
  readonly role?: Maybe<EpocusIdentityRole>;
  readonly status: EpocusUserStatus;
};

export type EpocusIdentityMembership = {
  readonly __typename?: 'EpocusIdentityMembership';
  readonly programId: Scalars['ID'];
  /**
   * The EpocusRole itself, not an ElephantOS role uuid. This is the untethering
   * (PNE-725): the ePOCUS vocabulary travels as its own enum, so nothing on this
   * path has to consult the borrowed role table that the deprecated role field
   * below depends on.
   */
  readonly role: EpocusRole;
};

export type EpocusIdentityRole = {
  readonly __typename?: 'EpocusIdentityRole';
  /** The platform role uuid the webapp resolves a role name from. */
  readonly _id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export enum EpocusIngressChannel {
  Dicomweb = 'DICOMWEB',
  Dimse = 'DIMSE'
}

/**
 * One way a study can reach this program: the gate that observed it, and the
 * key that gate stamps. Neither carrier is authenticated — both are self-
 * asserted by the sender — so a route buys attribution, not a boundary.
 */
export type EpocusIngressRoute = {
  readonly __typename?: 'EpocusIngressRoute';
  readonly channel: EpocusIngressChannel;
  readonly gateId: Scalars['String'];
  readonly id: Scalars['ID'];
  /** For DIMSE, the called AE title. For DICOMweb, the URL slug. */
  readonly routeKey: Scalars['String'];
};

/**
 * An existing ElephantOS user, resolved by email so an admin can link them to a
 * program. Deliberately narrower than api-admin's own `User`: only what the
 * link form needs to identify a person and populate a new `EpocusUser`.
 */
export type EpocusLinkableElephantUser = {
  readonly __typename?: 'EpocusLinkableElephantUser';
  /**
   * The ElephantOS user id, which is what `addEpocusProgramMember` expects as
   * `elephantUserId` — the value that arrives as `user.id` on this person's
   * requests. Not an Auth0 subject.
   */
  readonly elephantUserId: Scalars['ID'];
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
};

export enum EpocusMachineCaller {
  /** The ePOCUS Auth0 Action, which resolves a subject to an ePOCUS identity at login. */
  IdentityLookup = 'IDENTITY_LOOKUP',
  /** The ePOCUS onboarding agent, which administers programs on behalf of a human admin. */
  OnboardingAgent = 'ONBOARDING_AGENT'
}

export enum EpocusMatchTier {
  AppCreated = 'APP_CREATED',
  ClaimedFromTriage = 'CLAIMED_FROM_TRIAGE',
  DeviceTimePerformer = 'DEVICE_TIME_PERFORMER',
  EncounterMatch = 'ENCOUNTER_MATCH',
  PatientDayPerformer = 'PATIENT_DAY_PERFORMER',
  ProbeOperatorMatch = 'PROBE_OPERATOR_MATCH',
  ProbeSerialMatch = 'PROBE_SERIAL_MATCH',
  StationAeMatch = 'STATION_AE_MATCH'
}

export type EpocusMedicareLocality = {
  readonly __typename?: 'EpocusMedicareLocality';
  readonly carrier: Scalars['String'];
  readonly locality: Scalars['String'];
  readonly name?: Maybe<Scalars['String']>;
  /**
   * The ZIP crosses localities. CMS prices it by ZIP+4; with five digits it
   * takes the locality CMS assigns the ZIP as a whole.
   */
  readonly spansLocalities: Scalars['Boolean'];
  readonly state?: Maybe<Scalars['String']>;
};

export enum EpocusMembershipStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED'
}

export enum EpocusNoFeeEstimateReason {
  /** The code is not in the committed, trimmed RVU file. */
  CodeNotInReference = 'CODE_NOT_IN_REFERENCE',
  /** The Medicare contractor prices the code case by case. */
  ContractorPriced = 'CONTRACTOR_PRICED',
  /** No committed CMS release was in effect on the date of service. */
  NoReferenceData = 'NO_REFERENCE_DATA',
  /** The program's postal code is not a US ZIP in the committed CMS ZIP file. */
  UnknownPostalCode = 'UNKNOWN_POSTAL_CODE',
  /** Only no modifier and -26 are priced. */
  UnsupportedModifier = 'UNSUPPORTED_MODIFIER'
}

export enum EpocusNonBillableReason {
  Educational = 'EDUCATIONAL',
  NotMedicallyIndicated = 'NOT_MEDICALLY_INDICATED'
}

export type EpocusOnboardingCaller = {
  readonly __typename?: 'EpocusOnboardingCaller';
  /** The value to carry as onBehalfOf on every subsequent machine token. */
  readonly elephantUserId: Scalars['ID'];
  readonly email: Scalars['String'];
  /**
   * Null when this person is not yet an EpocusUser. Machine writes on their
   * behalf are refused until they are.
   */
  readonly epocusUserId?: Maybe<Scalars['ID']>;
  /** Null only for a user who is not yet an EpocusUser and has no name on their ElephantOS record. */
  readonly firstName?: Maybe<Scalars['String']>;
  readonly lastName?: Maybe<Scalars['String']>;
  readonly platformRole?: Maybe<EpocusPlatformRole>;
  /** Programs this person holds an active membership of. */
  readonly programIds: ReadonlyArray<Scalars['ID']>;
};

export enum EpocusOpsAuditAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Execute = 'EXECUTE',
  Read = 'READ',
  Update = 'UPDATE'
}

export enum EpocusOpsAuditActorKind {
  /** A signed-in person, acting through the ePOCUS console. */
  Human = 'HUMAN',
  /** A machine credential — today, the onboarding agent. */
  Machine = 'MACHINE'
}

/**
 * One thing done to the ePOCUS administration surface, as the server recorded
 * it. Field names follow FHIR R4 AuditEvent.
 */
export type EpocusOpsAuditEvent = {
  readonly __typename?: 'EpocusOpsAuditEvent';
  readonly action: EpocusOpsAuditAction;
  /** The ElephantOS user id for a human, or the machine caller name for an agent. */
  readonly actorId: Scalars['ID'];
  readonly actorKind: EpocusOpsAuditActorKind;
  readonly detail: Scalars['JSON'];
  readonly entityId?: Maybe<Scalars['ID']>;
  readonly entityType?: Maybe<Scalars['String']>;
  /** Present only on a FAILURE row. */
  readonly failureReason?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly occurredAt: Scalars['DateTime'];
  /**
   * The human who authorised a machine caller's session. Null for a human actor,
   * who is already named by actorId.
   */
  readonly onBehalfOfId?: Maybe<Scalars['ID']>;
  /** The GraphQL field coordinate, e.g. Mutation.createEpocusProgram. */
  readonly operation: Scalars['String'];
  readonly outcome: EpocusOpsAuditOutcome;
  readonly programId?: Maybe<Scalars['ID']>;
  /** The onboarding conversation this action came from, when the caller sent one. */
  readonly sessionId?: Maybe<Scalars['ID']>;
};

export enum EpocusOpsAuditOutcome {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type EpocusPatientConsentSyncPushDocument = {
  readonly audience?: EpocusConsentAudience;
  readonly consentDocumentId: Scalars['ID'];
  readonly elephantPatientIdentityValue?: InputMaybe<Scalars['ID']>;
  readonly encounterId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly kind: EpocusConsentItemKind;
  readonly meta: SyncableMetaInput;
  readonly privacyPolicyId?: InputMaybe<Scalars['ID']>;
  readonly programId?: InputMaybe<Scalars['ID']>;
  readonly response: EpocusConsentResponse;
};

export type EpocusPatientConsentSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<EpocusPatientConsentSyncPushDocument>;
  readonly newDocumentState: EpocusPatientConsentSyncPushDocument;
};

export type EpocusPerformerCredential = {
  readonly __typename?: 'EpocusPerformerCredential';
  readonly id: Scalars['ID'];
  /** The performer's principal id, as carried by EpocusEncounter.performerId. */
  readonly performerId: Scalars['ID'];
  readonly programId: Scalars['ID'];
  readonly status: EpocusPerformerCredentialStatus;
  /** The supervising clinician's principal id. Null once no supervision is required. */
  readonly supervisorId?: Maybe<Scalars['ID']>;
  /** Free-text unit or site label. A real site model is PNE-695. */
  readonly unit?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
};

export enum EpocusPerformerCredentialStatus {
  /** Assessed and cleared to scan unsupervised. */
  Credentialed = 'CREDENTIALED',
  /** Working towards credentialing — supervised, and being counted. */
  InProgress = 'IN_PROGRESS',
  /** May scan under supervision; nothing has been assessed yet. The default. */
  Provisional = 'PROVISIONAL'
}

/** A person behind an id stamped on a record, for display. */
export type EpocusPerson = {
  readonly __typename?: 'EpocusPerson';
  readonly displayName: Scalars['String'];
  /**
   * The id as it appears on the record — the value the caller's token carries,
   * which is the ElephantOS user id in a combo deployment and EpocusUser.id in
   * a standalone one. Echoed back so a caller can match a result to the id it
   * asked about without knowing which topology it is running in.
   */
  readonly userId: Scalars['ID'];
};

/**
 * Product-wide ePOCUS roles, held on the user rather than on a program
 * membership (PNE-600). Distinct from EpocusRole: a caller may hold one, the
 * other, both or neither.
 */
export enum EpocusPlatformRole {
  EpocusAdmin = 'EPOCUS_ADMIN'
}

export type EpocusPrivacyPolicy = {
  readonly __typename?: 'EpocusPrivacyPolicy';
  readonly bodyText: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly createdByUserId: Scalars['ID'];
  readonly effectiveFrom: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly version: Scalars['Int'];
};

export type EpocusProbeAssociationSyncPushDocument = {
  readonly deviceAeTitle?: InputMaybe<Scalars['String']>;
  readonly deviceSerialNumber: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly meta: SyncableMetaInput;
  readonly performerId: Scalars['ID'];
  readonly performerName: Scalars['String'];
  readonly programId?: InputMaybe<Scalars['ID']>;
};

export type EpocusProbeAssociationSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<EpocusProbeAssociationSyncPushDocument>;
  readonly newDocumentState: EpocusProbeAssociationSyncPushDocument;
};

export enum EpocusProbeType {
  Curved = 'CURVED',
  Linear = 'LINEAR',
  Phased = 'PHASED'
}

export type EpocusProgram = {
  readonly __typename?: 'EpocusProgram';
  readonly config?: Maybe<EpocusProgramConfig>;
  readonly createdAt: Scalars['DateTime'];
  readonly dimseAeTitle?: Maybe<Scalars['String']>;
  readonly elephantFacilityId?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  /**
   * PNE-663: the routes this program can actually receive scans on, one per
   * gate configured when it was created. **An empty list means no device can
   * ever reach it** — the create ran with EPOCUS_DIMSE_GATE_IDS unset and wrote
   * no routes, which it does without erroring. Read this on the result of
   * createEpocusProgram rather than assuming a returned program is reachable.
   */
  readonly ingressRoutes: ReadonlyArray<EpocusIngressRoute>;
  readonly name: Scalars['String'];
  readonly status: EpocusProgramStatus;
  readonly updatedAt: Scalars['DateTime'];
};

export type EpocusProgramAuditTrail = {
  readonly __typename?: 'EpocusProgramAuditTrail';
  /**
   * False when EPOCUS_OPS_AUDIT_ENABLED is off in this environment. Distinguishes
   * 'nothing has happened to this program' from 'nothing is being recorded'.
   */
  readonly enabled: Scalars['Boolean'];
  readonly events: ReadonlyArray<EpocusOpsAuditEvent>;
};

export enum EpocusProgramClinicalSetting {
  Asc = 'ASC',
  Ed = 'ED',
  HospitalOutpatient = 'HOSPITAL_OUTPATIENT',
  Office = 'OFFICE'
}

export type EpocusProgramConfig = {
  readonly __typename?: 'EpocusProgramConfig';
  readonly billingDeliveryMethod: EpocusBillingDeliveryMethod;
  /**
   * The local HH:mm a program treats as end of day. Display only — nothing
   * schedules against it.
   */
  readonly billingEndOfDayTime?: Maybe<Scalars['String']>;
  /** Null follows clinicalSetting. */
  readonly billingModifierOverride?: Maybe<EpocusBillingModifierOverride>;
  readonly billingRecipientEmail?: Maybe<Scalars['String']>;
  /** Who the end-of-day billing batch is addressed to. Null when unconfigured. */
  readonly billingRecipientName?: Maybe<Scalars['String']>;
  readonly clinicalSetting: EpocusProgramClinicalSetting;
  /**
   * Supervised scans before a performer is credentialed; the supervisedScans
   * entry of credentialingThresholds. Null when unset.
   */
  readonly credentialingThreshold?: Maybe<Scalars['Int']>;
  readonly credentialingThresholds: Scalars['JSON'];
  /**
   * The device catalogue ids a performer may pick in this program. Empty means
   * unconfigured, which enables all of them.
   */
  readonly enabledDeviceIds: ReadonlyArray<Scalars['String']>;
  /**
   * The exam types a performer may pick in this program. Empty means
   * unconfigured, which enables every type in its worksheetSet.
   */
  readonly enabledExamTypes: ReadonlyArray<EpocusExamType>;
  readonly id: Scalars['ID'];
  /**
   * The Medicare locality the postal code prices at, from the committed CMS
   * ZIP file. Null unless postalCode is a US ZIP (or ZIP+4) in that file.
   */
  readonly medicareLocality?: Maybe<EpocusMedicareLocality>;
  /** Territory-agnostic, e.g. a US ZIP code. Stored trimmed and upper-cased. */
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly qaSamplingRatePercent?: Maybe<Scalars['Int']>;
  /** Local HH:mm the daily incomplete-studies email goes out. */
  readonly reminderEmailTime: Scalars['String'];
  /** IANA time zone the reminder email's send time is read in. */
  readonly timezone: Scalars['String'];
  /** Minutes to sign-off treated as on time. Null is unconfigured; display 30. */
  readonly turnaroundTargetMinutes?: Maybe<Scalars['Int']>;
  /**
   * The family of worksheets this program's performers choose new exams from.
   * Existing exams keep their own type whatever this says.
   */
  readonly worksheetSet: EpocusWorksheetSet;
};

export type EpocusProgramCredentialing = {
  readonly __typename?: 'EpocusProgramCredentialing';
  readonly counts: EpocusCredentialingCounts;
  readonly programId: Scalars['ID'];
  /** Program-wide QA average over the rolling window. */
  readonly programQaAveragePct?: Maybe<Scalars['Float']>;
  readonly qaAverageWindowDays: Scalars['Int'];
  readonly rows: ReadonlyArray<EpocusCredentialingRow>;
};

export type EpocusProgramDashboard = {
  readonly __typename?: 'EpocusProgramDashboard';
  /** Share of reviews signed this period that met target. */
  readonly completedWithinTargetPct?: Maybe<Scalars['Float']>;
  readonly integrity: EpocusProgramIntegrity;
  /** Pending reviews already past target, live and not range-scoped. */
  readonly openPastTargetCount: Scalars['Int'];
  readonly priorRange: EpocusStatsRange;
  readonly programId: Scalars['ID'];
  readonly qaReviewedCount: Scalars['Int'];
  /** Share of this period's scans that have a signed review. Null when there were none. */
  readonly qaReviewedPct?: Maybe<Scalars['Float']>;
  readonly range: EpocusStatsRange;
  readonly scans: EpocusStatsDelta;
  /** By reviewer, not by site — the locked product decision of 2026-09-18. */
  readonly turnaroundByReviewer: ReadonlyArray<EpocusReviewerTurnaround>;
  /**
   * The program's configured target. Null means unconfigured: no metric here
   * substitutes a default for it, so every within-target figure is null too.
   * Display a placeholder against a null; do not compute against one.
   */
  readonly turnaroundTargetMinutes?: Maybe<Scalars['Int']>;
  readonly weekly: ReadonlyArray<EpocusProgramWeekPoint>;
};

export type EpocusProgramIngress = {
  readonly __typename?: 'EpocusProgramIngress';
  /**
   * Null for a program created before AE titles were derived. Nothing can be
   * addressed at such a program and a title cannot be added afterwards, so every
   * channel reports disabled.
   */
  readonly aeTitle?: Maybe<Scalars['String']>;
  /**
   * One entry per channel this deployment knows about, enabled or not — never a
   * filtered list, so an admin whose device never appears can be told why.
   */
  readonly endpoints: ReadonlyArray<EpocusProgramIngressEndpoint>;
  readonly programId: Scalars['ID'];
};

export enum EpocusProgramIngressChannel {
  Dicomweb = 'DICOMWEB',
  Dimse = 'DIMSE',
  /**
   * Modality worklist — a probe asking what it is scheduled to scan, not a way a
   * study arrives. Deliberately not an EpocusIngressChannel, which enumerates
   * the ways one does and is the channel on a stored route.
   */
  Mwl = 'MWL'
}

/**
 * One ingest channel, as a device must be configured to use it. Fields not
 * meaningful for the channel are null: DICOMweb carries a URL, DIMSE and MWL a
 * host and port.
 */
export type EpocusProgramIngressEndpoint = {
  readonly __typename?: 'EpocusProgramIngressEndpoint';
  /** DIMSE: the AE title to address, which is the program's own. */
  readonly calledAeTitle?: Maybe<Scalars['String']>;
  /**
   * A fixed AE title the device must present as its own, where a channel has
   * one. Null on the worklist: a device identifies itself there by the AE title
   * its performer registered under Settings → Probes, set on the device as its
   * own AE title and as its scheduled station AE title.
   */
  readonly callingAeTitle?: Maybe<Scalars['String']>;
  readonly callingAeTitleRules: ReadonlyArray<EpocusCallingAeTitleRule>;
  readonly channel: EpocusProgramIngressChannel;
  /**
   * Which of those is missing, phrased for a program admin to act on. Null when
   * enabled. Worth showing: every variant is invisible from the device, which
   * simply never appears.
   */
  readonly disabledReason?: Maybe<Scalars['String']>;
  /**
   * True only when this deployment advertises an endpoint for the channel AND
   * this program can be reached over it. Offer a device setup section for
   * exactly the enabled channels — the rest cannot be made to work by typing
   * these values into a probe.
   */
  readonly enabled: Scalars['Boolean'];
  /** Devices we have run through this channel, to help an admin recognise theirs. */
  readonly examples: ReadonlyArray<Scalars['String']>;
  /** DICOMWEB: the full STOW-RS URL to post studies to. */
  readonly exportUrl?: Maybe<Scalars['String']>;
  /** DIMSE, MWL: hostname to associate with. */
  readonly host?: Maybe<Scalars['String']>;
  /** DIMSE, MWL: port to associate on. */
  readonly port?: Maybe<Scalars['Int']>;
  /**
   * DICOMWEB: Basic-auth username for that URL. The password is never served
   * here and is handed over out of band.
   */
  readonly username?: Maybe<Scalars['String']>;
};

export type EpocusProgramIntegrity = {
  readonly __typename?: 'EpocusProgramIntegrity';
  /** Real scans in range that someone has documented — anything past IMPORTED. */
  readonly documented: Scalars['Int'];
  /**
   * Escalations still standing, program-wide and not range-scoped.
   * @deprecated Almost always zero: signing the last review completes the study. Read flaggedByReviewers.
   */
  readonly escalationsOpen: Scalars['Int'];
  /**
   * Reviews signed this period as a false negative or false positive, or as a
   * major discrepancy before interpretation existed. Counted per review on real
   * scans, whatever the study's status.
   */
  readonly flaggedByReviewers: Scalars['Int'];
  /** Real scans in range with no elephantPatientId — never linked to a patient. */
  readonly noPatientLink: Scalars['Int'];
  /** Phantom / test scans in range. The one metric that counts them. */
  readonly testScans: Scalars['Int'];
};

export type EpocusProgramMembership = {
  readonly __typename?: 'EpocusProgramMembership';
  readonly createdAt: Scalars['DateTime'];
  readonly epocusUserId: Scalars['ID'];
  /**
   * True on a provisionEpocusProgramMember response when the email already had
   * an ePOCUS login, so only the membership was added and no invite was sent.
   * False everywhere else.
   */
  readonly existingUser: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly programId: Scalars['ID'];
  readonly role: EpocusRole;
  readonly status: EpocusMembershipStatus;
  readonly updatedAt: Scalars['DateTime'];
  readonly user: EpocusUser;
};

export type EpocusProgramQaWorkload = {
  readonly __typename?: 'EpocusProgramQaWorkload';
  /** Window a reviewer must have signed something in to count as active. */
  readonly activeReviewerWindowDays: Scalars['Int'];
  /** Reviewers holding an open assignment, or who signed within the active window. */
  readonly activeReviewers: Scalars['Int'];
  readonly byReviewer: ReadonlyArray<EpocusQaWorkloadReviewer>;
  readonly overdue: Scalars['Int'];
  /** Every encounter awaiting review, assigned or not, at any age. */
  readonly pending: Scalars['Int'];
  readonly programId: Scalars['ID'];
  /** Null means unconfigured. Nothing substitutes a default; overdue is then 0. */
  readonly turnaroundTargetMinutes?: Maybe<Scalars['Int']>;
  /** Window the per-reviewer turnaround figures are computed over. */
  readonly turnaroundWindowDays: Scalars['Int'];
  /** Pending encounters nobody is assigned to — the shared pool. */
  readonly unassignedInPool: Scalars['Int'];
};

export type EpocusProgramScopeBackfillResult = {
  readonly __typename?: 'EpocusProgramScopeBackfillResult';
  readonly encountersUpdated: Scalars['Int'];
  readonly probeAssociationsUpdated: Scalars['Int'];
  readonly programId: Scalars['ID'];
};

export enum EpocusProgramStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED'
}

export type EpocusProgramWeekPoint = {
  readonly __typename?: 'EpocusProgramWeekPoint';
  readonly reviewed: Scalars['Int'];
  readonly scans: Scalars['Int'];
  /** Monday 00:00 UTC. Every week the range touches is present, quiet ones as zeros. */
  readonly weekStart: Scalars['DateTime'];
};

export type EpocusProgramWorklistEntry = {
  readonly __typename?: 'EpocusProgramWorklistEntry';
  readonly accessionNumber: Scalars['String'];
  readonly encounterId: Scalars['ID'];
  readonly indication?: Maybe<Scalars['String']>;
  readonly isTestScan: Scalars['Boolean'];
  readonly patientMrn?: Maybe<Scalars['String']>;
  readonly patientName?: Maybe<Scalars['String']>;
  /** Null means the order sits in the pool for any performer in the program. */
  readonly performerId?: Maybe<Scalars['ID']>;
  readonly requestNotes?: Maybe<Scalars['String']>;
  readonly requestPriority?: Maybe<EpocusRequestPriority>;
  readonly requestedAt?: Maybe<Scalars['DateTime']>;
  readonly requestedById?: Maybe<Scalars['ID']>;
  readonly requestedExamType?: Maybe<Scalars['String']>;
  readonly scheduledStart?: Maybe<Scalars['DateTime']>;
  readonly scheduledStationAeTitle?: Maybe<Scalars['String']>;
};

export type EpocusQaWorkloadReviewer = {
  readonly __typename?: 'EpocusQaWorkloadReviewer';
  readonly medianTurnaroundMinutes?: Maybe<Scalars['Float']>;
  readonly name?: Maybe<Scalars['String']>;
  /** Encounters currently assigned to them and still pending. */
  readonly open: Scalars['Int'];
  /** Of those, already past target. Zero when the program has no target. */
  readonly overdue: Scalars['Int'];
  readonly reviewerId: Scalars['ID'];
  readonly withinTargetPct?: Maybe<Scalars['Float']>;
};

export type EpocusRenderingProvider = {
  readonly __typename?: 'EpocusRenderingProvider';
  readonly name?: Maybe<Scalars['String']>;
  readonly npi?: Maybe<Scalars['String']>;
};

/** PNE-756 — how soon a requested scan is wanted. */
export enum EpocusRequestPriority {
  Routine = 'ROUTINE',
  Urgent = 'URGENT'
}

export enum EpocusReviewAgreement {
  Agree = 'AGREE',
  MajorDiscrepancy = 'MAJOR_DISCREPANCY',
  MinorDiscrepancy = 'MINOR_DISCREPANCY'
}

export enum EpocusReviewInterpretation {
  FalseNegative = 'FALSE_NEGATIVE',
  FalsePositive = 'FALSE_POSITIVE',
  Indeterminate = 'INDETERMINATE',
  TrueNegative = 'TRUE_NEGATIVE',
  TruePositive = 'TRUE_POSITIVE'
}

/** RETURNED is reserved for the send-back flow and is written by nothing today. */
export enum EpocusReviewOutcome {
  Escalated = 'ESCALATED',
  Returned = 'RETURNED',
  Signed = 'SIGNED'
}

export type EpocusReviewSyncPushDocument = {
  /** @deprecated Derived by the server from interpretation or agreement. Still accepted from older devices. */
  readonly agree?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Send interpretation (PNE-838). Still accepted from devices on the previous release. */
  readonly agreement?: InputMaybe<EpocusReviewAgreement>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly examId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly imageQualityScore?: InputMaybe<Scalars['Int']>;
  /** A review carries interpretation, or agreement from a device on the previous release. */
  readonly interpretation?: InputMaybe<EpocusReviewInterpretation>;
  readonly meta: SyncableMetaInput;
  readonly qualityScore?: InputMaybe<Scalars['Float']>;
  /**
   * Replayed by the client; the server authors the stored value from the
   * authenticated caller either way. Nullable so a client built before this
   * field existed keeps pushing.
   */
  readonly reviewerId?: InputMaybe<Scalars['ID']>;
  /** Set when the reviewer signs. The review is then locked. */
  readonly signedAt?: InputMaybe<Scalars['DateTime']>;
  readonly tags: ReadonlyArray<Scalars['String']>;
};

export type EpocusReviewSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<EpocusReviewSyncPushDocument>;
  readonly newDocumentState: EpocusReviewSyncPushDocument;
};

export type EpocusReviewerTurnaround = {
  readonly __typename?: 'EpocusReviewerTurnaround';
  /** Null when none of their reviews in this window can be timed. */
  readonly medianMinutes?: Maybe<Scalars['Float']>;
  /** Null when no EpocusUser matches the principal — never a fabricated name. */
  readonly name?: Maybe<Scalars['String']>;
  /** The reviewer's principal id, as carried by EpocusReview.reviewerId. */
  readonly reviewerId: Scalars['ID'];
  /** Null when the program has no turnaround target, or nothing is decidable. */
  readonly withinTargetPct?: Maybe<Scalars['Float']>;
};

export enum EpocusRole {
  Performer = 'PERFORMER',
  PerformerReviewer = 'PERFORMER_REVIEWER',
  ProgramAdmin = 'PROGRAM_ADMIN',
  QaAdmin = 'QA_ADMIN',
  Reviewer = 'REVIEWER'
}

export enum EpocusSeedKind {
  Both = 'BOTH',
  Cines = 'CINES',
  Stills = 'STILLS'
}

export type EpocusSeedLibraryAttribution = {
  readonly __typename?: 'EpocusSeedLibraryAttribution';
  readonly dataset: Scalars['String'];
  readonly licence: Scalars['String'];
  readonly title: Scalars['String'];
  readonly url?: Maybe<Scalars['String']>;
};

export type EpocusSeedLibraryExamTypeCount = {
  readonly __typename?: 'EpocusSeedLibraryExamTypeCount';
  readonly cines: Scalars['Int'];
  readonly examType: EpocusExamType;
  readonly stills: Scalars['Int'];
};

export type EpocusSeedLibrarySummary = {
  readonly __typename?: 'EpocusSeedLibrarySummary';
  readonly attribution: ReadonlyArray<EpocusSeedLibraryAttribution>;
  readonly available: Scalars['Boolean'];
  readonly byExamType: ReadonlyArray<EpocusSeedLibraryExamTypeCount>;
  readonly version?: Maybe<Scalars['String']>;
};

export enum EpocusSeedSource {
  /** The curated seed library, matched to exam types. */
  Library = 'LIBRARY',
  /** The program's own imaged studies, cloned. */
  Program = 'PROGRAM'
}

export type EpocusSeedableStudy = {
  readonly __typename?: 'EpocusSeedableStudy';
  /** Instances that are multi-frame and have finished transcoding. */
  readonly cineCount: Scalars['Int'];
  readonly dicomStudyId: Scalars['ID'];
  /** Instances holding a stored preview, so an image renders for each. */
  readonly imageCount: Scalars['Int'];
};

export type EpocusSeededDemoStudy = {
  readonly __typename?: 'EpocusSeededDemoStudy';
  readonly cineCount: Scalars['Int'];
  readonly dicomStudyId: Scalars['ID'];
  readonly encounterId: Scalars['ID'];
  /** Null when the study was cloned from the program rather than drawn from the library. */
  readonly examType?: Maybe<EpocusExamType>;
  readonly imageCount: Scalars['Int'];
};

export type EpocusSeededWorklistResult = {
  readonly __typename?: 'EpocusSeededWorklistResult';
  readonly cancelledCount: Scalars['Int'];
  readonly entries: ReadonlyArray<EpocusProgramWorklistEntry>;
  readonly programId: Scalars['ID'];
};

export type EpocusStatsDelta = {
  readonly __typename?: 'EpocusStatsDelta';
  readonly current: Scalars['Int'];
  /** Null when the prior period is empty — that change is not a percentage. */
  readonly deltaPct?: Maybe<Scalars['Float']>;
  readonly prior: Scalars['Int'];
};

export type EpocusStatsRange = {
  readonly __typename?: 'EpocusStatsRange';
  readonly from: Scalars['DateTime'];
  readonly to: Scalars['DateTime'];
};

export type EpocusStatsRangeInput = {
  /** Inclusive start of the clinical-date window. */
  readonly from: Scalars['DateTime'];
  /** Exclusive end. Half-open so a day falls in exactly one period. */
  readonly to: Scalars['DateTime'];
};

export type EpocusStudyFeeEstimate = {
  readonly __typename?: 'EpocusStudyFeeEstimate';
  /** The sum of the lines that could be estimated. Null when none could. */
  readonly amountCents?: Maybe<Scalars['Int']>;
  readonly lines: ReadonlyArray<EpocusChargeLineFee>;
  readonly needsProgramPostalCode: Scalars['Boolean'];
  readonly unestimatedLineCount: Scalars['Int'];
};

export type EpocusStudyRouting = {
  readonly __typename?: 'EpocusStudyRouting';
  /** Null for a portable device sending no accession, which is the common case. */
  readonly accessionNumber?: Maybe<Scalars['String']>;
  readonly deviceSerialNumber?: Maybe<Scalars['String']>;
  readonly dimseAeTitle?: Maybe<Scalars['String']>;
  readonly encounterId?: Maybe<Scalars['ID']>;
  readonly encounterStatus?: Maybe<EpocusEncounterStatus>;
  /**
   * What the gate stamped at ingress, as sent. Null for a study that arrived by
   * a path that does not stamp, or that predates the stamp being retained.
   */
  readonly ingressChannel?: Maybe<Scalars['String']>;
  readonly ingressGateId?: Maybe<Scalars['String']>;
  readonly ingressRouteKey?: Maybe<Scalars['String']>;
  readonly matchTier?: Maybe<EpocusMatchTier>;
  /** The matched performer, null while the encounter is unclaimed. */
  readonly performerId?: Maybe<Scalars['ID']>;
  readonly programId?: Maybe<Scalars['ID']>;
  readonly programName?: Maybe<Scalars['String']>;
  /**
   * Reported even when DISABLED: a study attributed to a disabled program is
   * readable by nobody, and that is the explanation for it.
   */
  readonly programStatus?: Maybe<EpocusProgramStatus>;
  /** Null only when the study was never received. */
  readonly receivedAt?: Maybe<Scalars['DateTime']>;
  readonly status: EpocusStudyRoutingStatus;
  readonly studyInstanceUid: Scalars['String'];
};

/**
 * Where a study got to, as four distinct outcomes rather than a nullable
 * program. Each has a different cause and a different fix.
 */
export enum EpocusStudyRoutingStatus {
  /**
   * No study with this StudyInstanceUID has reached the middleware. The send
   * failed upstream — at the gate, at the DIMSE association, or in transit —
   * and nothing here saw it.
   */
  NotReceived = 'NOT_RECEIVED',
  /**
   * Stored, but no ePOCUS encounter exists for it. The matching engine runs
   * inside a catch that deliberately swallows its errors so a failure there
   * cannot fail the ingest back to pacs, so this state is silent everywhere
   * else. Needs the service logs.
   */
  ReceivedNotProcessed = 'RECEIVED_NOT_PROCESSED',
  /** Attributed to a program. */
  Routed = 'ROUTED',
  /**
   * An encounter exists but belongs to no program: the ingress route key it
   * presented resolved to nothing. Compare ingressRouteKey and ingressGateId
   * against the program's ingressRoutes to tell a wrong called-AE from a
   * missing route row.
   */
  Unrouted = 'UNROUTED'
}

/** A GE-style exam preset, landing in ImageType[2] where the core plugin reads it. */
export enum EpocusTestStudyPreset {
  Abdominal = 'ABDOMINAL',
  Lung = 'LUNG',
  Ob = 'OB',
  Tte = 'TTE'
}

export type EpocusTestStudySend = {
  readonly __typename?: 'EpocusTestStudySend';
  /**
   * Whether the gate accepted the instance. False does not mean the study is
   * lost in transit — the gate refuses a disallowed calling AE per instance,
   * after the association succeeds — so failureReason is the thing to read.
   */
  readonly accepted: Scalars['Boolean'];
  readonly accessionNumber: Scalars['String'];
  readonly callingAeTitle: Scalars['String'];
  readonly deviceSerialNumber: Scalars['String'];
  /** The called AE, echoed back — the route key the gate should stamp. */
  readonly dimseAeTitle: Scalars['String'];
  /**
   * The C-STORE status, hex, when the gate answered at all. A 0xBxxx status is
   * a DICOM *warning*: the study was stored and something about it was changed,
   * so accepted is true.
   */
  readonly dimseStatus?: Maybe<Scalars['String']>;
  readonly failureReason?: Maybe<Scalars['String']>;
  /** The ACTIVE program the AE title resolved to before sending. */
  readonly programId: Scalars['ID'];
  readonly programName: Scalars['String'];
  readonly sentAt: Scalars['DateTime'];
  readonly sopInstanceUid: Scalars['String'];
  /**
   * Pass to epocusStudyRouting to find out where it landed. Freshly generated
   * per send, so repeated sends to one program never collide.
   */
  readonly studyInstanceUid: Scalars['String'];
};

export type EpocusTestStudySendInput = {
  /**
   * Sent as DeviceSerialNumber. Set it to a serial an existing performer has
   * already registered and the study lands in that performer's claim pool
   * instead of the unattributed one; omitted, a harness-specific serial is used
   * that matches nobody.
   */
  readonly deviceSerialNumber?: InputMaybe<Scalars['String']>;
  /**
   * The target program's dimseAeTitle, presented as the called AE. This is what
   * the gate stamps as the ingress route key, so it alone decides which program
   * the study is attributed to. Required, and never defaulted.
   */
  readonly dimseAeTitle: Scalars['String'];
  readonly examPreset?: InputMaybe<EpocusTestStudyPreset>;
  /**
   * Appended to the fixed synthetic patient name as a trailing component, to
   * tell repeated sends apart. It cannot replace the marker: this mutation
   * writes into a live clinical system and is reachable by an agent whose
   * inputs are free text from whoever it is talking to, so no caller gets to
   * make a test study read as a real person. Stripped to 32 characters with
   * DICOM PN delimiters removed.
   */
  readonly patientLabel?: InputMaybe<Scalars['String']>;
};

export type EpocusUser = {
  readonly __typename?: 'EpocusUser';
  readonly createdAt: Scalars['DateTime'];
  readonly elephantUserId?: Maybe<Scalars['ID']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly lastName: Scalars['String'];
  /**
   * The programs this person belongs to.
   *
   * Readable **only** through myEpocusUser. EpocusUser is also reachable from
   * listProgramUsers and epocusProgramMembers, where answering this would tell
   * one program's admin which *other* programs their members belong to — a
   * cross-tenant disclosure that surface does not otherwise make. Asking for it
   * there is refused rather than answered with an empty list, which would be a
   * lie about someone's access.
   */
  readonly memberships: ReadonlyArray<EpocusUserMembership>;
  /** The 10-digit National Provider Identifier billed as this person's rendering provider. */
  readonly npi?: Maybe<Scalars['String']>;
  /** Null for everyone but an ePOCUS platform admin (PNE-600). */
  readonly platformRole?: Maybe<EpocusPlatformRole>;
  /** Whether the daily incomplete-studies email is sent to this person. */
  readonly reminderEmailEnabled: Scalars['Boolean'];
  /** Local HH:mm in the program's time zone. Null follows the program's send time. */
  readonly reminderEmailTime?: Maybe<Scalars['String']>;
  readonly status: EpocusUserStatus;
  readonly telephone?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
};

/** One program the caller belongs to, and the role they hold in it. */
export type EpocusUserMembership = {
  readonly __typename?: 'EpocusUserMembership';
  readonly programId: Scalars['ID'];
  /**
   * Resolved here rather than on the client so Settings can name a program
   * without a second round trip. Only ACTIVE memberships of ACTIVE programs are
   * returned, matching the role resolution in caller-identity.ts.
   */
  readonly programName: Scalars['String'];
  readonly role: EpocusRole;
};

export enum EpocusUserStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Invited = 'INVITED'
}

/**
 * A station AE title the worklist will answer, and the program it answers for:
 * every active program's own AE title plus every device AE title registered
 * under Settings → Probes in exactly one program. The MWL gate admits a calling
 * AE from this list and refuses any other.
 */
export type EpocusWorklistStation = {
  readonly __typename?: 'EpocusWorklistStation';
  readonly aeTitle: Scalars['String'];
  readonly programId: Scalars['ID'];
};

export enum EpocusWorksheetSet {
  Standard = 'STANDARD',
  Us = 'US'
}

export enum ExchangeRateSource {
  Cbl = 'CBL'
}

export enum ExemptionType {
  AncMother = 'ANC_MOTHER',
  GenderBasedViolence = 'GENDER_BASED_VIOLENCE',
  MalariaPatient = 'MALARIA_PATIENT',
  Other = 'OTHER',
  Over_70 = 'OVER_70',
  Prisoner = 'PRISONER',
  PsychiatricPatient = 'PSYCHIATRIC_PATIENT',
  Under_5 = 'UNDER_5'
}

export type ExternalCoding = {
  readonly __typename?: 'ExternalCoding';
  readonly icd10?: Maybe<ExternalCodingReference>;
  readonly icd11?: Maybe<ExternalCodingReference>;
  readonly loinc?: Maybe<ExternalCodingReference>;
  readonly snomed?: Maybe<ExternalCodingReference>;
};

export type ExternalCodingReference = {
  readonly __typename?: 'ExternalCodingReference';
  readonly code: Scalars['String'];
  readonly system?: Maybe<Scalars['String']>;
};

export type ExternalReference = {
  readonly foreignId: Scalars['String'];
  readonly origin: Scalars['String'];
};

export type ExternalReferenceInventorySummary = {
  readonly __typename?: 'ExternalReferenceInventorySummary';
  readonly externalReference: SkuExternalReference;
  readonly facilityId: Scalars['ID'];
  readonly facilityQuantity: Scalars['Int'];
  readonly locationId?: Maybe<Scalars['ID']>;
  readonly quantity: Scalars['Int'];
  readonly summaries: ReadonlyArray<InventorySummary>;
  readonly supplyLevel: SupplyLevel;
};

export type FacilityDepartment = {
  readonly __typename?: 'FacilityDepartment';
  readonly _id: Scalars['ID'];
  readonly clinicUuid?: Maybe<Scalars['String']>;
  readonly color?: Maybe<DepartmentColor>;
  readonly formSchema?: Maybe<OperationalFormSchema>;
  readonly title: Scalars['String'];
};

export type FacilityLocationsInput = {
  readonly active?: InputMaybe<Scalars['Boolean']>;
  readonly clinicUuids: ReadonlyArray<Scalars['String']>;
  readonly hasPatients?: InputMaybe<Scalars['Boolean']>;
};

export type FacilityQueueInput = {
  readonly queueId: Scalars['ID'];
};

export type FacilitySnapshot = {
  readonly __typename?: 'FacilitySnapshot';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly name: Scalars['String'];
  readonly uuid: Scalars['ID'];
};

export type FacilitySnapshotInput = {
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export enum FacilityType {
  ChagHealthCentreAndClinic = 'CHAG_HEALTH_CENTRE_AND_CLINIC',
  ChagPrimaryCareHospitalCateringExcl = 'CHAG_PRIMARY_CARE_HOSPITAL_CATERING_EXCL',
  ChagPrimaryCareHospitalCateringIncl = 'CHAG_PRIMARY_CARE_HOSPITAL_CATERING_INCL',
  PrivateClinic = 'PRIVATE_CLINIC',
  PrivateDentalCentres = 'PRIVATE_DENTAL_CENTRES',
  PrivateDiagnosticCentre = 'PRIVATE_DIAGNOSTIC_CENTRE',
  PrivateEyeCentres = 'PRIVATE_EYE_CENTRES',
  PrivateHealthCentreAndMaternityHome = 'PRIVATE_HEALTH_CENTRE_AND_MATERNITY_HOME',
  PrivatePrimaryCareHospitalCateringExcl = 'PRIVATE_PRIMARY_CARE_HOSPITAL_CATERING_EXCL',
  PrivatePrimaryCareHospitalCateringIncl = 'PRIVATE_PRIMARY_CARE_HOSPITAL_CATERING_INCL',
  PrivateSecondaryHospital = 'PRIVATE_SECONDARY_HOSPITAL',
  PublicChpsCompound = 'PUBLIC_CHPS_COMPOUND',
  PublicHealthCentre = 'PUBLIC_HEALTH_CENTRE',
  PublicPrimaryCareHospitalCateringExcl = 'PUBLIC_PRIMARY_CARE_HOSPITAL_CATERING_EXCL',
  PublicPrimaryCareHospitalCateringIncl = 'PUBLIC_PRIMARY_CARE_HOSPITAL_CATERING_INCL',
  PublicSecondaryHospital = 'PUBLIC_SECONDARY_HOSPITAL',
  PublicTertiaryHospital = 'PUBLIC_TERTIARY_HOSPITAL'
}

export type FilterOptions = {
  readonly endDate: Scalars['Date'];
  readonly startDate: Scalars['Date'];
};

export type FinaliseStockTakeInput = {
  readonly facilityId: Scalars['ID'];
  readonly stockTakeId: Scalars['ID'];
};

export type FinalizeInvoiceInput = {
  readonly _id: Scalars['String'];
};

export type ForeignIdMapping = {
  readonly __typename?: 'ForeignIdMapping';
  readonly foreignId: Scalars['String'];
  readonly origin: Scalars['String'];
};

export type FreeTextDiagnosis = {
  readonly __typename?: 'FreeTextDiagnosis';
  /** The category entered by the user. */
  readonly category: Scalars['String'];
  /** The ID referencing to the Condition collection. */
  readonly id: Scalars['ID'];
  /** The name entered by the user. */
  readonly name: Scalars['String'];
};

export type FreeTextDiagnosisInput = {
  /** The category entered by the user. */
  readonly category: Scalars['String'];
  /** The ID referencing to the Condition collection. */
  readonly id: Scalars['ID'];
  /** The name entered by the user. */
  readonly name: Scalars['String'];
};

export type Frequency = {
  readonly __typename?: 'Frequency';
  readonly unit: TimeUnit;
  readonly value: Scalars['Int'];
};

export type FrequencyInput = {
  readonly unit: TimeUnit;
  readonly value: Scalars['Int'];
};

export type FulfillInventoryMoveRequestFulfillmentsInput = {
  readonly fulfillingLotId: Scalars['ID'];
  readonly quantity: Scalars['Int'];
  readonly requestSkuId: Scalars['ID'];
};

export type FulfillInventoryMoveRequestInput = {
  readonly fulfillments: ReadonlyArray<FulfillInventoryMoveRequestFulfillmentsInput>;
  readonly id: Scalars['ID'];
  readonly notes?: InputMaybe<Scalars['String']>;
};

export enum Gender {
  F = 'f',
  M = 'm',
  Transgender = 'transgender'
}

export type GenerateClaimCheckCodeInput = {
  readonly cardNumber: Scalars['String'];
  readonly cardType: CardType;
};

export type GenerateClaimCheckCodeResult = {
  readonly __typename?: 'GenerateClaimCheckCodeResult';
  readonly claimCheckCode?: Maybe<Scalars['String']>;
  readonly expiryDate?: Maybe<Scalars['String']>;
  readonly memberName?: Maybe<Scalars['String']>;
  readonly membershipNumber?: Maybe<Scalars['String']>;
};

export type GetAdministrationSchedulesInput = {
  readonly prescriptionIds: ReadonlyArray<Scalars['String']>;
};

export type GetDepartmentsForClinicInput = {
  readonly clinicUuid?: InputMaybe<Scalars['String']>;
};

export type GetDepartmentsInput = {
  readonly filter?: InputMaybe<DepartmentFilter>;
  readonly pagination?: InputMaybe<PaginatedInput>;
};

export type GetLotsBySkuIdInput = {
  readonly facilityId: Scalars['String'];
  readonly locationId?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Comparison>;
  readonly skuId: Scalars['String'];
};

/** Only one of the fields within this type should be provided. */
export type GetPatientInput = {
  readonly cardId?: InputMaybe<Scalars['ID']>;
  readonly cardOrPassportId?: InputMaybe<Scalars['ID']>;
  readonly cardUrl?: InputMaybe<Scalars['ID']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly passportId?: InputMaybe<Scalars['ID']>;
};

export type GetPatientResponse = {
  readonly __typename?: 'GetPatientResponse';
  readonly patient?: Maybe<SyncablePatient>;
};

export type GetPrescriptionInput = {
  readonly id: Scalars['ID'];
};

export type GetPrescriptionsInput = {
  readonly clinicalEventId?: InputMaybe<Scalars['ID']>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly patientId?: InputMaybe<Scalars['ID']>;
  readonly status?: InputMaybe<PrescriptionStatus>;
};

export type GetSkuByIdInput = {
  readonly id: Scalars['String'];
};

export type GetUiDefaultInput = {
  readonly name: Scalars['String'];
  readonly namespace: Scalars['String'];
  readonly scope: DefaultScope;
};

export type GetVtmResponse = {
  readonly __typename?: 'GetVtmResponse';
  readonly patient?: Maybe<SyncableVtm>;
};

export type Guardian = {
  readonly __typename?: 'Guardian';
  readonly consents: GuardianConsents;
  readonly fullName?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly patientId?: Maybe<Scalars['ID']>;
  readonly phone?: Maybe<SyncablePatientPhone>;
  readonly relationship: GuardianRelationship;
};

export type GuardianConsent = {
  readonly __typename?: 'GuardianConsent';
  readonly providedAt: Scalars['DateTime'];
  readonly value: Scalars['Boolean'];
};

export type GuardianConsentInput = {
  readonly providedAt: Scalars['DateTime'];
  readonly value: Scalars['Boolean'];
};

export type GuardianConsents = {
  readonly __typename?: 'GuardianConsents';
  readonly healthcareComms: GuardianConsent;
  readonly marketingComms: GuardianConsent;
};

export type GuardianConsentsInput = {
  readonly healthcareComms: GuardianConsentInput;
  readonly marketingComms: GuardianConsentInput;
};

/** Either patientId or fullName, phone and relationship are needed. Eg you either need to link a patient or provide sufficient guardian details */
export type GuardianInput = {
  readonly consents: GuardianConsentsInput;
  readonly fullName?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMetaInput;
  readonly patientId?: InputMaybe<Scalars['ID']>;
  readonly phone?: InputMaybe<SyncablePatientPhoneInput>;
  readonly relationship?: InputMaybe<GuardianRelationship>;
};

export enum GuardianRelationship {
  Father = 'FATHER',
  Grandparent = 'GRANDPARENT',
  Mother = 'MOTHER',
  Other = 'OTHER'
}

export type HealthPay = {
  readonly __typename?: 'HealthPay';
  /**
   * This field returns the most recently taken patient photo. We don't yet have a concrete plan
   * for how we'll store real patient photos, so for now we're just mimicing an action so that
   * if one person takes a photo another person won't have to.
   * It is likely that this field will be moved to api-patient in the future.
   */
  readonly mostRecentFakePhoto?: Maybe<HealthPayPatientPhoto>;
  readonly submissions: ReadonlyArray<HealthPaySubmission>;
};

export type HealthPayPatientPhoto = {
  readonly __typename?: 'HealthPayPatientPhoto';
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly patientId: Scalars['ID'];
};

export type HealthPaySubmission = {
  readonly __typename?: 'HealthPaySubmission';
  readonly consultationId: Scalars['ID'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly investigationActivityId: Scalars['ID'];
  readonly patientId: Scalars['ID'];
  readonly prescriptionId: Scalars['ID'];
  readonly version: Scalars['String'];
};

export type HealthPaySubmissionInput = {
  readonly consultationId: Scalars['ID'];
  readonly investigationActivityId: Scalars['ID'];
  readonly patientId: Scalars['ID'];
  readonly prescriptionId: Scalars['ID'];
  readonly version?: InputMaybe<Scalars['String']>;
};

export type I18NSchema = {
  readonly __typename?: 'I18NSchema';
  readonly categoryDisplayName: Scalars['String'];
  readonly displayName: Scalars['String'];
  readonly keywords?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly locale: L10N;
};

export type I18nString = {
  readonly __typename?: 'I18nString';
  readonly en: Scalars['String'];
};

export type I18nStringInput = {
  readonly en?: InputMaybe<Scalars['String']>;
  readonly es?: InputMaybe<Scalars['String']>;
  readonly fr?: InputMaybe<Scalars['String']>;
};

export enum ImagingAssetKind {
  Cine = 'CINE',
  Preview = 'PREVIEW',
  Thumbnail = 'THUMBNAIL'
}

export type ImagingAssetUrl = {
  readonly __typename?: 'ImagingAssetUrl';
  readonly url?: Maybe<Scalars['String']>;
};

export type ImagingAssetUrlInput = {
  readonly imagingInstanceId: Scalars['ID'];
  readonly kind: ImagingAssetKind;
};

export type ImagingInstance = {
  readonly __typename?: 'ImagingInstance';
  readonly id: Scalars['ID'];
  readonly previewUrl: Scalars['String'];
  readonly thumbnailUrl: Scalars['String'];
};

export type ImagingInstanceInput = {
  readonly dicomPreset?: InputMaybe<Scalars['String']>;
  readonly externalId: Scalars['String'];
  readonly frameRate?: InputMaybe<Scalars['Float']>;
  readonly numberOfFrames?: InputMaybe<Scalars['Int']>;
  readonly physicalDeltaMm?: InputMaybe<Scalars['Float']>;
  readonly previewUrl: Scalars['String'];
  readonly thumbnailUrl: Scalars['String'];
};

export type ImagingStudyExternalDetails = {
  readonly __typename?: 'ImagingStudyExternalDetails';
  readonly id: Scalars['ID'];
};

export type ImagingStudyExternalDetailsInput = {
  readonly accessionNumber: Scalars['String'];
  readonly deviceManufacturer?: InputMaybe<Scalars['String']>;
  readonly deviceModelName?: InputMaybe<Scalars['String']>;
  readonly deviceSerialNumber?: InputMaybe<Scalars['String']>;
  readonly externalId: Scalars['String'];
  readonly externalOperatorName?: InputMaybe<Scalars['String']>;
  readonly externalPatientDob?: InputMaybe<Scalars['String']>;
  readonly externalPatientGender?: InputMaybe<Scalars['String']>;
  readonly externalPatientIdentifier: Scalars['String'];
  readonly externalPatientName?: InputMaybe<Scalars['String']>;
  readonly externalUserIdentifier: Scalars['String'];
  readonly images: ReadonlyArray<ImagingInstanceInput>;
  readonly ingressCallingAeTitle?: InputMaybe<Scalars['String']>;
  readonly ingressChannel?: InputMaybe<Scalars['String']>;
  readonly ingressGateId?: InputMaybe<Scalars['String']>;
  readonly ingressRouteKey?: InputMaybe<Scalars['String']>;
  readonly startedAt: Scalars['DateTime'];
  readonly stationName?: InputMaybe<Scalars['String']>;
};

export type ImagingStudySyncPushInput = {
  readonly accessionNumber: Scalars['String'];
  readonly elephantPatientId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMetaInput;
};

export type ImagingStudySyncPushRow = {
  readonly assumedMasterState?: InputMaybe<ImagingStudySyncPushInput>;
  readonly newDocumentState: ImagingStudySyncPushInput;
};

export type InitiateStockTakeInput = {
  readonly facilityId: Scalars['ID'];
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly locationId: Scalars['ID'];
};

export type InpatientDetails = {
  readonly __typename?: 'InpatientDetails';
  readonly admission?: Maybe<Scalars['DateTime']>;
  readonly dailyRebateAmount?: Maybe<Scalars['Float']>;
  readonly discharge?: Maybe<Scalars['DateTime']>;
  readonly inpatientNumber?: Maybe<Scalars['String']>;
  readonly ward?: Maybe<Scalars['String']>;
};

export type InpatientDetailsInput = {
  readonly admission?: InputMaybe<Scalars['DateTime']>;
  readonly discharge?: InputMaybe<Scalars['DateTime']>;
  readonly inpatientNumber?: InputMaybe<Scalars['String']>;
  readonly ward?: InputMaybe<Scalars['String']>;
};

export type InpatientDiagnosis = {
  readonly notes?: InputMaybe<Scalars['String']>;
  readonly type: DiagnosisType;
  readonly uuid?: InputMaybe<Scalars['String']>;
};

export type InpatientPrescription = {
  readonly __typename?: 'InpatientPrescription';
  readonly administrationApproach: AdministrationApproach;
  readonly administrationSchedules: ReadonlyArray<AdministrationSchedule>;
  readonly asRequired: Scalars['Boolean'];
  readonly cancellationDetails?: Maybe<CancellationDetails>;
  readonly clinicalEvent: ClinicalEvent;
  readonly clinicalProduct?: Maybe<PrescriptionClinicalProduct>;
  readonly createdAt: Scalars['DateTime'];
  readonly dailyAdministrationScheduleSummary?: Maybe<ReadonlyArray<DailyAdministrationScheduleSummary>>;
  readonly dispensations: InpatientPrescriptionDispensationsPage;
  readonly dosage: DoseMeasurement;
  readonly facilityId: Scalars['String'];
  readonly frequency: Frequency;
  readonly id: Scalars['ID'];
  readonly isStat: Scalars['Boolean'];
  readonly minimumDoseInterval?: Maybe<MinimumDoseInterval>;
  readonly note?: Maybe<Scalars['String']>;
  readonly patientId: Scalars['String'];
  readonly prescriber: User;
  readonly rate?: Maybe<RateMeasurement>;
  readonly route: Route;
  readonly startsAt: Scalars['DateTime'];
  readonly status: PrescriptionStatus;
  readonly stopsAt: Scalars['DateTime'];
};


export type InpatientPrescriptionAdministrationSchedulesArgs = {
  input?: InputMaybe<InpatientPrescriptionAdministrationSchedulesInput>;
};


export type InpatientPrescriptionDailyAdministrationScheduleSummaryArgs = {
  input?: InputMaybe<InpatientPrescriptionDailyAdministrationSchedulesInput>;
};


export type InpatientPrescriptionDispensationsArgs = {
  options?: InputMaybe<InpatientPrescriptionDispensationsOptions>;
};

export type InpatientPrescriptionAdministrationSchedulesInput = {
  readonly scheduledFrom?: InputMaybe<Scalars['DateTime']>;
  readonly scheduledTo?: InputMaybe<Scalars['DateTime']>;
};

export type InpatientPrescriptionDailyAdministrationSchedulesInput = {
  readonly scheduledFrom?: InputMaybe<Scalars['DateTime']>;
  readonly scheduledTo?: InputMaybe<Scalars['DateTime']>;
};

export type InpatientPrescriptionDispensation = {
  readonly __typename?: 'InpatientPrescriptionDispensation';
  /** @deprecated Use the DispensationStrategy field instead */
  readonly alternativeDispensed?: Maybe<Scalars['Boolean']>;
  readonly createdAt: Scalars['DateTime'];
  readonly dispensationStrategy: DispensationStrategy;
  readonly dispenseLocation?: Maybe<Location>;
  readonly dispensedByUser?: Maybe<User>;
  readonly dispensedByUserId: Scalars['String'];
  readonly facilityId: Scalars['String'];
  readonly id: Scalars['String'];
  readonly locationId: Scalars['String'];
  readonly prescriptionId: Scalars['String'];
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly sku?: Maybe<Sku>;
};

export type InpatientPrescriptionDispensationsOptions = {
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export type InpatientPrescriptionDispensationsPage = {
  readonly __typename?: 'InpatientPrescriptionDispensationsPage';
  readonly items: ReadonlyArray<InpatientPrescriptionDispensation>;
  readonly totalCount?: Maybe<Scalars['Int']>;
};

export type InpatientVisitsExportInput = {
  readonly options: InpatientVisitsExportOptions;
  readonly params: InpatientVisitsExportParams;
};

export type InpatientVisitsExportOptions = {
  readonly facilityIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly organisationId: Scalars['ID'];
};

export type InpatientVisitsExportPage = {
  readonly __typename?: 'InpatientVisitsExportPage';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<DataExportInpatientVisit>>;
};

export type InpatientVisitsExportParams = {
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
};

export type InputCardIsVoidError = BaseError & {
  readonly __typename?: 'InputCardIsVoidError';
  readonly message: Scalars['String'];
  readonly path: ReadonlyArray<Scalars['String']>;
};

export type Insurance = {
  readonly __typename?: 'Insurance';
  /** @deprecated Use `insuranceDetails`. */
  readonly expiryDate?: Maybe<Scalars['Date']>;
  readonly id: Scalars['ID'];
  readonly insuranceDetails?: Maybe<Scalars['JSONObject']>;
  readonly insuranceNumber?: Maybe<Scalars['String']>;
  readonly insuranceProvider?: Maybe<InsuranceProvider>;
  readonly insuranceType: Scalars['String'];
  /** @deprecated Use `insuranceDetails`. */
  readonly paymentUpToDate?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use `insuranceDetails`. */
  readonly serialNumber?: Maybe<Scalars['String']>;
  readonly visitValidation?: Maybe<PatientInsuranceVisitValidation>;
};

export type InsuranceDetails = {
  readonly __typename?: 'InsuranceDetails';
  readonly dependent?: Maybe<Dependent>;
  readonly insuranceNumber?: Maybe<Scalars['String']>;
  /** @deprecated Use `insuranceNumber`. */
  readonly membershipNumber?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly nationalIdNumber?: Maybe<Scalars['String']>;
};

export type InsuranceDetailsInput = {
  readonly dependent?: InputMaybe<Dependent>;
  readonly insuranceNumber?: InputMaybe<Scalars['String']>;
  readonly membershipNumber?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly nationalIdNumber?: InputMaybe<Scalars['String']>;
};

export type InsuranceInput = {
  readonly expiryDate?: InputMaybe<Scalars['Date']>;
  readonly insuranceDetails?: InputMaybe<Scalars['JSONObject']>;
  readonly insuranceNumber?: InputMaybe<Scalars['String']>;
  readonly insuranceType: Scalars['String'];
  readonly paymentUpToDate?: InputMaybe<Scalars['Boolean']>;
  readonly serialNumber?: InputMaybe<Scalars['String']>;
  readonly visitInsuranceDetails?: InputMaybe<Scalars['JSONObject']>;
};

export type InsuranceListItem = {
  readonly __typename?: 'InsuranceListItem';
  readonly insurance: VisitInsurance;
  readonly insuranceDetails?: Maybe<Scalars['JSONObject']>;
  /** @deprecated Use insurance */
  readonly insuranceProvider: VisitInsurance;
  readonly isValidForVisit?: Maybe<Scalars['Boolean']>;
  readonly visitInsuranceDetails?: Maybe<Scalars['JSONObject']>;
};

export type InsuranceProvider = {
  readonly __typename?: 'InsuranceProvider';
  readonly id: Scalars['ID'];
  readonly insuranceType?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly registrationValidation?: Maybe<InsuranceRegistrationValidation>;
  readonly visitValidation?: Maybe<InsuranceVisitValidation>;
};

export type InsuranceRegistrationValidation = {
  readonly __typename?: 'InsuranceRegistrationValidation';
  readonly formSchema?: Maybe<Scalars['JSONObject']>;
  readonly validatorConfig?: Maybe<Scalars['JSONObject']>;
};

export type InsuranceVisitValidation = {
  readonly __typename?: 'InsuranceVisitValidation';
  readonly expiryStrategy: VisitExpiryStrategy;
  readonly formSchema?: Maybe<Scalars['JSONObject']>;
  readonly validatorConfig?: Maybe<Scalars['JSONObject']>;
};

export type InventoryHistory = {
  readonly __typename?: 'InventoryHistory';
  readonly eventType: Scalars['String'];
  readonly location?: Maybe<Location>;
  readonly skuName?: Maybe<Scalars['String']>;
  readonly timestamp: Scalars['DateTime'];
  readonly user: User;
};

export type InventoryHistoryInput = {
  readonly facilityId: Scalars['ID'];
  readonly locationId?: InputMaybe<Scalars['ID']>;
  readonly skuId?: InputMaybe<Scalars['ID']>;
  readonly userId?: InputMaybe<Scalars['ID']>;
};

export type InventoryHistoryOptions = {
  readonly endDate?: InputMaybe<Scalars['DateTime']>;
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']>;
};

export type InventoryHistoryPaged = {
  readonly __typename?: 'InventoryHistoryPaged';
  readonly items: ReadonlyArray<InventoryHistory>;
  readonly totalCount: Scalars['Int'];
};

/**
 * PHARMA matches SKUs without any external reference whose origin is "non_pharma".
 * NON_PHARMA matches SKUs with at least one external reference whose origin is "non_pharma".
 * Origin string is the ADR-006 federation contract value.
 */
export enum InventoryItemType {
  NonPharma = 'NON_PHARMA',
  Pharma = 'PHARMA'
}

export type InventoryMoveRequest = {
  readonly __typename?: 'InventoryMoveRequest';
  readonly actionedAt?: Maybe<Scalars['DateTime']>;
  readonly actioner?: Maybe<User>;
  readonly actionerNotes?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly fulfillingFacility?: Maybe<Clinic>;
  readonly fulfillingLocation?: Maybe<Location>;
  readonly id: Scalars['ID'];
  readonly receivingFacility: Clinic;
  readonly receivingLocation: Location;
  readonly requestor: User;
  readonly skus: InventoryMoveRequestSkuPaged;
  readonly status: InventoryMoveRequestStatus;
};

export type InventoryMoveRequestFulfillment = {
  readonly __typename?: 'InventoryMoveRequestFulfillment';
  readonly fulfillingLot: Lot;
  readonly id: Scalars['ID'];
  readonly quantityFulfilled: Scalars['Int'];
  readonly receivingLot: Lot;
};

export type InventoryMoveRequestInput = {
  readonly id: Scalars['ID'];
};

export type InventoryMoveRequestPaged = {
  readonly __typename?: 'InventoryMoveRequestPaged';
  readonly items: ReadonlyArray<InventoryMoveRequest>;
  readonly totalCount: Scalars['Int'];
};

export type InventoryMoveRequestSku = {
  readonly __typename?: 'InventoryMoveRequestSku';
  readonly availableLots: ReadonlyArray<Lot>;
  readonly fulfillments: ReadonlyArray<InventoryMoveRequestFulfillment>;
  readonly id: Scalars['ID'];
  readonly quantityRequested: Scalars['Int'];
  readonly sku: Sku;
};


export type InventoryMoveRequestSkuAvailableLotsArgs = {
  input: InventoryMoveRequestSkusAvailableLotsInput;
};

export type InventoryMoveRequestSkuPaged = {
  readonly __typename?: 'InventoryMoveRequestSkuPaged';
  readonly items: ReadonlyArray<InventoryMoveRequestSku>;
  readonly totalCount: Scalars['Int'];
};

export type InventoryMoveRequestSkusAvailableLotsInput = {
  readonly fulfillingFacilityId: Scalars['ID'];
  readonly fulfillingLocationId: Scalars['ID'];
};

export enum InventoryMoveRequestStatus {
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type InventoryMoveRequestsInput = {
  readonly receivingLocationId?: InputMaybe<Scalars['ID']>;
  readonly status?: InputMaybe<InventoryMoveRequestStatus>;
};

export type InventoryMoveRequestsOptions = {
  readonly orderBy?: InputMaybe<InventoryMoveRequestsOptionsOrderBy>;
  readonly orderDirection?: InputMaybe<OrderDirection>;
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export enum InventoryMoveRequestsOptionsOrderBy {
  CreatedAt = 'CREATED_AT'
}

export type InventorySearchExternalReferenceInput = {
  readonly foreignId: Scalars['String'];
  readonly origin: Scalars['String'];
};

export type InventorySearchForeignReference = {
  readonly foreignId: Scalars['String'];
  readonly origin: Scalars['String'];
};

export type InventorySearchInput = {
  readonly active?: InputMaybe<Scalars['Boolean']>;
  readonly externalReferences?: InputMaybe<ReadonlyArray<InventorySearchExternalReferenceInput>>;
  readonly facilityId: Scalars['String'];
  /** @deprecated Use 'externalReferences' */
  readonly foreignReferences?: InputMaybe<ReadonlyArray<InventorySearchForeignReference>>;
  readonly itemType?: InputMaybe<InventoryItemType>;
  readonly locationId?: InputMaybe<Scalars['String']>;
  readonly lot?: InputMaybe<InventorySearchLotInput>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Comparison>;
};

export type InventorySearchLotInput = {
  readonly expiryDate?: InputMaybe<ComparisonDate>;
  readonly quantity?: InputMaybe<Comparison>;
};

export type InventorySearchOptionsInput = {
  readonly order?: InputMaybe<InventorySearchOrderOptions>;
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export type InventorySearchOrderOptions = {
  readonly by?: InputMaybe<InventorySearchOrderProperty>;
  readonly direction?: InputMaybe<OrderDirection>;
};

export enum InventorySearchOrderProperty {
  ExpiryDate = 'EXPIRY_DATE',
  Name = 'NAME',
  NameRelavance = 'NAME_RELAVANCE',
  StockLevel = 'STOCK_LEVEL',
  UpdatedAt = 'UPDATED_AT'
}

export type InventorySummary = {
  readonly __typename?: 'InventorySummary';
  /** @deprecated Use field 'sku' instead */
  readonly active: Scalars['Boolean'];
  readonly expiryDate?: Maybe<Scalars['Date']>;
  /** @deprecated Use field 'sku' instead */
  readonly externalReferences: ReadonlyArray<SkuExternalReference>;
  readonly facilityQuantity?: Maybe<Scalars['Int']>;
  /** @deprecated Use field 'sku' instead */
  readonly id: Scalars['String'];
  /** @deprecated Use field 'sku' instead */
  readonly measurement?: Maybe<Measurement>;
  /** @deprecated Use field 'sku.measurement.quantity' instead */
  readonly measurementQuantity?: Maybe<Scalars['Int']>;
  /** @deprecated Use field 'sku.measurement.unit' instead */
  readonly measurementUnit?: Maybe<Scalars['String']>;
  /** @deprecated Use field 'sku' instead */
  readonly name: Scalars['String'];
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly sku: Sku;
  readonly supplyLevel?: Maybe<SupplyLevel>;
};

export type InventorySummaryConnection = {
  readonly __typename?: 'InventorySummaryConnection';
  readonly edges: ReadonlyArray<InventorySummaryEdge>;
  readonly totalCount?: Maybe<Scalars['Int']>;
};

export type InventorySummaryEdge = {
  readonly __typename?: 'InventorySummaryEdge';
  readonly cursor: Scalars['String'];
  readonly node: InventorySummary;
};

export type InvestigationActivitiesByIdInput = {
  readonly interOrgFlag?: InputMaybe<Scalars['Boolean']>;
  readonly investigationIds: ReadonlyArray<Scalars['ID']>;
};

export type InvestigationActivitiesInput = {
  readonly interOrgFlag?: InputMaybe<Scalars['Boolean']>;
  readonly patientUuid: Scalars['ID'];
};

export type InvestigationActivitiesPaginatedOffset = {
  readonly __typename?: 'InvestigationActivitiesPaginatedOffset';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<InvestigationResultUnion>;
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type InvestigationActivity = BaseActivity & {
  readonly __typename?: 'InvestigationActivity';
  readonly _id: Scalars['ID'];
  readonly catalogueItem: InvestigationActivityItem;
  readonly clinicalEvent?: Maybe<ClinicalEvent>;
  readonly meta: Meta;
  readonly outcome?: Maybe<InvestigationRequestOutcome>;
  /** @deprecated Field no longer supported */
  readonly patient: InvestigationPatientDetailsSnapshot;
  readonly request?: Maybe<InvestigationRequestOutcome>;
  readonly uuid?: Maybe<Scalars['ID']>;
  readonly void: Scalars['Boolean'];
};

export type InvestigationActivityInput = {
  readonly interOrgFlag?: InputMaybe<Scalars['Boolean']>;
  readonly investigationId: Scalars['ID'];
};

export type InvestigationActivityItem = {
  readonly __typename?: 'InvestigationActivityItem';
  /** @deprecated Use id */
  readonly _id?: Maybe<Scalars['ID']>;
  readonly activityType: Scalars['String'];
  readonly coding?: Maybe<CatalogueCoding>;
  readonly id: Scalars['ID'];
  readonly keywords?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly meta?: Maybe<Meta>;
  readonly result?: Maybe<InvestigationItemResult>;
  readonly title: Scalars['String'];
  readonly version: Scalars['Int'];
};

export type InvestigationActivityItemInput = {
  readonly activityType: Scalars['String'];
  readonly coding?: InputMaybe<CatalogueCodingInput>;
  readonly id: Scalars['ID'];
  readonly keywords?: InputMaybe<ReadonlyArray<InputMaybe<SyncableI18nStringInput>>>;
  readonly meta?: InputMaybe<SyncableMetaInput>;
  readonly result?: InputMaybe<InvestigationItemResultInput>;
  readonly title: SyncableI18nStringInput;
  readonly version: Scalars['Int'];
};

export type InvestigationActivitySyncPushInput = {
  readonly catalogueItem: InvestigationActivityItemInput;
  readonly clinicalEvent?: InputMaybe<ClinicalEventRefInput>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMetaInput;
  readonly outcome?: InputMaybe<InvestigationRequestOutcomeInput>;
  readonly patientId: Scalars['ID'];
  readonly request: InvestigationRequestOutcomeInput;
};

export type InvestigationActivitySyncPushRow = {
  readonly assumedMasterState?: InputMaybe<InvestigationActivitySyncPushInput>;
  readonly newDocumentState: InvestigationActivitySyncPushInput;
};

export type InvestigationDeleteResult = {
  readonly __typename?: 'InvestigationDeleteResult';
  readonly investigationActivityIds: ReadonlyArray<Scalars['ID']>;
  readonly success?: Maybe<Scalars['Boolean']>;
};

export type InvestigationItemResult = {
  readonly __typename?: 'InvestigationItemResult';
  readonly resultSchema: Scalars['JSONObject'];
};

export type InvestigationItemResultInput = {
  readonly resultSchema: Scalars['JSONObject'];
};

export type InvestigationLocationSnapshot = {
  readonly __typename?: 'InvestigationLocationSnapshot';
  readonly _id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type InvestigationPatientDetailsSnapshot = {
  readonly __typename?: 'InvestigationPatientDetailsSnapshot';
  /** @deprecated Use id */
  readonly _id: Scalars['ID'];
  /** @deprecated Fetch field from patient entity instead */
  readonly age: Scalars['String'];
  /** @deprecated Fetch field from patient entity instead */
  readonly dob: Scalars['String'];
  /** @deprecated Fetch field from patient entity instead */
  readonly gender: Gender;
  readonly id: Scalars['ID'];
  /** @deprecated Fetch field from patient entity instead */
  readonly name: Scalars['String'];
};

export type InvestigationPerformed = CareActivity & {
  readonly __typename?: 'InvestigationPerformed';
  readonly _id: Scalars['ID'];
  readonly careActivity?: Maybe<InvestigationPerformedDetails>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly type: Scalars['String'];
};

export type InvestigationPerformedDetails = {
  readonly __typename?: 'InvestigationPerformedDetails';
  readonly investigationId?: Maybe<Scalars['ID']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly performedAt?: Maybe<Scalars['DateTime']>;
};

export type InvestigationRequestOutcome = {
  readonly __typename?: 'InvestigationRequestOutcome';
  readonly _id: Scalars['ID'];
  readonly clinic: FacilitySnapshot;
  readonly location?: Maybe<InvestigationLocationSnapshot>;
  readonly meta?: Maybe<Meta>;
  readonly orderedProperties: ReadonlyArray<Maybe<Scalars['JSONObject']>>;
  readonly organisation: FacilitySnapshot;
  readonly performer: ElephantActor;
};

export type InvestigationRequestOutcomeInput = {
  readonly clinic: FacilitySnapshotInput;
  readonly meta?: InputMaybe<InvestigationRequestOutcomeMetaInput>;
  readonly orderedProperties: ReadonlyArray<InputMaybe<Scalars['JSONObject']>>;
  readonly organisation: FacilitySnapshotInput;
  readonly performer: ElephantActorInput;
};

export type InvestigationRequestOutcomeMetaInput = {
  readonly created: Scalars['DateTime'];
  readonly createdByUserId?: InputMaybe<Scalars['ID']>;
  readonly updated?: InputMaybe<Scalars['DateTime']>;
  readonly updatedByUserId?: InputMaybe<Scalars['ID']>;
};

export type InvestigationRequested = CareActivity & {
  readonly __typename?: 'InvestigationRequested';
  readonly _id: Scalars['ID'];
  readonly careActivity?: Maybe<InvestigationRequestedDetails>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly type: Scalars['String'];
};

export type InvestigationRequestedDetails = {
  readonly __typename?: 'InvestigationRequestedDetails';
  readonly investigationId?: Maybe<Scalars['ID']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly requestedAt?: Maybe<Scalars['DateTime']>;
};

export type InvestigationResultUnion = InvestigationActivity | TestResult;

export type InvestigationValidation = {
  readonly __typename?: 'InvestigationValidation';
  readonly id: Scalars['ID'];
  readonly investigationActivityId: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly processingStatus: ProcessingStatus;
};

export type InvestigationValidationSyncPushInput = {
  readonly id: Scalars['ID'];
  readonly investigationActivityId: Scalars['ID'];
  readonly meta: SyncableMetaInput;
  readonly processingStatus: ProcessingStatus;
};

export type InvestigationValidationSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<InvestigationValidationSyncPushInput>;
  readonly newDocumentState: InvestigationValidationSyncPushInput;
};

export type InvestigationValueItem = {
  readonly __typename?: 'InvestigationValueItem';
  readonly clinic: FacilitySnapshot;
  readonly id: Scalars['ID'];
  /** @deprecated Location not used for investigations */
  readonly location?: Maybe<InvestigationLocationSnapshot>;
  readonly meta: Meta;
  readonly organisation: FacilitySnapshot;
  readonly performer: ElephantActor;
  readonly unit?: Maybe<Scalars['String']>;
  readonly value: Scalars['String'];
};

export type InvestigationsExportInput = {
  readonly options: InvestigationsExportOptions;
  readonly params: InvestigationsExportParams;
};

export type InvestigationsExportOptions = {
  readonly clinicUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly organisationUuid: Scalars['ID'];
};

export type InvestigationsExportPage = {
  readonly __typename?: 'InvestigationsExportPage';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<InvestigationActivity>>;
  readonly total: Scalars['Int'];
};

export type InvestigationsExportParams = {
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
};

export type Invoice = {
  readonly __typename?: 'Invoice';
  readonly _id: Scalars['ID'];
  readonly balance: Balance;
  readonly created: Scalars['DateTime'];
  readonly createdBy: InvoiceUser;
  readonly facility: InvoiceClinic;
  readonly inpatientDetails?: Maybe<InpatientDetails>;
  readonly invoiceNumber: Scalars['String'];
  readonly invoiceStatus: InvoiceStatus;
  readonly lineItems: ReadonlyArray<InvoiceLineItem>;
  readonly organisation: InvoiceOrganisation;
  readonly patient: InvoicePatient;
  readonly patientType: PatientType;
  readonly payers: ReadonlyArray<Payer>;
  readonly transactions: ReadonlyArray<Transaction>;
  readonly updated: Scalars['DateTime'];
};

export type InvoiceClinic = {
  readonly __typename?: 'InvoiceClinic';
  readonly addresses?: Maybe<ReadonlyArray<Maybe<Address>>>;
  readonly name: Scalars['String'];
  readonly uuid: Scalars['String'];
};

export type InvoiceContactPoint = {
  readonly __typename?: 'InvoiceContactPoint';
  readonly ownership?: Maybe<InvoiceContactPointOwnership>;
  readonly system: InvoiceContactPointSystem;
  readonly value: Scalars['String'];
};

export enum InvoiceContactPointOwnership {
  Personal = 'personal',
  Shared = 'shared'
}

export enum InvoiceContactPointSystem {
  Other = 'other',
  Phone = 'phone'
}

export enum InvoiceGender {
  F = 'f',
  M = 'm',
  Transgender = 'transgender'
}

export type InvoiceLineItem = {
  readonly __typename?: 'InvoiceLineItem';
  readonly automated: Scalars['Boolean'];
  readonly cost: Scalars['Int'];
  readonly disabled: Scalars['Boolean'];
  readonly externalReference?: Maybe<PriceableItemExternalReference>;
  readonly id?: Maybe<Scalars['String']>;
  readonly incurredAt?: Maybe<Scalars['DateTime']>;
  readonly missingPrice?: Maybe<Scalars['Boolean']>;
  readonly priceListItem: PriceListItem;
  readonly quantity: Scalars['Int'];
  readonly supplier?: Maybe<LineItemSupplier>;
};

export type InvoiceLineItemV2Input = {
  readonly disabled?: InputMaybe<Scalars['Boolean']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly priceListItem: PriceListItemV2Input;
  readonly quantity: Scalars['Int'];
  readonly supplier?: InputMaybe<LineItemSupplier>;
};

export type InvoiceOrganisation = {
  readonly __typename?: 'InvoiceOrganisation';
  readonly addresses?: Maybe<ReadonlyArray<Maybe<Address>>>;
  readonly name: Scalars['String'];
  readonly uuid: Scalars['String'];
};

export type InvoicePatient = {
  readonly __typename?: 'InvoicePatient';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly cardId?: Maybe<Scalars['String']>;
  readonly insurance?: Maybe<InvoicePatientInsurance>;
  readonly passport?: Maybe<InvoicePatientPassport>;
  readonly person?: Maybe<InvoicePerson>;
  readonly uuid?: Maybe<Scalars['ID']>;
};

export type InvoicePatientInsurance = {
  readonly __typename?: 'InvoicePatientInsurance';
  /** @deprecated Use `insuranceDetails`. */
  readonly expiryDate?: Maybe<Scalars['Date']>;
  readonly insuranceDetails?: Maybe<Scalars['JSONObject']>;
  readonly insuranceNumber?: Maybe<Scalars['String']>;
  readonly insuranceType: Scalars['String'];
  /** @deprecated Use `insuranceDetails`. */
  readonly paymentUpToDate?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use `insuranceDetails`. */
  readonly serialNumber?: Maybe<Scalars['String']>;
};

export type InvoicePatientPassport = {
  readonly __typename?: 'InvoicePatientPassport';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly uid?: Maybe<Scalars['String']>;
};

export type InvoicePerson = {
  readonly __typename?: 'InvoicePerson';
  readonly addresses: ReadonlyArray<Maybe<Address>>;
  readonly contactPoints: ReadonlyArray<Maybe<InvoiceContactPoint>>;
  readonly dob: Scalars['PastDate'];
  readonly gender: InvoiceGender;
  readonly name: InvoicePersonName;
  readonly nationality?: Maybe<Scalars['String']>;
};

export type InvoicePersonName = {
  readonly __typename?: 'InvoicePersonName';
  readonly firstname?: Maybe<Scalars['String']>;
  readonly lastname?: Maybe<Scalars['String']>;
  readonly middlename?: Maybe<Scalars['String']>;
};

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID',
  Void = 'VOID'
}

export type InvoiceSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<SyncableInvoiceInput>;
  readonly newDocumentState: SyncableInvoiceInput;
};

export type InvoiceUser = {
  readonly __typename?: 'InvoiceUser';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly person?: Maybe<InvoicePersonName>;
  readonly role_id?: Maybe<Scalars['String']>;
  /** @deprecated Only present for legacy invoices */
  readonly uuid?: Maybe<Scalars['ID']>;
};

export type InvoicesExportInput = {
  readonly options: InvoicesExportOptions;
  readonly params: InvoicesExportParams;
};

export type InvoicesExportOptions = {
  readonly clinicUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly organisationUuid: Scalars['ID'];
};

export type InvoicesExportPage = {
  readonly __typename?: 'InvoicesExportPage';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<Invoice>>;
  readonly total: Scalars['Int'];
};

export type InvoicesExportParams = {
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
};

export type IsPatientsCardError = BaseError & {
  readonly __typename?: 'IsPatientsCardError';
  readonly message: Scalars['String'];
  readonly path: ReadonlyArray<Scalars['String']>;
};

export type ItemPrice = {
  readonly __typename?: 'ItemPrice';
  readonly active: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly owner: ItemPriceOwner;
  readonly parentPrice?: Maybe<ItemPrice>;
  readonly revenueDepartment: RevenueDepartment;
  readonly tariff: PriceTariff;
  readonly value: Scalars['Int'];
};

export enum ItemPriceOwner {
  Facility = 'FACILITY',
  Organisation = 'ORGANISATION'
}

export enum L10N {
  Ar = 'ar',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Kam = 'kam',
  Sw = 'sw'
}

export type Language = {
  readonly __typename?: 'Language';
  readonly locale?: Maybe<Scalars['String']>;
};

export type LegacyRole = {
  readonly __typename?: 'LegacyRole';
  readonly _id: Scalars['ID'];
  readonly description?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly parent?: Maybe<Scalars['String']>;
  readonly requiresTwoFactor?: Maybe<Scalars['Boolean']>;
  readonly uuid?: Maybe<Scalars['String']>;
};

export enum LineItemSupplier {
  Government = 'GOVERNMENT',
  Private = 'PRIVATE'
}

export type Location = {
  readonly __typename?: 'Location';
  readonly _id: Scalars['ID'];
  /** @deprecated Field no longer supported */
  readonly active: Scalars['Boolean'];
  readonly bedCount?: Maybe<Scalars['Int']>;
  readonly clinicUuid: Scalars['String'];
  readonly meta: LocationMeta;
  readonly name: Scalars['String'];
  readonly patients: ReadonlyArray<Maybe<LocationPatient>>;
  readonly readOnly?: Maybe<Scalars['Boolean']>;
};

export type LocationMeta = {
  readonly __typename?: 'LocationMeta';
  readonly active?: Maybe<Scalars['Boolean']>;
  readonly created: Scalars['DateTime'];
  readonly updated?: Maybe<Scalars['DateTime']>;
};

export type LocationPatient = {
  readonly __typename?: 'LocationPatient';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly admittedAt: Scalars['DateTime'];
  readonly diagnoses: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly dob: Scalars['DateTime'];
  readonly gender: Gender;
  readonly name: Scalars['String'];
  readonly uuid: Scalars['ID'];
};

export enum LookupKeyOrigin {
  FacilityId = 'FACILITY_ID'
}

export type LookupPatientIdError = InputCardIsVoidError;

export type LookupPatientIdInput = {
  /** Either the card url, card ID or the passport ID */
  readonly identifier: Scalars['ID'];
};

export type LookupPatientIdResponse = {
  readonly __typename?: 'LookupPatientIdResponse';
  readonly errors: ReadonlyArray<LookupPatientIdError>;
  readonly patientId?: Maybe<Scalars['ID']>;
};

export type Lot = {
  readonly __typename?: 'Lot';
  readonly expiryDate: Scalars['Date'];
  readonly facilityId: Scalars['String'];
  readonly id: Scalars['String'];
  readonly locationId?: Maybe<Scalars['String']>;
  readonly quantity: Scalars['Int'];
  readonly skuId: Scalars['String'];
};

export enum MaritalStatus {
  A = 'A',
  I = 'I',
  L = 'L',
  M = 'M',
  P = 'P',
  S = 'S',
  T = 'T',
  U = 'U',
  Unk = 'UNK',
  W = 'W'
}

export type Measurement = {
  readonly __typename?: 'Measurement';
  readonly quantity: Scalars['Int'];
  readonly unit: Scalars['String'];
};

export type Medication = {
  readonly __typename?: 'Medication';
  readonly uuid: Scalars['String'];
};

export type MedicationCategory = {
  readonly __typename?: 'MedicationCategory';
  readonly id: Scalars['String'];
  readonly title: Scalars['String'];
};

export type Meta = {
  readonly __typename?: 'Meta';
  readonly created?: Maybe<Scalars['DateTime']>;
  readonly updated?: Maybe<Scalars['DateTime']>;
};

export type Mfa = {
  readonly __typename?: 'Mfa';
  readonly hasMfa?: Maybe<Scalars['Boolean']>;
};

export type MinInsuranceProvider = {
  readonly __typename?: 'MinInsuranceProvider';
  readonly id: Scalars['ID'];
  readonly insuranceType?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly properties?: Maybe<ReadonlyArray<Maybe<Scalars['JSONObject']>>>;
};

export type MinimumDoseInterval = {
  readonly __typename?: 'MinimumDoseInterval';
  readonly unit: TimeUnit;
  readonly value: Scalars['Int'];
};

export type MinimumDoseIntervalInput = {
  readonly unit: TimeUnit;
  readonly value: Scalars['Int'];
};

export type ModalityWorklistEntry = {
  readonly __typename?: 'ModalityWorklistEntry';
  readonly accessionNumber: Scalars['String'];
  readonly elephantIdentifier: Scalars['String'];
  readonly modality: Scalars['String'];
  readonly partnerIdentifierSystem?: Maybe<Scalars['String']>;
  readonly partnerIdentifierValue?: Maybe<Scalars['String']>;
  readonly patientName?: Maybe<Scalars['String']>;
  readonly scheduledStart?: Maybe<Scalars['DateTime']>;
  readonly scheduledStationAeTitle?: Maybe<Scalars['String']>;
};

export type MoveLotInput = {
  readonly quantity: Scalars['Int'];
  readonly sourceLotId: Scalars['String'];
};

export type MoveLotOutput = {
  readonly __typename?: 'MoveLotOutput';
  readonly newDestinationLotCreated: Scalars['Boolean'];
  readonly quantityDecremented: Scalars['Int'];
  readonly quantityRequested: Scalars['Int'];
  readonly updatedDestinationLot: Lot;
  readonly updatedSourceLot: Lot;
};

export type MoveLotsInput = {
  readonly destinationLocationId: Scalars['String'];
  readonly facilityId: Scalars['String'];
  readonly moves: ReadonlyArray<MoveLotInput>;
};

export type MoveLotsOutput = {
  readonly __typename?: 'MoveLotsOutput';
  readonly moves: ReadonlyArray<MoveLotOutput>;
};

export type MoveQueuePatientInput = {
  readonly newQueueId: Scalars['ID'];
  readonly patientUuid: Scalars['ID'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly _empty?: Maybe<Scalars['String']>;
  readonly activateCard: ActivateCardResponse;
  readonly activateSku: Sku;
  readonly addCareEventToVisit?: Maybe<Visit>;
  readonly addClinicInsurance?: Maybe<ClinicInsurance>;
  /**
   * Attach someone who already has an ElephantOS login, by elephantUserId.
   * Team members are added by email through provisionEpocusProgramMember,
   * which handles new and existing people; this is for the one id the
   * onboarding agent legitimately knows, its own onBehalfOf, so the admin can
   * join the program they created. A machine caller is refused any other
   * elephantUserId, since nothing here would check who that id belongs to.
   */
  readonly addEpocusProgramMember: EpocusProgramMembership;
  readonly addNoteToCurrentVisit?: Maybe<Visit>;
  readonly addPatientToLocation: Location;
  readonly addPayers?: Maybe<Invoice>;
  readonly addQueuePatient: PatientQueue;
  readonly addStockTakeLot: StockTakeLotAddition;
  readonly administerScheduledDose: AdministrationScheduleResponse;
  readonly administerUnscheduledDose: AdministrationScheduleResponse;
  readonly ampBulkUpload: BulkUploadResult;
  readonly assignCard: Patient;
  readonly backfillEpocusProgramScope: EpocusProgramScopeBackfillResult;
  readonly billingDataReport?: Maybe<Scalars['JSONObject']>;
  readonly cancelPrescriptions: PrescriptionsResponse;
  readonly cashiersReport?: Maybe<Scalars['JSONObject']>;
  readonly clearAncHighRisk: AncPatientRiskRecord;
  /**
   * Soft-deletes every seeded demo study still sitting unclaimed in the program:
   * isTestScan encounters in IMPORTED with no performer and no accession. A
   * seeded study someone has claimed or documented is left alone.
   */
  readonly clearEpocusSeededDemoStudies: EpocusClearedSeededDemoStudies;
  /**
   * Cancels every still-ORDERED seeded request in a program — a soft delete plus
   * the MWL revoke. Only isTestScan rows, so a clinician's real order is never
   * swept up by a demo reset.
   */
  readonly clearEpocusSeededWorklist: EpocusSeededWorklistResult;
  readonly completeInvestigations: ReadonlyArray<Maybe<InvestigationActivity>>;
  readonly createAmp: Amp;
  readonly createAncEncounter: AncEncounter;
  /**
   * Should only be used in acceptance. Do not use in production. TODO: add a custom directive
   * to auto-block this being called in production.
   */
  readonly createCard?: Maybe<CreateCardResult>;
  readonly createClinic: Clinic;
  readonly createConsultation: Consultation;
  readonly createDataExportRequest?: Maybe<DataExportRequest>;
  /** @deprecated Field no longer supported */
  readonly createDepartment?: Maybe<Department>;
  /**
   * Exports every Ready-to-bill study in range, amended ones included, and marks
   * them Exported. Returns at once; the ZIP builds in the background. Null when
   * nothing is ready.
   */
  readonly createEpocusBillerExport?: Maybe<EpocusBillerExport>;
  readonly createEpocusConsentDocument: SyncableEpocusConsentDocument;
  readonly createEpocusPrivacyPolicy: EpocusPrivacyPolicy;
  readonly createEpocusProgram: EpocusProgram;
  readonly createFacilityLocation?: Maybe<Location>;
  readonly createHealthPaySubmission: HealthPaySubmission;
  readonly createInpatientVisit?: Maybe<Visit>;
  readonly createInvestigations: ReadonlyArray<Maybe<InvestigationActivity>>;
  readonly createInvoice?: Maybe<Invoice>;
  readonly createNonPharmaItem: NonPharmaItem;
  readonly createOrganisation: Organisation;
  readonly createOutpatientPrescriptions?: Maybe<ReadonlyArray<Maybe<InpatientPrescription>>>;
  /** @deprecated Use createPatientWithCard for patients with pre-printed cards */
  readonly createPassport: Passport;
  /**
   * Should only be used in acceptance. Do not use in production. TODO: add a custom directive
   * to auto-block this being called in production.
   * @deprecated Use createPatientWithCard for clinics with pre-printed cards
   */
  readonly createPatient?: Maybe<PatientAndPassport>;
  readonly createPatientQueue: PatientQueue;
  readonly createPatientTriageStatus: TriageStatus;
  readonly createPin?: Maybe<CreatePinResult>;
  readonly createPrescriptions: PrescriptionsResponse;
  readonly createSku: Sku;
  readonly createUser: User;
  readonly createVisit?: Maybe<Visit>;
  readonly createVmp: Vmp;
  readonly createVtm: Vtm;
  readonly dailySalesReport?: Maybe<Scalars['JSONObject']>;
  readonly deactivateSku: Sku;
  readonly deleteCareEventsFromVisit?: Maybe<Visit>;
  /** @deprecated Field no longer supported */
  readonly deleteDepartment?: Maybe<DeleteDepartmentResult>;
  readonly deleteFacilityLocations?: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly deleteInvestigations: InvestigationDeleteResult;
  readonly deleteInvoice?: Maybe<Scalars['Boolean']>;
  readonly deletePatientQueue: PatientQueueDeleteResult;
  readonly deleteTestClinicInsurance?: Maybe<Scalars['Boolean']>;
  readonly deleteUserMfaEnrollments: UserMutationResponse;
  readonly dischargePatient?: Maybe<DischargePatientResponse>;
  readonly dispenseInpatientPrescriptions?: Maybe<DispenseInpatientPrescriptionsResponse>;
  readonly dispensePrescriptions: ReadonlyArray<Prescription>;
  readonly dispenseStock: ReadonlyArray<Lot>;
  readonly finaliseStockTake: StockTake;
  readonly finalizeInvoice?: Maybe<Invoice>;
  readonly fiso3dReport?: Maybe<Scalars['JSONObject']>;
  readonly fulfillInventoryMoveRequest: InventoryMoveRequest;
  readonly generateClaimCheckCode?: Maybe<GenerateClaimCheckCodeResult>;
  readonly initiateStockTake: StockTake;
  readonly moveLots: MoveLotsOutput;
  readonly moveQueuePatient: PatientQueue;
  readonly nonPharmaItemBulkUpload: BulkUploadResult;
  readonly priceListV2: PriceListV2Mutations;
  readonly provisionEpocusProgramMember: EpocusProgramMembership;
  /**
   * Mint an auth principal and record an EpocusUser against it, with no program
   * membership. The person receives an email to set their password.
   */
  readonly provisionEpocusUser: EpocusUser;
  readonly pushConsultation: PushConsultationResponse;
  readonly pushDispensation: PushDispensationResponse;
  readonly pushEpocusAuditEvents: PushEpocusAuditEventsResult;
  readonly pushEpocusBilling: PushEpocusBillingResult;
  readonly pushEpocusEncounter: PushEpocusEncounterResult;
  readonly pushEpocusExam: PushEpocusExamResult;
  readonly pushEpocusPatientConsent: PushEpocusPatientConsentResult;
  readonly pushEpocusProbeAssociation: PushEpocusProbeAssociationResult;
  readonly pushEpocusReview: PushEpocusReviewResult;
  readonly pushImagingStudy: PushImagingStudyResponse;
  readonly pushInvestigationActivity: PushInvestigationActivityResponse;
  readonly pushInvestigationValidation: PushInvestigationValidationResponse;
  readonly pushInvoice: PushInvoiceResponse;
  readonly pushNotificationBellState: PushNotificationBellStateResponse;
  readonly pushNotificationDismissal: PushNotificationDismissalResponse;
  readonly pushPatient: PushPatientResponse;
  readonly pushPrescription: PushPrescriptionResponse;
  readonly pushPriceAcknowledgement: PushPriceAcknowledgementResponse;
  readonly pushReferral: PushReferralResponse;
  readonly pushReferralFeedback: PushReferralFeedbackResponse;
  readonly receiveStock: Lot;
  readonly receiveStockBulkUpload: BulkUploadResult;
  readonly recordPayment: Payment;
  readonly refundInvoice?: Maybe<Invoice>;
  readonly rejectInventoryMoveRequest: InventoryMoveRequest;
  readonly removeClinic: Clinic;
  readonly removeOrganisation: Organisation;
  readonly removePatientFromLocation: Location;
  readonly removeQueuePatient: PatientQueue;
  /** Program admins of that program only. Every request is audited. */
  readonly requestEpocusBillerExportDownload: EpocusBillerExportDownload;
  readonly requestInventoryMove: InventoryMoveRequest;
  readonly requestRegisterDownload: RegisterDownloadRequest;
  readonly requestSendPin?: Maybe<Scalars['Boolean']>;
  readonly resetEpocusUserMfa: Scalars['Boolean'];
  readonly retryEpocusBillerExport: EpocusBillerExport;
  readonly reviewStockTakeLot: StockTakeLot;
  /**
   * Seeds unclaimed demo encounters into a program. LIBRARY draws assets from the
   * curated seed library for the requested exam types (default: the program's
   * enabled set) and copies them into this deployment's imaging bucket; PROGRAM
   * clones the program's own imaged studies. With no source given, LIBRARY is
   * used when one is configured. Every row is marked isTestScan and stays out of
   * the program's QA numbers.
   */
  readonly seedEpocusDemoStudies: ReadonlyArray<EpocusSeededDemoStudy>;
  /**
   * Seeds realistic scan requests into a program's worklist through the real
   * order path, so a demo can show the order flow without a clinician placing
   * orders. Every row is marked isTestScan and stays out of the program's QA
   * numbers. Refuses a program with no DIMSE AE title, because no probe could
   * query the entries it would create.
   */
  readonly seedEpocusWorklist: EpocusSeededWorklistResult;
  /**
   * C-STORE a synthetic study to a program's AE title. Read the outcome back
   * with epocusStudyRouting.
   *
   * **What a pass proves:** the AE title resolves to an ACTIVE program, that
   * program has an ingress route on this gate, and a study presenting the title
   * is stamped and attributed to it. That is the failure this loop exists for —
   * a program that looks complete and is wired to receive nothing.
   *
   * **What a pass does not prove:** that a device at the site can reach us. The
   * send originates inside the cluster and so skips the NLB's TLS and HAProxy's
   * source-IP allow-list, and a new site's egress IP is a separate onboarding
   * step. It equally cannot prove anyone has typed the AE title into the device
   * — no send from our own infrastructure can, since this one supplies the
   * title itself.
   *
   * So a pass means the platform side is correctly configured. A site is live
   * when a study from its own device appears, not when this succeeds.
   */
  readonly sendEpocusTestStudy: EpocusTestStudySend;
  readonly sendEpocusUserPasswordReset: Scalars['Boolean'];
  readonly sendPinViaSMS?: Maybe<Scalars['Boolean']>;
  readonly sendUserPasswordReset: UserMutationResponse;
  readonly setEpocusPerformerCredential: EpocusPerformerCredential;
  readonly setEpocusPlatformRole: EpocusUser;
  readonly setEpocusProgramEnabledDeviceIds: EpocusProgram;
  readonly setEpocusProgramEnabledExamTypes: EpocusProgram;
  readonly setEpocusUserEnabled: EpocusUser;
  readonly setLineItemsV2: Invoice;
  readonly setPatientType?: Maybe<Invoice>;
  readonly skuBulkUpload: BulkUploadResult;
  readonly stockTakeBulkUpload: StockTakeBulkUploadResult;
  readonly supplierBulkUpload: BulkUploadResult;
  readonly takePayment?: Maybe<Invoice>;
  readonly updateAccessToHealthRecords: Patient;
  readonly updateAmp: Amp;
  readonly updateAmpActivation: Amp;
  readonly updateAncEncounter: AncEncounter;
  readonly updateClinic: Clinic;
  readonly updateCurrentVisit: Visit;
  /** @deprecated Field no longer supported */
  readonly updateDepartment?: Maybe<Department>;
  readonly updateEpocusProgram: EpocusProgram;
  readonly updateEpocusUser: EpocusUser;
  readonly updateFacilityLocation?: Maybe<Location>;
  readonly updateInpatientDepartment?: Maybe<Visit>;
  readonly updateInpatientLocation?: Maybe<Visit>;
  readonly updateLot: Lot;
  /**
   * Update your own name, telephone, NPI and reminder email settings.
   *
   * Email is deliberately absent: it is the join key to the auth principal, so
   * it is changed by re-provisioning rather than by editing a profile. Role and
   * status are absent for the same reason in reverse — those are somebody
   * else's decision about you, and live on updateEpocusUser.
   */
  readonly updateMyEpocusUser: EpocusUser;
  readonly updateNonPharmaItem: NonPharmaItem;
  readonly updateNonPharmaItemActivation: NonPharmaItem;
  readonly updateOrganisation: Organisation;
  readonly updatePatient: Patient;
  readonly updatePatientDiagnosesInLocation: Location;
  readonly updatePatientInsuranceDetails: Patient;
  readonly updatePatientTriageStatus: TriageStatus;
  readonly updateSku: Sku;
  readonly updateUser: User;
  readonly updateUserEnabledState: UserMeta;
  readonly updateVmp: Vmp;
  readonly updateVmpActivation: Vmp;
  readonly updateVtm: Vtm;
  readonly updateVtmActivation: Vtm;
  readonly upsertImagingStudyExternalDetails: ImagingStudyExternalDetails;
  readonly upsertUiDefault: UiDefault;
  readonly vmpBulkUpload: BulkUploadResult;
  readonly voidInvoice?: Maybe<Invoice>;
  readonly vtmBulkUpload: BulkUploadResult;
};


export type MutationActivateCardArgs = {
  input: ActivateCardInput;
};


export type MutationActivateSkuArgs = {
  input: ActivateSkuInput;
};


export type MutationAddCareEventToVisitArgs = {
  input?: InputMaybe<AddCareEventToVisitInput>;
};


export type MutationAddClinicInsuranceArgs = {
  input: AddClinicInsuranceInput;
};


export type MutationAddEpocusProgramMemberArgs = {
  input: AddEpocusProgramMemberInput;
};


export type MutationAddNoteToCurrentVisitArgs = {
  input: AddNoteToVisitInput;
};


export type MutationAddPatientToLocationArgs = {
  input: AddPatientToLocationInput;
};


export type MutationAddPayersArgs = {
  input: AddPayersInput;
};


export type MutationAddQueuePatientArgs = {
  input: AddQueuePatientInput;
};


export type MutationAddStockTakeLotArgs = {
  input: AddStockTakeLotInput;
};


export type MutationAdministerScheduledDoseArgs = {
  input: AdministerScheduledDoseInput;
};


export type MutationAdministerUnscheduledDoseArgs = {
  input: AdministerUnscheduledDoseInput;
};


export type MutationAmpBulkUploadArgs = {
  input: BulkUploadInput;
};


export type MutationAssignCardArgs = {
  canAssignAcrossWholeTerritory?: InputMaybe<Scalars['Boolean']>;
  input: AssignCardInput;
};


export type MutationBackfillEpocusProgramScopeArgs = {
  input: BackfillEpocusProgramScopeInput;
};


export type MutationBillingDataReportArgs = {
  input: BillingDataReportInput;
};


export type MutationCancelPrescriptionsArgs = {
  input: CancelPrescriptionsInput;
};


export type MutationCashiersReportArgs = {
  input: BillingDataReportInput;
};


export type MutationClearAncHighRiskArgs = {
  input: ClearAncHighRiskInput;
};


export type MutationClearEpocusSeededDemoStudiesArgs = {
  programId: Scalars['ID'];
};


export type MutationClearEpocusSeededWorklistArgs = {
  programId: Scalars['ID'];
};


export type MutationCompleteInvestigationsArgs = {
  input: ReadonlyArray<InputMaybe<CompleteInvestigationInput>>;
};


export type MutationCreateAmpArgs = {
  input: CreateAmpInput;
};


export type MutationCreateAncEncounterArgs = {
  input: CreateAncEncounterInput;
};


export type MutationCreateCardArgs = {
  isTestEnv: Scalars['Boolean'];
};


export type MutationCreateClinicArgs = {
  clinic: ClinicInput;
};


export type MutationCreateConsultationArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  input: CreateConsultation;
};


export type MutationCreateDataExportRequestArgs = {
  input: CreateDataExportRequestInput;
};


export type MutationCreateDepartmentArgs = {
  input: CreateDepartmentInput;
};


export type MutationCreateEpocusBillerExportArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  programId: Scalars['ID'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type MutationCreateEpocusConsentDocumentArgs = {
  input: CreateEpocusConsentDocumentInput;
};


export type MutationCreateEpocusPrivacyPolicyArgs = {
  input: CreateEpocusPrivacyPolicyInput;
};


export type MutationCreateEpocusProgramArgs = {
  input: CreateEpocusProgramInput;
};


export type MutationCreateFacilityLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateHealthPaySubmissionArgs = {
  input: HealthPaySubmissionInput;
};


export type MutationCreateInpatientVisitArgs = {
  input: CreateInpatientVisitInput;
};


export type MutationCreateInvestigationsArgs = {
  input: ReadonlyArray<InputMaybe<CreateInvestigationInput>>;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateNonPharmaItemArgs = {
  input: CreateNonPharmaItemInput;
};


export type MutationCreateOrganisationArgs = {
  organisation: OrganisationInput;
};


export type MutationCreateOutpatientPrescriptionsArgs = {
  input: CreateOutpatientPrescriptionsInput;
};


export type MutationCreatePassportArgs = {
  patientId: Scalars['String'];
};


export type MutationCreatePatientArgs = {
  patient?: InputMaybe<PatientInput>;
};


export type MutationCreatePatientQueueArgs = {
  input: CreatePatientQueueInput;
};


export type MutationCreatePatientTriageStatusArgs = {
  input: CreatePatientTriageStatus;
};


export type MutationCreatePinArgs = {
  patientUuid: Scalars['String'];
};


export type MutationCreatePrescriptionsArgs = {
  input: CreatePrescriptionsInput;
};


export type MutationCreateSkuArgs = {
  input: CreateSkuInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVisitArgs = {
  input?: InputMaybe<CreateVisitInput>;
};


export type MutationCreateVmpArgs = {
  input: CreateVmpInput;
};


export type MutationCreateVtmArgs = {
  input: CreateVtmInput;
};


export type MutationDailySalesReportArgs = {
  input: BillingDataReportInput;
};


export type MutationDeactivateSkuArgs = {
  input: DeactivateSkuInput;
};


export type MutationDeleteCareEventsFromVisitArgs = {
  input: DeleteCareEventsInput;
};


export type MutationDeleteDepartmentArgs = {
  input: DeleteDepartmentInput;
};


export type MutationDeleteFacilityLocationsArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};


export type MutationDeleteInvestigationsArgs = {
  input: ReadonlyArray<Scalars['ID']>;
};


export type MutationDeleteInvoiceArgs = {
  input: DeleteInvoiceInput;
};


export type MutationDeletePatientQueueArgs = {
  input: DeletePatientQueueInput;
};


export type MutationDeleteUserMfaEnrollmentsArgs = {
  _id: Scalars['String'];
};


export type MutationDischargePatientArgs = {
  input: DischargePatientInput;
};


export type MutationDispenseInpatientPrescriptionsArgs = {
  input: DispenseInpatientPrescriptionsInput;
};


export type MutationDispensePrescriptionsArgs = {
  input: ReadonlyArray<InputMaybe<DispensePrescription>>;
  locationId?: InputMaybe<Scalars['ID']>;
};


export type MutationDispenseStockArgs = {
  input: ReadonlyArray<DispenseStockInput>;
};


export type MutationFinaliseStockTakeArgs = {
  input: FinaliseStockTakeInput;
};


export type MutationFinalizeInvoiceArgs = {
  input: FinalizeInvoiceInput;
};


export type MutationFiso3dReportArgs = {
  input: BillingDataReportInput;
};


export type MutationFulfillInventoryMoveRequestArgs = {
  input: FulfillInventoryMoveRequestInput;
};


export type MutationGenerateClaimCheckCodeArgs = {
  input: GenerateClaimCheckCodeInput;
};


export type MutationInitiateStockTakeArgs = {
  input: InitiateStockTakeInput;
};


export type MutationMoveLotsArgs = {
  input: MoveLotsInput;
};


export type MutationMoveQueuePatientArgs = {
  input: MoveQueuePatientInput;
};


export type MutationNonPharmaItemBulkUploadArgs = {
  input: BulkUploadInput;
};


export type MutationProvisionEpocusProgramMemberArgs = {
  input: ProvisionEpocusProgramMemberInput;
};


export type MutationProvisionEpocusUserArgs = {
  input: ProvisionEpocusUserInput;
};


export type MutationPushConsultationArgs = {
  input: PushConsultationInput;
};


export type MutationPushDispensationArgs = {
  input: PushDispensationInput;
};


export type MutationPushEpocusAuditEventsArgs = {
  input: PushEpocusAuditEventsInput;
};


export type MutationPushEpocusBillingArgs = {
  input: PushEpocusBillingInput;
};


export type MutationPushEpocusEncounterArgs = {
  input: PushEpocusEncounterInput;
};


export type MutationPushEpocusExamArgs = {
  input: PushEpocusExamInput;
};


export type MutationPushEpocusPatientConsentArgs = {
  input: PushEpocusPatientConsentInput;
};


export type MutationPushEpocusProbeAssociationArgs = {
  input: PushEpocusProbeAssociationInput;
};


export type MutationPushEpocusReviewArgs = {
  input: PushEpocusReviewInput;
};


export type MutationPushImagingStudyArgs = {
  input: PushImagingStudyInput;
};


export type MutationPushInvestigationActivityArgs = {
  input: PushInvestigationActivityInput;
};


export type MutationPushInvestigationValidationArgs = {
  input: PushInvestigationValidationInput;
};


export type MutationPushInvoiceArgs = {
  input: PushInvoiceInput;
};


export type MutationPushNotificationBellStateArgs = {
  input: PushNotificationBellStateInput;
};


export type MutationPushNotificationDismissalArgs = {
  input: PushNotificationDismissalInput;
};


export type MutationPushPatientArgs = {
  input: PushPatientInput;
};


export type MutationPushPrescriptionArgs = {
  input: PushPrescriptionInput;
};


export type MutationPushPriceAcknowledgementArgs = {
  input: PushPriceAcknowledgementInput;
};


export type MutationPushReferralArgs = {
  input: PushReferralInput;
};


export type MutationPushReferralFeedbackArgs = {
  input: PushReferralFeedbackInput;
};


export type MutationReceiveStockArgs = {
  input: ReceiveStockInput;
};


export type MutationReceiveStockBulkUploadArgs = {
  input: ReceiveStockBulkUploadInput;
};


export type MutationRecordPaymentArgs = {
  input: RecordPaymentInput;
};


export type MutationRefundInvoiceArgs = {
  input: RefundInvoiceInput;
};


export type MutationRejectInventoryMoveRequestArgs = {
  input: RejectInventoryMoveRequestInput;
};


export type MutationRemoveClinicArgs = {
  uuid: Scalars['String'];
};


export type MutationRemoveOrganisationArgs = {
  uuid: Scalars['String'];
};


export type MutationRemovePatientFromLocationArgs = {
  input: RemovePatientFromLocationInput;
};


export type MutationRemoveQueuePatientArgs = {
  input: RemoveQueuePatientInput;
};


export type MutationRequestEpocusBillerExportDownloadArgs = {
  exportId: Scalars['ID'];
  programId: Scalars['ID'];
};


export type MutationRequestInventoryMoveArgs = {
  input: RequestInventoryMoveInput;
};


export type MutationRequestRegisterDownloadArgs = {
  input: RequestRegisterDownloadInput;
};


export type MutationRequestSendPinArgs = {
  input: RequestSendPinInput;
};


export type MutationResetEpocusUserMfaArgs = {
  epocusUserId: Scalars['ID'];
};


export type MutationRetryEpocusBillerExportArgs = {
  exportId: Scalars['ID'];
  programId: Scalars['ID'];
};


export type MutationReviewStockTakeLotArgs = {
  input: ReviewStockTakeLotInput;
};


export type MutationSeedEpocusDemoStudiesArgs = {
  count?: Scalars['Int'];
  deviceSerialNumber?: InputMaybe<Scalars['String']>;
  examTypes?: InputMaybe<ReadonlyArray<EpocusExamType>>;
  kind?: EpocusSeedKind;
  programId: Scalars['ID'];
  source?: InputMaybe<EpocusSeedSource>;
};


export type MutationSeedEpocusWorklistArgs = {
  clear?: InputMaybe<Scalars['Boolean']>;
  count?: InputMaybe<Scalars['Int']>;
  programId: Scalars['ID'];
};


export type MutationSendEpocusTestStudyArgs = {
  input: EpocusTestStudySendInput;
};


export type MutationSendEpocusUserPasswordResetArgs = {
  epocusUserId: Scalars['ID'];
};


export type MutationSendPinViaSmsArgs = {
  sendPinInput: SendPinInput;
};


export type MutationSendUserPasswordResetArgs = {
  _id: Scalars['String'];
};


export type MutationSetEpocusPerformerCredentialArgs = {
  input: SetEpocusPerformerCredentialInput;
};


export type MutationSetEpocusPlatformRoleArgs = {
  input: SetEpocusPlatformRoleInput;
};


export type MutationSetEpocusProgramEnabledDeviceIdsArgs = {
  input: SetEpocusProgramEnabledDeviceIdsInput;
};


export type MutationSetEpocusProgramEnabledExamTypesArgs = {
  input: SetEpocusProgramEnabledExamTypesInput;
};


export type MutationSetEpocusUserEnabledArgs = {
  enabled: Scalars['Boolean'];
  epocusUserId: Scalars['ID'];
};


export type MutationSetLineItemsV2Args = {
  input: SetInvoiceLineItemsV2Input;
};


export type MutationSetPatientTypeArgs = {
  input: SetPatientTypeInput;
};


export type MutationSkuBulkUploadArgs = {
  input: BulkUploadInput;
};


export type MutationStockTakeBulkUploadArgs = {
  input: StockTakeBulkUploadInput;
};


export type MutationSupplierBulkUploadArgs = {
  input: BulkUploadInput;
};


export type MutationTakePaymentArgs = {
  input: TakePaymentInput;
};


export type MutationUpdateAccessToHealthRecordsArgs = {
  accessToHealthRecords: Scalars['Boolean'];
  uuid: Scalars['String'];
};


export type MutationUpdateAmpArgs = {
  input: UpdateAmpInput;
};


export type MutationUpdateAmpActivationArgs = {
  input: ProductActivationInput;
};


export type MutationUpdateAncEncounterArgs = {
  input: UpdateAncEncounterInput;
};


export type MutationUpdateClinicArgs = {
  clinic: UpdateClinicInput;
  uuid: Scalars['String'];
};


export type MutationUpdateCurrentVisitArgs = {
  input: UpdateCurrentVisitInput;
};


export type MutationUpdateDepartmentArgs = {
  input: UpdateDepartmentInput;
};


export type MutationUpdateEpocusProgramArgs = {
  input: UpdateEpocusProgramInput;
};


export type MutationUpdateEpocusUserArgs = {
  input: UpdateEpocusUserInput;
};


export type MutationUpdateFacilityLocationArgs = {
  id: Scalars['ID'];
  input: CreateLocationInput;
};


export type MutationUpdateInpatientDepartmentArgs = {
  input: UpdateInpatientDepartmentInput;
};


export type MutationUpdateInpatientLocationArgs = {
  input: UpdateInpatientLocationInput;
};


export type MutationUpdateLotArgs = {
  input: UpdateLotInput;
};


export type MutationUpdateMyEpocusUserArgs = {
  input: UpdateMyEpocusUserInput;
};


export type MutationUpdateNonPharmaItemArgs = {
  input: UpdateNonPharmaItemInput;
};


export type MutationUpdateNonPharmaItemActivationArgs = {
  input: ProductActivationInput;
};


export type MutationUpdateOrganisationArgs = {
  organisation: UpdateOrganisationInput;
  uuid: Scalars['String'];
};


export type MutationUpdatePatientArgs = {
  canUpdateAcrossWholeTerritory?: InputMaybe<Scalars['Boolean']>;
  patient: UpdatePatientInput;
  uuid: Scalars['String'];
};


export type MutationUpdatePatientDiagnosesInLocationArgs = {
  input: UpdatePatientDiagnosesInLocationInput;
};


export type MutationUpdatePatientInsuranceDetailsArgs = {
  canUpdateAcrossWholeTerritory?: InputMaybe<Scalars['Boolean']>;
  input: UpdatePatientInsuranceDetailsInput;
};


export type MutationUpdatePatientTriageStatusArgs = {
  input: UpdatePatientTriageStatus;
};


export type MutationUpdateSkuArgs = {
  input: UpdateSkuInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserEnabledStateArgs = {
  input: UpdateUserEnabledStateInput;
};


export type MutationUpdateVmpArgs = {
  input: UpdateVmpInput;
};


export type MutationUpdateVmpActivationArgs = {
  input: ProductActivationInput;
};


export type MutationUpdateVtmArgs = {
  input: UpdateVtmInput;
};


export type MutationUpdateVtmActivationArgs = {
  input: ProductActivationInput;
};


export type MutationUpsertImagingStudyExternalDetailsArgs = {
  input: ImagingStudyExternalDetailsInput;
};


export type MutationUpsertUiDefaultArgs = {
  input: UpsertUiDefaultInput;
};


export type MutationVmpBulkUploadArgs = {
  input: BulkUploadInput;
};


export type MutationVoidInvoiceArgs = {
  input: VoidInvoiceInput;
};


export type MutationVtmBulkUploadArgs = {
  input: BulkUploadInput;
};

export type Name = {
  readonly __typename?: 'Name';
  readonly firstname?: Maybe<Scalars['String']>;
  readonly fullname?: Maybe<Scalars['String']>;
  readonly lastname?: Maybe<Scalars['String']>;
  readonly middlename?: Maybe<Scalars['String']>;
};

export type NationalIdMeta = {
  readonly __typename?: 'NationalIdMeta';
  readonly nationalIdOwner?: Maybe<NationalIdOwner>;
  readonly nationalIdType: NationalIdType;
};

export type NationalIdMetaInput = {
  readonly nationalIdOwner?: InputMaybe<NationalIdOwner>;
  readonly nationalIdType: NationalIdType;
};

export enum NationalIdOwner {
  Brother = 'brother',
  BrotherInLaw = 'brotherInLaw',
  Daughter = 'daughter',
  Father = 'father',
  FatherInLaw = 'fatherInLaw',
  Husband = 'husband',
  Mother = 'mother',
  MotherInLaw = 'motherInLaw',
  Other = 'other',
  Self = 'self',
  Sister = 'sister',
  SisterInLaw = 'sisterInLaw',
  Son = 'son',
  Wife = 'wife'
}

export enum NationalIdType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type NextOfKinInput = {
  readonly address?: InputMaybe<AddressInput>;
  readonly fullName?: InputMaybe<Scalars['String']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly relationship?: InputMaybe<Scalars['String']>;
};

export enum NigeriaDailyOutpatientAttendance {
  FollowUp = 'FOLLOW_UP',
  New = 'NEW'
}

export enum NigeriaDailyOutpatientGbvCase {
  Physical = 'PHYSICAL',
  Pyschological = 'PYSCHOLOGICAL',
  Sexual = 'SEXUAL'
}

export enum NigeriaDailyOutpatientHepatitisResult {
  NotTested = 'NOT_TESTED',
  TestedNegative = 'TESTED_NEGATIVE',
  TestedPositiveReferred = 'TESTED_POSITIVE_REFERRED',
  TestedPositiveTreated = 'TESTED_POSITIVE_TREATED'
}

export enum NigeriaDailyOutpatientMalariaDiagnosis {
  ClinicalDiagnosisOnly = 'CLINICAL_DIAGNOSIS_ONLY',
  MicroscopyNeg = 'MICROSCOPY_NEG',
  MicroscopyPos = 'MICROSCOPY_POS',
  RdtNeg = 'RDT_NEG',
  RdtPos = 'RDT_POS'
}

export enum NigeriaDailyOutpatientOutcome {
  NotTreated = 'NOT_TREATED',
  Referred = 'REFERRED',
  Treated = 'TREATED'
}

export enum NigeriaDailyOutpatientPreReferralTreatment {
  ImIvArtesunate = 'IM_IV_ARTESUNATE',
  IvArtesunate = 'IV_ARTESUNATE',
  No = 'NO',
  Other = 'OTHER'
}

export type NigeriaDailyOutpatientRegisterInput = {
  readonly filterOptions: FilterOptions;
  readonly paginationOptions?: InputMaybe<PaginationOptions>;
};

export type NigeriaDailyOutpatientRegisterRecord = {
  readonly __typename?: 'NigeriaDailyOutpatientRegisterRecord';
  readonly BMI?: Maybe<Scalars['Float']>;
  readonly actGiven?: Maybe<Scalars['Boolean']>;
  readonly attendanceType?: Maybe<NigeriaDailyOutpatientAttendance>;
  readonly date: Scalars['DateTime'];
  readonly diagnosis?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly drugsGiven?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly gbvCaseReferred?: Maybe<Scalars['Boolean']>;
  readonly gbvCaseSeen?: Maybe<ReadonlyArray<Maybe<NigeriaDailyOutpatientGbvCase>>>;
  readonly height?: Maybe<Scalars['Float']>;
  readonly hepatitisB?: Maybe<NigeriaDailyOutpatientHepatitisResult>;
  readonly hepatitisC?: Maybe<NigeriaDailyOutpatientHepatitisResult>;
  readonly id: Scalars['ID'];
  readonly investigationsCompleted?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly isPregnant?: Maybe<Scalars['Boolean']>;
  readonly malariaDiagnosis?: Maybe<NigeriaDailyOutpatientMalariaDiagnosis>;
  readonly otherAntimalarialGiven?: Maybe<Scalars['Boolean']>;
  readonly outcomeOfVisit?: Maybe<NigeriaDailyOutpatientOutcome>;
  readonly patient: Patient;
  readonly postGBVCareReceived?: Maybe<Scalars['Boolean']>;
  readonly preReferralTreatment?: Maybe<NigeriaDailyOutpatientPreReferralTreatment>;
  readonly presentingComplaint?: Maybe<Scalars['String']>;
  readonly severeMalaria?: Maybe<Scalars['Boolean']>;
  readonly tbClinicalScreeningForm?: Maybe<Scalars['Boolean']>;
  readonly tbClinicallyScreened?: Maybe<Scalars['Boolean']>;
  readonly tbReferred?: Maybe<Scalars['Boolean']>;
  readonly weight?: Maybe<Scalars['Float']>;
};

export type NigeriaGeneralAttendanceRegisterInput = {
  readonly filterOptions: FilterOptions;
  readonly paginationOptions?: InputMaybe<PaginationOptions>;
};

export type NigeriaGeneralAttendanceRegisterRecord = {
  readonly __typename?: 'NigeriaGeneralAttendanceRegisterRecord';
  readonly date: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly patient: PatientRegisterDetails;
};

export type NonPharmaCategory = {
  readonly __typename?: 'NonPharmaCategory';
  readonly id: Scalars['String'];
  readonly title: NonPharmaCategoryTitle;
};

export type NonPharmaCategoryTitle = {
  readonly __typename?: 'NonPharmaCategoryTitle';
  readonly en: Scalars['String'];
};

export type NonPharmaItem = ClinicalProduct & ClinicalProductInventorySummary & {
  readonly __typename?: 'NonPharmaItem';
  readonly brand?: Maybe<Scalars['String']>;
  readonly category: NonPharmaCategory;
  readonly id: Scalars['String'];
  readonly inventory: ExternalReferenceInventorySummary;
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly meta: ProductMeta;
  readonly productType: ProductType;
  readonly snomedId?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};


export type NonPharmaItemInventoryArgs = {
  input: ClinicalProductInventorySummaryInput;
};

export type NotificationBellState = {
  readonly __typename?: 'NotificationBellState';
  readonly id: Scalars['ID'];
  readonly lastBellOpenedAt?: Maybe<Scalars['DateTime']>;
  readonly lastMarkAllReadAt?: Maybe<Scalars['DateTime']>;
  readonly meta: SyncableMeta;
  readonly userId: Scalars['ID'];
};

export type NotificationBellStateInput = {
  readonly id: Scalars['ID'];
  readonly lastBellOpenedAt?: InputMaybe<Scalars['DateTime']>;
  readonly lastMarkAllReadAt?: InputMaybe<Scalars['DateTime']>;
  readonly meta: SyncableMetaInput;
  readonly userId: Scalars['ID'];
};

export type NotificationDismissal = {
  readonly __typename?: 'NotificationDismissal';
  readonly dismissedAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly meta: SyncableMeta;
  readonly userId: Scalars['ID'];
  readonly versionAtDismissal?: Maybe<Scalars['String']>;
};

export type NotificationDismissalInput = {
  readonly dismissedAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly key: Scalars['String'];
  readonly meta: SyncableMetaInput;
  readonly userId: Scalars['ID'];
  readonly versionAtDismissal?: InputMaybe<Scalars['String']>;
};

export type OngoingInpatientVisitsInput = {
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly patientUuid: Scalars['String'];
};

export type OperationalFormSchema = {
  readonly __typename?: 'OperationalFormSchema';
  readonly jsonSchemaReference?: Maybe<Scalars['String']>;
  readonly orderedProperties?: Maybe<ReadonlyArray<Maybe<Scalars['JSONObject']>>>;
  readonly type?: Maybe<Scalars['String']>;
};

export type OperationalFormWithValuesSchema = {
  readonly __typename?: 'OperationalFormWithValuesSchema';
  readonly orderedProperties?: Maybe<ReadonlyArray<Maybe<Scalars['JSONObject']>>>;
  readonly type?: Maybe<Scalars['String']>;
};

export type OperationalFormWithValuesSchemaInput = {
  readonly orderedProperties?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSONObject']>>>;
  readonly type?: InputMaybe<Scalars['String']>;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Organisation = {
  readonly __typename?: 'Organisation';
  readonly addresses?: Maybe<ReadonlyArray<Maybe<Address>>>;
  readonly name: Scalars['String'];
  readonly settings: OrganisationSettings;
  readonly uuid: Scalars['String'];
};

export type OrganisationInput = {
  readonly addresses?: InputMaybe<ReadonlyArray<InputMaybe<AddressInput>>>;
  readonly name: Scalars['String'];
  readonly settings?: InputMaybe<OrganisationSettingsInput>;
};

export type OrganisationSettings = {
  readonly __typename?: 'OrganisationSettings';
  readonly billingMode: BillingMode;
};

export type OrganisationSettingsInput = {
  readonly billingMode?: InputMaybe<BillingMode>;
};

export type OutpatientPrescription = {
  readonly __typename?: 'OutpatientPrescription';
  readonly administrationApproach: AdministrationApproach;
  readonly asRequired: Scalars['Boolean'];
  readonly clinicalEvent: ClinicalEvent;
  readonly clinicalProduct?: Maybe<PrescriptionClinicalProduct>;
  readonly createdAt: Scalars['DateTime'];
  readonly dispensations: InpatientPrescriptionDispensationsPage;
  readonly dosage: DoseMeasurement;
  readonly facilityId: Scalars['String'];
  readonly frequency: Frequency;
  readonly id: Scalars['ID'];
  readonly note?: Maybe<Scalars['String']>;
  readonly patientId: Scalars['String'];
  readonly prescriber: User;
  readonly rate: RateMeasurement;
  readonly startsAt: Scalars['DateTime'];
  readonly status: PrescriptionStatus;
  readonly stopsAt: Scalars['DateTime'];
};


export type OutpatientPrescriptionDispensationsArgs = {
  options?: InputMaybe<InpatientPrescriptionDispensationsOptions>;
};

export type OutpatientPrescriptionInput = {
  readonly asRequired?: InputMaybe<Scalars['Boolean']>;
  readonly clinicalEventRef: ClinicalEventRefInput;
  readonly clinicalProductRef?: InputMaybe<ClinicalProductRefInput>;
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly doseMeasurement: DoseMeasurementInput;
  readonly facilityId: Scalars['String'];
  readonly frequency: FrequencyInput;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly patientId: Scalars['String'];
  readonly rateMeasurement: RateMeasurementInput;
};

export type PaginatedChildImmunisationRegister = {
  readonly __typename?: 'PaginatedChildImmunisationRegister';
  readonly limit?: Maybe<Scalars['Int']>;
  readonly nextPage?: Maybe<Scalars['Boolean']>;
  readonly offset?: Maybe<Scalars['Int']>;
  readonly records?: Maybe<ReadonlyArray<Maybe<ChildImmunisationRegisterRecord>>>;
  readonly total?: Maybe<Scalars['Int']>;
};

export type PaginatedDepartment = PaginatedResult & {
  readonly __typename?: 'PaginatedDepartment';
  readonly limit?: Maybe<Scalars['Int']>;
  readonly list: ReadonlyArray<Maybe<Department>>;
  readonly offset?: Maybe<Scalars['Int']>;
  readonly total?: Maybe<Scalars['Int']>;
};

export type PaginatedInput = {
  readonly limit?: InputMaybe<Scalars['Int']>;
  readonly offset?: InputMaybe<Scalars['Int']>;
};

export type PaginatedNigeriaDailyOutpatientRegister = {
  readonly __typename?: 'PaginatedNigeriaDailyOutpatientRegister';
  readonly limit?: Maybe<Scalars['Int']>;
  readonly offset?: Maybe<Scalars['Int']>;
  readonly records?: Maybe<ReadonlyArray<Maybe<NigeriaDailyOutpatientRegisterRecord>>>;
  readonly total?: Maybe<Scalars['Int']>;
};

export type PaginatedNigeriaGeneralAttendanceRegister = {
  readonly __typename?: 'PaginatedNigeriaGeneralAttendanceRegister';
  readonly limit?: Maybe<Scalars['Int']>;
  readonly offset?: Maybe<Scalars['Int']>;
  readonly records?: Maybe<ReadonlyArray<Maybe<NigeriaGeneralAttendanceRegisterRecord>>>;
  readonly total?: Maybe<Scalars['Int']>;
};

export type PaginatedRegisterRecord = {
  readonly __typename?: 'PaginatedRegisterRecord';
  readonly limit?: Maybe<Scalars['Int']>;
  readonly offset?: Maybe<Scalars['Int']>;
  readonly records?: Maybe<ReadonlyArray<Maybe<RegisterRecord>>>;
  readonly total?: Maybe<Scalars['Int']>;
};

export type PaginatedResult = {
  readonly limit?: Maybe<Scalars['Int']>;
  readonly offset?: Maybe<Scalars['Int']>;
  readonly total?: Maybe<Scalars['Int']>;
};

export type PaginatedVisits = {
  readonly __typename?: 'PaginatedVisits';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<Visit>>;
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type PaginationInput = {
  readonly limit?: InputMaybe<Scalars['Int']>;
  readonly offset?: InputMaybe<Scalars['Int']>;
};

export type PaginationOptions = {
  readonly limit?: InputMaybe<Scalars['Int']>;
  readonly offset?: InputMaybe<Scalars['Int']>;
};

/**
 * A "virtual card", created only at time of it being registered to a patient.
 * These may be printed out or patients may take a photo of the QR
 * code for use as they would a physical Card.
 */
export type Passport = {
  readonly __typename?: 'Passport';
  /** The database ID of the Passport. */
  readonly _id: Scalars['ID'];
  /**
   * Code that Patients can use, having scanned the QR code at home, to sign into
   * their medical records. For "security", this is not stored in the DB and is available
   * only at time of creation the first time this entity is returned.
   *
   * Unlike Cards, this is necessary because there is no physical card pre-printed with a known
   * CVV that can be used to authenticate the patient.
   */
  readonly pin: Scalars['String'];
  /**
   * A link used to create a QR code that Patients can scan at home to access their medical records.
   * Contains the <uid> within the URL.
   */
  readonly qrcode: Scalars['String'];
  /** The 12 digit card ID presented to the User. */
  readonly uid: Scalars['String'];
};

export type PastInpatientVisitsInput = {
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly patientUuid?: InputMaybe<Scalars['String']>;
};

export type Patient = {
  readonly __typename?: 'Patient';
  /** @deprecated Use id */
  readonly _id: Scalars['ID'];
  /** @deprecated Use AddedToQueueAt */
  readonly addedAt?: Maybe<Scalars['DateTime']>;
  readonly addedToQueueAt?: Maybe<Scalars['DateTime']>;
  readonly card?: Maybe<PatientCard>;
  /** @deprecated Use card.id */
  readonly cardId?: Maybe<Scalars['String']>;
  readonly clinic: Scalars['String'];
  readonly conditions?: Maybe<ReadonlyArray<Maybe<Condition>>>;
  readonly consent: Consent;
  readonly consultations?: Maybe<ReadonlyArray<Maybe<Consultation>>>;
  readonly currentVisit?: Maybe<Visit>;
  readonly dob?: Maybe<Scalars['Date']>;
  readonly education?: Maybe<Education>;
  readonly fullname?: Maybe<Scalars['String']>;
  readonly gender?: Maybe<Gender>;
  readonly guardians?: Maybe<ReadonlyArray<Guardian>>;
  readonly healthPay: HealthPay;
  /**
   * In the past Patient had two ids. _id and uuid. For reasons uuid was chosen as the
   * id going forward for this entity. When you're migrating onto id, be sure your code was
   * expecting uuid and not _id else your feature will break. Once every usage of _id and uuid has
   * been migrated, they and this comment can be deleted as callers should no longer care about this
   * distinction.
   */
  readonly id: Scalars['ID'];
  readonly insurance?: Maybe<Insurance>;
  readonly meta?: Maybe<Meta>;
  readonly newToClinic?: Maybe<Scalars['String']>;
  readonly organisation: Scalars['String'];
  readonly passport?: Maybe<Passport>;
  readonly patientHasInsurance?: Maybe<PatientHasInsurance>;
  readonly person: Person;
  readonly recorder: Scalars['String'];
  readonly registrationPayment: RegistrationPaymentOverview;
  readonly triageStatus?: Maybe<TriageStatusOfQueue>;
  /** @deprecated Use id */
  readonly uuid: Scalars['ID'];
};

export type PatientAndPassport = {
  readonly __typename?: 'PatientAndPassport';
  readonly passport: Passport;
  readonly patient: Patient;
};

export type PatientByCardIdResult = {
  readonly __typename?: 'PatientByCardIdResult';
  readonly passportId?: Maybe<Scalars['String']>;
  readonly patient: Patient;
};

export type PatientByPassportInput = {
  /** Elephant card id or passport id */
  readonly id: Scalars['String'];
  /** @deprecated Inter org is rolled out for all */
  readonly searchWholeTerritory?: InputMaybe<Scalars['Boolean']>;
};

/** A physical, pre-printed card given to patients. */
export type PatientCard = {
  readonly __typename?: 'PatientCard';
  /** The 12 digit card ID printed on the card. */
  readonly id?: Maybe<Scalars['String']>;
  /**
   * The URL contained within the QR code on the printed card that Patients can scan at home
   * to access their medical records.
   */
  readonly url?: Maybe<Scalars['String']>;
  /** Whether the card has been voided. Contains the date of voiding. */
  readonly voided?: Maybe<CardVoided>;
};

export type PatientDetailsPhoneNumber = {
  readonly __typename?: 'PatientDetailsPhoneNumber';
  readonly ownership?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['String']>;
};

export type PatientDiseaseResponse = {
  readonly __typename?: 'PatientDiseaseResponse';
  readonly diseases: ReadonlyArray<DiseaseEntry>;
  readonly facilityId: Scalars['ID'];
  readonly patientId: Scalars['ID'];
};

export type PatientDiseasesInput = {
  readonly diseaseCodes: ReadonlyArray<Scalars['String']>;
  readonly endDate: Scalars['DateTime'];
  readonly facilityId: Scalars['ID'];
  readonly paginationOptions: PaginationOptions;
  readonly startDate: Scalars['DateTime'];
};

export enum PatientHasInsurance {
  No = 'NO',
  Unknown = 'UNKNOWN',
  Yes = 'YES'
}

export type PatientInput = {
  /** @deprecated Use `consent.accessToHealthRecords` instead. */
  readonly accessToHealthRecords?: InputMaybe<Scalars['Boolean']>;
  readonly address: AddressInput;
  /** @deprecated No longer used. */
  readonly cardDetails?: InputMaybe<CardDetailsInput>;
  readonly consent?: InputMaybe<ConsentInput>;
  readonly dob: Scalars['PastDate'];
  readonly education: EducationInput;
  readonly firstName: Scalars['String'];
  readonly gender: Gender;
  readonly insurance?: InputMaybe<InsuranceInput>;
  readonly isNew: Scalars['Boolean'];
  readonly lastName: Scalars['String'];
  readonly locale?: InputMaybe<Scalars['String']>;
  readonly maritalStatus?: InputMaybe<MaritalStatus>;
  readonly middleName?: InputMaybe<Scalars['String']>;
  readonly nationalIdMeta?: InputMaybe<NationalIdMetaInput>;
  readonly nationalIdNumber?: InputMaybe<Scalars['String']>;
  readonly nationality: Scalars['String'];
  readonly nextOfKin?: InputMaybe<NextOfKinInput>;
  /** @deprecated Use `insurance` instead to decide if patient has insurance. */
  readonly patientHasInsurance?: InputMaybe<PatientHasInsurance>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly phoneOwnership?: InputMaybe<ContactPointOwnership>;
};

export type PatientInsuranceVisitValidation = {
  readonly __typename?: 'PatientInsuranceVisitValidation';
  readonly expiryStrategy?: Maybe<Scalars['String']>;
};

export type PatientInvestigationValue = {
  readonly __typename?: 'PatientInvestigationValue';
  readonly id: Scalars['ID'];
  readonly items: ReadonlyArray<Maybe<InvestigationValueItem>>;
};

export type PatientInvestigationValuesOptions = {
  readonly endDate?: InputMaybe<Scalars['String']>;
  readonly startDate?: InputMaybe<Scalars['String']>;
};

export type PatientInvestigationValuesParams = {
  readonly loincCode: Scalars['String'];
  /** @deprecated This is using the legacy _id. Use patientUuid instead */
  readonly patientId?: InputMaybe<Scalars['ID']>;
  readonly patientUuid?: InputMaybe<Scalars['ID']>;
};

export type PatientNotFoundError = BaseError & {
  readonly __typename?: 'PatientNotFoundError';
  readonly message: Scalars['String'];
  readonly path: ReadonlyArray<Scalars['String']>;
};

export type PatientOfQueue = {
  readonly __typename?: 'PatientOfQueue';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly addedAt: Scalars['DateTime'];
  readonly dob?: Maybe<Scalars['Date']>;
  readonly fullname: Scalars['String'];
  readonly gender: Gender;
  /** @deprecated No longer supplied a value */
  readonly triageStatus?: Maybe<TriageStatusOfQueue>;
  readonly uuid: Scalars['ID'];
};

export type PatientQueryFilters = {
  readonly searchWholeTerritory?: InputMaybe<Scalars['Boolean']>;
};

export type PatientQueue = {
  readonly __typename?: 'PatientQueue';
  readonly _id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly patients: ReadonlyArray<Maybe<PatientOfQueue>>;
  readonly patientsWIP: ReadonlyArray<Maybe<Patient>>;
};

export type PatientQueueDeleteResult = {
  readonly __typename?: 'PatientQueueDeleteResult';
  readonly _id: Scalars['ID'];
  readonly deletionSuccess: Scalars['Boolean'];
  readonly message?: Maybe<Scalars['String']>;
};

export type PatientRegisterDetails = {
  readonly __typename?: 'PatientRegisterDetails';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly address?: Maybe<Address>;
  readonly cardId?: Maybe<Scalars['String']>;
  readonly dateOfBirth?: Maybe<Scalars['DateTime']>;
  readonly firstContact?: Maybe<Scalars['Boolean']>;
  readonly gender?: Maybe<Gender>;
  readonly name?: Maybe<Scalars['String']>;
  readonly nextOfKinAddress?: Maybe<Address>;
  readonly nextOfKinName?: Maybe<Scalars['String']>;
  readonly nextOfKinPhoneNumber?: Maybe<Scalars['String']>;
  readonly nextOfKinRelationship?: Maybe<Scalars['String']>;
  readonly patientUuid?: Maybe<Scalars['ID']>;
  readonly phoneNumber?: Maybe<PatientDetailsPhoneNumber>;
};

export type PatientRegisterDispensation = {
  readonly __typename?: 'PatientRegisterDispensation';
  readonly quantity?: Maybe<Scalars['Float']>;
};

export type PatientRegisterDose = {
  readonly __typename?: 'PatientRegisterDose';
  readonly asNeeded?: Maybe<Scalars['Boolean']>;
  readonly doseQuantity?: Maybe<PatientRegisterRate>;
  readonly durationQuantity?: Maybe<PatientRegisterRate>;
  readonly rateQuantity?: Maybe<PatientRegisterRate>;
};

export type PatientRegisterMedication = {
  readonly __typename?: 'PatientRegisterMedication';
  readonly name?: Maybe<Scalars['String']>;
};

export type PatientRegisterRate = {
  readonly __typename?: 'PatientRegisterRate';
  readonly unit?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['Float']>;
};

export type PatientSyncPushInput = {
  readonly address: SyncablePatientAddressInput;
  /** @deprecated Assigning a card via the patient is no longer supported. */
  readonly card?: InputMaybe<SyncablePatientCardInput>;
  readonly consent?: InputMaybe<ConsentInput>;
  readonly dob: Scalars['Date'];
  readonly education?: InputMaybe<EducationInput>;
  readonly facilityId: Scalars['String'];
  readonly gender: Gender;
  readonly guardians?: InputMaybe<ReadonlyArray<GuardianInput>>;
  readonly id: Scalars['ID'];
  readonly insurance?: InputMaybe<InsuranceInput>;
  readonly maritalStatus?: InputMaybe<SyncablePatientMaritalStatus>;
  readonly meta: SyncableMetaInput;
  readonly name: SyncablePatientNameInput;
  readonly nationalId?: InputMaybe<SyncablePatientNationalIdInput>;
  readonly nationality: Scalars['String'];
  readonly newToFacility: Scalars['Boolean'];
  readonly nextOfKin?: InputMaybe<SyncablePatientNextOfKinInput>;
  readonly organisationId: Scalars['String'];
  readonly phone?: InputMaybe<SyncablePatientPhoneInput>;
  readonly registrationFee?: InputMaybe<SyncablePatientRegistrationFeeInput>;
};

export type PatientSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<PatientSyncPushInput>;
  readonly newDocumentState: PatientSyncPushInput;
};

export type PatientTriageStatusInput = {
  readonly patientUuid: Scalars['ID'];
};

export enum PatientType {
  Inpatient = 'Inpatient',
  Outpatient = 'Outpatient'
}

export type PatientsExportInput = {
  readonly options: PatientsExportOptions;
  readonly params: PatientsExportParams;
};

export type PatientsExportOptions = {
  readonly clinicUuids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly organisationUuid: Scalars['ID'];
};

export type PatientsExportPage = {
  readonly __typename?: 'PatientsExportPage';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<Patient>>;
  readonly total: Scalars['Int'];
};

export type PatientsExportParams = {
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
};

export type Payer = {
  readonly __typename?: 'Payer';
  readonly balance: Balance;
  readonly id?: Maybe<Scalars['ID']>;
  readonly insuranceDetails?: Maybe<InsuranceDetails>;
  readonly name: Scalars['String'];
  readonly type: PayerType;
};

export type PayerInput = {
  readonly balance: BalanceInput;
  readonly insuranceDetails?: InputMaybe<InsuranceDetailsInput>;
  readonly name: Scalars['String'];
  readonly type: PayerType;
};

export enum PayerType {
  Exempt = 'EXEMPT',
  Insurer = 'INSURER',
  Patient = 'PATIENT',
  Void = 'VOID',
  Waiver = 'WAIVER'
}

export type PayersTariff = {
  readonly __typename?: 'PayersTariff';
  readonly amountInPence?: Maybe<Scalars['Int']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly revenueDepartment?: Maybe<Scalars['String']>;
  readonly tariffId?: Maybe<Scalars['String']>;
};

export type Payment = {
  readonly __typename?: 'Payment';
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly origin: PaymentOrigin;
  readonly paidOn: Scalars['Date'];
  readonly updatedAt: Scalars['DateTime'];
};

export type PaymentDetails = {
  readonly __typename?: 'PaymentDetails';
  readonly amount: Amount;
  readonly authCode?: Maybe<Scalars['String']>;
  readonly paymentMethod: PaymentMethod;
  readonly timestamp?: Maybe<Scalars['DateTime']>;
};

export type PaymentDetailsInput = {
  readonly amount: AmountInput;
  readonly authCode?: InputMaybe<Scalars['String']>;
  readonly paymentMethod: PaymentMethod;
};

export enum PaymentMethod {
  Cash = 'CASH',
  Mpesa = 'MPESA',
  Other = 'OTHER',
  Void = 'VOID'
}

export enum PaymentOrigin {
  Registration = 'REGISTRATION',
  Renewal = 'RENEWAL'
}

export enum PaymentStatus {
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type Person = {
  readonly __typename?: 'Person';
  readonly addresses: ReadonlyArray<Maybe<Address>>;
  readonly contactPoints: ReadonlyArray<Maybe<ContactPoint>>;
  readonly contacts: ReadonlyArray<Maybe<Contact>>;
  readonly dob: Scalars['Date'];
  readonly gender: Gender;
  readonly languages: ReadonlyArray<Maybe<Language>>;
  readonly maritalStatus?: Maybe<MaritalStatus>;
  readonly name: Name;
  readonly nationalIdMeta?: Maybe<NationalIdMeta>;
  readonly nationalIdNumber?: Maybe<Scalars['String']>;
  readonly nationality?: Maybe<Scalars['String']>;
};

export type PersonInput = {
  readonly dob?: InputMaybe<Scalars['Date']>;
  readonly firstname?: InputMaybe<Scalars['String']>;
  readonly gender?: InputMaybe<Gender>;
  readonly languages?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly lastname?: InputMaybe<Scalars['String']>;
  readonly middlename?: InputMaybe<Scalars['String']>;
  readonly telephone?: InputMaybe<Scalars['String']>;
  readonly whatsappConsent?: InputMaybe<Scalars['Boolean']>;
};

export enum PrescribableItemType {
  ClinicalProduct = 'CLINICAL_PRODUCT',
  FreeText = 'FREE_TEXT'
}

export type Prescription = {
  readonly __typename?: 'Prescription';
  readonly clinician?: Maybe<User>;
  /** Either holds a long form name of the medication OR the free-text entered by the user. */
  readonly codification?: Maybe<Scalars['String']>;
  readonly dispensation?: Maybe<Dispense>;
  readonly dose?: Maybe<Dose>;
  /** @deprecated Legacy field */
  readonly encounter?: Maybe<Scalars['String']>;
  /** The legacy medication's uuid OR null for non free-text prescriptions. */
  readonly medication?: Maybe<Medication>;
  readonly note?: Maybe<Scalars['String']>;
  readonly uuid?: Maybe<Scalars['String']>;
};

export type PrescriptionClinicalProduct = Amp | Vmp;

export type PrescriptionConnection = {
  readonly __typename?: 'PrescriptionConnection';
  readonly edges: ReadonlyArray<PrescriptionEdge>;
};

export type PrescriptionDispensed = CareActivity & {
  readonly __typename?: 'PrescriptionDispensed';
  readonly _id: Scalars['ID'];
  readonly careActivity?: Maybe<PrescriptionDispensedDetails>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly type: Scalars['String'];
};

export type PrescriptionDispensedDetails = {
  readonly __typename?: 'PrescriptionDispensedDetails';
  readonly consultationId?: Maybe<Scalars['ID']>;
  readonly createdOn?: Maybe<Scalars['DateTime']>;
  readonly dispensation?: Maybe<PatientRegisterDispensation>;
  readonly dose?: Maybe<PatientRegisterDose>;
  readonly id?: Maybe<Scalars['ID']>;
  readonly medication?: Maybe<PatientRegisterMedication>;
};

export type PrescriptionEdge = {
  readonly __typename?: 'PrescriptionEdge';
  readonly cursor: Scalars['ID'];
  readonly node: InpatientPrescription;
};

export type PrescriptionInput = {
  readonly codification?: InputMaybe<Scalars['String']>;
  readonly created?: InputMaybe<Scalars['DateTime']>;
  readonly dose: DoseInput;
  readonly medication?: InputMaybe<Scalars['ID']>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Float']>;
};

export type PrescriptionIssued = CareActivity & {
  readonly __typename?: 'PrescriptionIssued';
  readonly _id: Scalars['ID'];
  readonly careActivity?: Maybe<PrescriptionIssuedDetails>;
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly type: Scalars['String'];
};

export type PrescriptionIssuedDetails = {
  readonly __typename?: 'PrescriptionIssuedDetails';
  readonly consultationId?: Maybe<Scalars['ID']>;
  readonly createdOn?: Maybe<Scalars['DateTime']>;
  readonly dose?: Maybe<PatientRegisterDose>;
  readonly id?: Maybe<Scalars['ID']>;
  readonly medication?: Maybe<PatientRegisterMedication>;
};

export enum PrescriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED'
}

export type PrescriptionSyncPushInput = {
  readonly administrationApproach: AdministrationApproach;
  readonly clinicalEvent: ClinicalEventRefInput;
  readonly clinicalProduct?: InputMaybe<ClinicalProductRefInput>;
  readonly dosage: DoseMeasurementInput;
  readonly facilityId: Scalars['ID'];
  readonly frequency: FrequencyInput;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMetaInput;
  readonly minimumDoseInterval?: InputMaybe<MinimumDoseIntervalInput>;
  readonly note?: InputMaybe<Scalars['String']>;
  readonly patientId: Scalars['ID'];
  readonly prescribableItemFreeText?: InputMaybe<Scalars['String']>;
  readonly prescribableItemType: PrescribableItemType;
  readonly prescribedByUserId: Scalars['ID'];
  readonly rate?: InputMaybe<RateMeasurementInput>;
  readonly startsAt: Scalars['DateTime'];
  readonly stopsAt: Scalars['DateTime'];
};

export type PrescriptionSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<PrescriptionSyncPushInput>;
  readonly newDocumentState: PrescriptionSyncPushInput;
};

export type PrescriptionsResponse = {
  readonly __typename?: 'PrescriptionsResponse';
  readonly prescriptions: ReadonlyArray<InpatientPrescription>;
};

export type PriceAcknowledgementSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<SyncablePriceAcknowledgementInput>;
  readonly newDocumentState: SyncablePriceAcknowledgementInput;
};

export type PriceBulkDownloadInput = {
  readonly priceListId: Scalars['ID'];
};

export type PriceBulkUploadInput = {
  readonly csv: Scalars['String'];
  readonly priceListId: Scalars['ID'];
};

export type PriceListItem = {
  readonly __typename?: 'PriceListItem';
  readonly activeTariffId?: Maybe<Scalars['String']>;
  /** @deprecated replaced by activeTariffId */
  readonly activeTariffName?: Maybe<Scalars['String']>;
  readonly code?: Maybe<Scalars['String']>;
  readonly cost: Scalars['Int'];
  readonly currency: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly payers: ReadonlyArray<PayersTariff>;
  readonly priceListItemType: PriceListItemType;
  /** @deprecated Use revenueDepartmentId */
  readonly revenueDepartment: Scalars['String'];
  readonly revenueDepartmentId: Scalars['ID'];
  /** @deprecated Use id */
  readonly uuid?: Maybe<Scalars['String']>;
};

export enum PriceListItemType {
  Admin = 'Admin',
  Consultation = 'Consultation',
  Investigation = 'Investigation',
  Other = 'Other',
  Prescription = 'Prescription',
  Procedure = 'Procedure'
}

export type PriceListItemV2Input = {
  readonly activeTariffId: Scalars['String'];
  readonly foreignId: Scalars['ID'];
  readonly origin: PriceableItemOrigin;
  readonly revenueDepartment: Scalars['String'];
};

export type PriceListItemsInput = {
  /**
   * Include inactive prices. Defaults to false to preserve existing behaviour
   * (invoicing and other callers expect active-only). The price-list admin UI
   * sets this to true so users can re-activate previously deactivated prices.
   */
  readonly includeInactive?: InputMaybe<Scalars['Boolean']>;
  /** Restrict results to these item categories. Empty/null returns all categories. */
  readonly origins?: InputMaybe<ReadonlyArray<PriceableItemOrigin>>;
  readonly priceListId: Scalars['ID'];
  /**
   * Restrict to items with at least one price updated strictly after this
   * timestamp; the per-item prices[] is also limited to that window. Drives
   * the PNE-258 price-list review screen: facility admins see only what's
   * moved since their last priceAcknowledgement.
   */
  readonly pricesUpdatedSince?: InputMaybe<Scalars['DateTime']>;
  /** Case-insensitive substring match on item name. */
  readonly searchTerm?: InputMaybe<Scalars['String']>;
};

export type PriceListItemsOptions = {
  readonly orderBy?: InputMaybe<PriceListItemsOrderBy>;
  readonly orderDirection?: InputMaybe<OrderDirection>;
  readonly pagination?: InputMaybe<PriceListPaginationInput>;
};

/**
 * The property to sort items by. Pairs with orderDirection; together they
 * follow the convention established by api-inventory's
 * InventoryMoveRequestsOptions.
 */
export enum PriceListItemsOrderBy {
  /**
   * The most recent updatedAt across the item's prices. Pairs with
   * pricesUpdatedSince for the review screen (DESC).
   */
  MostRecentPriceUpdate = 'MOST_RECENT_PRICE_UPDATE',
  /**
   * Item name. Default — preserves existing behaviour when callers omit
   * orderBy / orderDirection.
   */
  Name = 'NAME'
}

export type PriceListMeta = {
  readonly __typename?: 'PriceListMeta';
  readonly facilityId?: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly linkedPriceListId?: Maybe<Scalars['ID']>;
  readonly linkedToOrganisation?: Maybe<Scalars['Boolean']>;
  readonly organisationId: Scalars['ID'];
};

export type PriceListMetaInput = {
  readonly facilityId?: InputMaybe<Scalars['ID']>;
};

export type PriceListPaginationInput = {
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export type PriceListV2Mutations = {
  readonly __typename?: 'PriceListV2Mutations';
  readonly connectOrganisationPriceList: ConnectOrganisationPriceListResponse;
  readonly createCustomItems: CreateCustomItemsResponse;
  readonly createPriceList: CreatePriceListResponse;
  readonly disconnectFromOrganisationPriceList: DisconnectOrganisationPriceListResponse;
  readonly priceBulkUpload: BulkUploadResult;
  readonly setPrices: SetPricesResponse;
  readonly upsertPricesAndPriceableItems: UpsertPricesAndPriceableItemsResponse;
};


export type PriceListV2MutationsConnectOrganisationPriceListArgs = {
  input: ConnectOrganisationPriceListInput;
};


export type PriceListV2MutationsCreateCustomItemsArgs = {
  input: CreateCustomItemsInput;
};


export type PriceListV2MutationsCreatePriceListArgs = {
  input: CreatePriceListInput;
};


export type PriceListV2MutationsDisconnectFromOrganisationPriceListArgs = {
  input: DisconnectOrganisationPriceListInput;
};


export type PriceListV2MutationsPriceBulkUploadArgs = {
  input: PriceBulkUploadInput;
};


export type PriceListV2MutationsSetPricesArgs = {
  input: SetPricesInput;
};


export type PriceListV2MutationsUpsertPricesAndPriceableItemsArgs = {
  input: UpsertPricesAndPriceableItemsInput;
};

export type PriceListV2Queries = {
  readonly __typename?: 'PriceListV2Queries';
  readonly customItems: CustomItemsResponse;
  readonly effectivePricesByReference?: Maybe<PriceableItem>;
  readonly priceBulkDownload: BulkDownloadResult;
  readonly priceListItems: PriceableItemConnection;
  readonly priceListMeta?: Maybe<PriceListMeta>;
  readonly priceTariffs: PriceTariffsConnection;
  readonly priceableItems: PriceableItemsResponse;
  readonly revenueDepartments: RevenueDepartmentsConnection;
  readonly validatePriceBulkUpload: BulkUploadValidationResult;
};


export type PriceListV2QueriesCustomItemsArgs = {
  input: CustomItemsInput;
};


export type PriceListV2QueriesEffectivePricesByReferenceArgs = {
  input: PricesByReferenceInput;
};


export type PriceListV2QueriesPriceBulkDownloadArgs = {
  input: PriceBulkDownloadInput;
};


export type PriceListV2QueriesPriceListItemsArgs = {
  input: PriceListItemsInput;
  options?: InputMaybe<PriceListItemsOptions>;
};


export type PriceListV2QueriesPriceListMetaArgs = {
  input: PriceListMetaInput;
};


export type PriceListV2QueriesPriceableItemsArgs = {
  input: PriceableItemsInput;
};


export type PriceListV2QueriesValidatePriceBulkUploadArgs = {
  input: PriceBulkUploadInput;
};

export type PriceTariff = {
  readonly __typename?: 'PriceTariff';
  readonly externalReference?: Maybe<PriceTariffExternalReference>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type PriceTariffExternalReference = {
  readonly __typename?: 'PriceTariffExternalReference';
  readonly foreignId: Scalars['ID'];
  readonly origin: PriceTariffExternalReferenceOrigin;
};

export enum PriceTariffExternalReferenceOrigin {
  InsuranceProvider = 'INSURANCE_PROVIDER'
}

export type PriceTariffsConnection = {
  readonly __typename?: 'PriceTariffsConnection';
  readonly edges: ReadonlyArray<PriceTariff>;
};

export type PriceableItem = {
  readonly __typename?: 'PriceableItem';
  readonly externalReference: PriceableItemExternalReference;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly prices: ReadonlyArray<ItemPrice>;
};

export type PriceableItemConnection = {
  readonly __typename?: 'PriceableItemConnection';
  readonly edges: ReadonlyArray<PriceableItem>;
  readonly id: Scalars['ID'];
  readonly meta: PriceListMeta;
  readonly pageInfo: PriceableItemConnectionPageInfo;
};

export type PriceableItemConnectionPageInfo = {
  readonly __typename?: 'PriceableItemConnectionPageInfo';
  readonly pageNumber: Scalars['Int'];
  readonly pageSize: Scalars['Int'];
  readonly totalRows: Scalars['Int'];
};

export type PriceableItemExternalReference = {
  readonly __typename?: 'PriceableItemExternalReference';
  readonly foreignId: Scalars['ID'];
  readonly origin: PriceableItemOrigin;
};

export type PriceableItemExternalReferenceInput = {
  readonly foreignId: Scalars['ID'];
  readonly origin: PriceableItemOrigin;
};

export enum PriceableItemLanguage {
  EnGb = 'EN_GB'
}

export enum PriceableItemOrigin {
  Custom = 'CUSTOM',
  General = 'GENERAL',
  Inventory = 'INVENTORY',
  Investigation = 'INVESTIGATION',
  NonPharma = 'NON_PHARMA',
  Procedure = 'PROCEDURE'
}

export type PriceableItemsInput = {
  readonly itemType: PriceableItemOrigin;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type PriceableItemsResponse = {
  readonly __typename?: 'PriceableItemsResponse';
  readonly priceableItems: ReadonlyArray<Maybe<PriceableItem>>;
};

export type PricesByReferenceInput = {
  readonly facilityId: Scalars['ID'];
  readonly foreignId: Scalars['ID'];
  readonly origin: PriceableItemOrigin;
};

export enum ProcessingStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Unprocessed = 'UNPROCESSED'
}

export type ProductActivationInput = {
  readonly active: Scalars['Boolean'];
  readonly id: Scalars['String'];
};

export type ProductIdInput = {
  readonly id: Scalars['String'];
};

export type ProductMeta = {
  readonly __typename?: 'ProductMeta';
  readonly active: Scalars['Boolean'];
  readonly created: Scalars['String'];
  readonly updated: Scalars['String'];
};

export type ProductSearchInput = {
  readonly active?: InputMaybe<Scalars['Boolean']>;
  readonly productTypes?: InputMaybe<ReadonlyArray<SearchProductType>>;
  readonly searchTerm: Scalars['String'];
  readonly size?: InputMaybe<Scalars['Int']>;
};

export type ProductSearchResult = ClinicalProduct & {
  readonly __typename?: 'ProductSearchResult';
  readonly id: Scalars['String'];
  readonly inventory: ExternalReferenceInventorySummary;
  readonly meta: ProductMeta;
  readonly parentId?: Maybe<Scalars['String']>;
  readonly productType: ProductType;
  readonly title: Scalars['String'];
};


export type ProductSearchResultInventoryArgs = {
  input: ClinicalProductInventorySummaryInput;
};

export enum ProductType {
  Amp = 'amp',
  NonPharma = 'non_pharma',
  Vmp = 'vmp',
  Vtm = 'vtm'
}

export type ProvisionEpocusProgramMemberInput = {
  /**
   * If an EpocusUser already exists for this email (compared lowercased) no
   * login is minted and no invite sent: they are added to the program and the
   * membership comes back with existingUser: true.
   */
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly programId: Scalars['ID'];
  readonly role: EpocusRole;
  readonly telephone?: InputMaybe<Scalars['String']>;
};

export type ProvisionEpocusUserInput = {
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  /**
   * The role this account is being provisioned FOR. No membership is created
   * here, so nothing program-scoped opens up. It is not inert, though: in a
   * dual-mode deployment the principal is minted with the matching ElephantOS
   * role, which the PNE-595 bridge reads as this ePOCUS role until a membership
   * displaces it. Pass the role the person is actually being onboarded for.
   */
  readonly role: EpocusRole;
  readonly telephone?: InputMaybe<Scalars['String']>;
};

export type PullAmpInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullAmpResponse = {
  readonly __typename?: 'PullAmpResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableAmp>;
};

export type PullClinicInsuranceInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullClinicInsuranceResponse = {
  readonly __typename?: 'PullClinicInsuranceResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableClinicInsurance>;
};

export type PullClinicalProductCategoryInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullClinicalProductCategoryResponse = {
  readonly __typename?: 'PullClinicalProductCategoryResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableClinicalProductCategory>;
};

export type PullClinicalProductFormInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullClinicalProductFormResponse = {
  readonly __typename?: 'PullClinicalProductFormResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableClinicalProductForm>;
};

export type PullConsultationFilters = {
  readonly patientId: Scalars['ID'];
};

export type PullConsultationInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullConsultationFilters;
  readonly limit: Scalars['Int'];
};

export type PullConsultationResponse = {
  readonly __typename?: 'PullConsultationResponse';
  /** @deprecated Checkpointing handled by FE */
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableConsultation>;
};

export type PullDiseaseInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullDiseaseResponse = {
  readonly __typename?: 'PullDiseaseResponse';
  /** @deprecated Checkpointing handled by FE */
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableDisease>;
};

export type PullDispensationFilters = {
  readonly patientId: Scalars['ID'];
};

export type PullDispensationInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullDispensationFilters;
  readonly limit: Scalars['Int'];
};

export type PullDispensationResponse = {
  readonly __typename?: 'PullDispensationResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableDispensation>;
};

export type PullEpocusBillingFilters = {
  readonly encounterId: Scalars['ID'];
};

export type PullEpocusBillingInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullEpocusBillingFilters;
  readonly limit: Scalars['Int'];
};

export type PullEpocusBillingResult = {
  readonly __typename?: 'PullEpocusBillingResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusBilling>;
};

export type PullEpocusBillingStatusFilters = {
  /**
   * Only this performer's studies, wherever they are tenanted. A caller may name
   * themselves, or anyone in their programs; a platform admin may name anyone.
   */
  readonly performerId?: InputMaybe<Scalars['ID']>;
};

export type PullEpocusBillingStatusInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters?: InputMaybe<PullEpocusBillingStatusFilters>;
  readonly limit: Scalars['Int'];
};

export type PullEpocusBillingStatusResult = {
  readonly __typename?: 'PullEpocusBillingStatusResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusBillingStatus>;
};

export type PullEpocusConsentDocumentInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullEpocusConsentDocumentResponse = {
  readonly __typename?: 'PullEpocusConsentDocumentResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusConsentDocument>;
};

export type PullEpocusEncounterFilters = {
  readonly elephantPatientId?: InputMaybe<Scalars['ID']>;
  readonly patientId?: InputMaybe<Scalars['ID']>;
};

export type PullEpocusEncounterInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters?: InputMaybe<PullEpocusEncounterFilters>;
  readonly limit: Scalars['Int'];
};

export type PullEpocusEncounterResponse = {
  readonly __typename?: 'PullEpocusEncounterResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusEncounter>;
};

export type PullEpocusExamFilters = {
  readonly elephantPatientId?: InputMaybe<Scalars['ID']>;
  readonly encounterId?: InputMaybe<Scalars['ID']>;
  /**
   * An explicit set of exams the caller already holds a reference to — the
   * reviewer's performance page asks for the exams behind the reviews it has
   * replicated, to complete the review → encounter join (PNE-789).
   *
   * Deliberately not a reviewer-derived scope: membership would be decided by
   * EpocusReview while the pull pages on EpocusExam.updatedAt, so an exam that
   * entered scope below a device's checkpoint could never be delivered.
   */
  readonly examIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type PullEpocusExamInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullEpocusExamFilters;
  readonly limit: Scalars['Int'];
};

export type PullEpocusExamResult = {
  readonly __typename?: 'PullEpocusExamResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusExam>;
};

export type PullEpocusPatientConsentFilters = {
  readonly encounterId: Scalars['ID'];
};

export type PullEpocusPatientConsentInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullEpocusPatientConsentFilters;
  readonly limit: Scalars['Int'];
};

export type PullEpocusPatientConsentResponse = {
  readonly __typename?: 'PullEpocusPatientConsentResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusPatientConsent>;
};

export type PullEpocusProbeAssociationInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullEpocusProbeAssociationResponse = {
  readonly __typename?: 'PullEpocusProbeAssociationResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusProbeAssociation>;
};

export type PullEpocusReviewFilters = {
  readonly encounterId?: InputMaybe<Scalars['ID']>;
  readonly examId?: InputMaybe<Scalars['ID']>;
  /**
   * The caller's own reviews, for the reviewer's performance record (PNE-789).
   * Only the authenticated user's own id is accepted, so this branch adds no
   * read the caller did not already have. It does not narrow the examId and
   * encounterId branches above, which carry no caller scope of their own.
   */
  readonly reviewerId?: InputMaybe<Scalars['ID']>;
};

export type PullEpocusReviewInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullEpocusReviewFilters;
  readonly limit: Scalars['Int'];
};

export type PullEpocusReviewResult = {
  readonly __typename?: 'PullEpocusReviewResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusReview>;
};

export type PullExchangeRateInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullExchangeRateResponse = {
  readonly __typename?: 'PullExchangeRateResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableExchangeRate>;
};

export type PullFacilityInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullFacilityResponse = {
  readonly __typename?: 'PullFacilityResponse';
  readonly documents: ReadonlyArray<SyncableFacility>;
};

export type PullImagingInstanceFilters = {
  readonly dicomStudyId?: InputMaybe<Scalars['ID']>;
  readonly elephantPatientId?: InputMaybe<Scalars['ID']>;
};

export type PullImagingInstanceInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullImagingInstanceFilters;
  readonly limit: Scalars['Int'];
};

export type PullImagingInstanceResponse = {
  readonly __typename?: 'PullImagingInstanceResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableImagingInstance>;
};

export type PullImagingStudyFilters = {
  readonly elephantPatientId: Scalars['ID'];
};

export type PullImagingStudyInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullImagingStudyFilters;
  readonly limit: Scalars['Int'];
};

export type PullImagingStudyResponse = {
  readonly __typename?: 'PullImagingStudyResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableImagingStudy>;
};

export type PullInvestigationActivityFilters = {
  readonly patientId: Scalars['ID'];
};

export type PullInvestigationActivityInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullInvestigationActivityFilters;
  readonly limit: Scalars['Int'];
};

export type PullInvestigationActivityResponse = {
  readonly __typename?: 'PullInvestigationActivityResponse';
  /** @deprecated Checkpointing handled by FE */
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableInvestigationActivity>;
};

export type PullInvestigationCatalogueItemInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullInvestigationCatalogueResponse = {
  readonly __typename?: 'PullInvestigationCatalogueResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableInvestigationCatalogueItem>;
};

export type PullInvoiceFilters = {
  /**
   * Optional patient scoping. Facility scoping is enforced server-side from
   * the auth context and cannot be set by the client.
   */
  readonly patientId?: InputMaybe<Scalars['ID']>;
};

export type PullInvoiceInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullInvoiceFilters;
  readonly limit: Scalars['Int'];
};

export type PullInvoiceResponse = {
  readonly __typename?: 'PullInvoiceResponse';
  /** @deprecated Checkpointing handled by FE — mirrors pullConsultation precedent */
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableInvoice>;
};

export type PullMyEpocusProgramsInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullMyEpocusProgramsResponse = {
  readonly __typename?: 'PullMyEpocusProgramsResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableEpocusProgram>;
};

export type PullNonPharmaCategoryInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullNonPharmaCategoryResponse = {
  readonly __typename?: 'PullNonPharmaCategoryResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableNonPharmaCategory>;
};

export type PullNonPharmaItemInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullNonPharmaItemResponse = {
  readonly __typename?: 'PullNonPharmaItemResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableNonPharmaItem>;
};

export type PullNotificationBellStateInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullNotificationBellStateResponse = {
  readonly __typename?: 'PullNotificationBellStateResponse';
  readonly documents: ReadonlyArray<NotificationBellState>;
};

export type PullNotificationDismissalInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullNotificationDismissalResponse = {
  readonly __typename?: 'PullNotificationDismissalResponse';
  readonly documents: ReadonlyArray<NotificationDismissal>;
};

export type PullPatientFilters = {
  readonly facilityId?: InputMaybe<Scalars['ID']>;
  /** If provided, the patient with the given ID will be returned rather than fetching a batch of recent patients. */
  readonly id?: InputMaybe<Scalars['ID']>;
};

export type PullPatientInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters?: InputMaybe<PullPatientFilters>;
  readonly limit: Scalars['Int'];
};

export type PullPatientResponse = {
  readonly __typename?: 'PullPatientResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePatient>;
};

export type PullPrescriptionFilters = {
  readonly patientId: Scalars['ID'];
};

export type PullPrescriptionInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullPrescriptionFilters;
  readonly limit: Scalars['Int'];
};

export type PullPrescriptionResponse = {
  readonly __typename?: 'PullPrescriptionResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePrescription>;
};

export type PullPriceAcknowledgementInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullPriceAcknowledgementResult = {
  readonly __typename?: 'PullPriceAcknowledgementResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePriceAcknowledgement>;
};

export type PullPriceInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullPriceListFacilityInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullPriceListFacilityResult = {
  readonly __typename?: 'PullPriceListFacilityResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePriceListFacility>;
};

export type PullPriceListItemExternalReferenceInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullPriceListItemExternalReferenceResult = {
  readonly __typename?: 'PullPriceListItemExternalReferenceResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePriceListItemExternalReference>;
};

export type PullPriceListItemInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullPriceListItemNameInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullPriceListItemNameResult = {
  readonly __typename?: 'PullPriceListItemNameResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePriceListItemName>;
};

export type PullPriceListItemResult = {
  readonly __typename?: 'PullPriceListItemResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePriceListItem>;
};

export type PullPriceListRevenueDepartmentInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullPriceListRevenueDepartmentResult = {
  readonly __typename?: 'PullPriceListRevenueDepartmentResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePriceListRevenueDepartment>;
};

export type PullPriceListTariffInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullPriceListTariffResult = {
  readonly __typename?: 'PullPriceListTariffResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePriceListTariff>;
};

export type PullPriceResult = {
  readonly __typename?: 'PullPriceResult';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncablePrice>;
};

export type PullReferralFeedbackFilters = {
  readonly patientId: Scalars['ID'];
};

export type PullReferralFeedbackInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullReferralFeedbackFilters;
  readonly limit: Scalars['Int'];
};

export type PullReferralFeedbackResponse = {
  readonly __typename?: 'PullReferralFeedbackResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableReferralFeedback>;
};

export type PullReferralFilters = {
  readonly patientId: Scalars['ID'];
};

export type PullReferralInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly filters: PullReferralFilters;
  readonly limit: Scalars['Int'];
};

export type PullReferralResponse = {
  readonly __typename?: 'PullReferralResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableReferral>;
};

export type PullSymptomInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullSymptomResponse = {
  readonly __typename?: 'PullSymptomResponse';
  readonly documents: ReadonlyArray<SyncableSymptom>;
};

export type PullVmpInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullVmpResponse = {
  readonly __typename?: 'PullVmpResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableVmp>;
};

export type PullVtmInput = {
  readonly checkpoint?: InputMaybe<SyncableCheckpointInput>;
  readonly limit: Scalars['Int'];
};

export type PullVtmResponse = {
  readonly __typename?: 'PullVtmResponse';
  readonly checkpoint?: Maybe<SyncableCheckpoint>;
  readonly documents: ReadonlyArray<SyncableVtm>;
};

export type PushConsultationInput = {
  readonly rows: ReadonlyArray<ConsultationSyncPushRow>;
};

export type PushConsultationResponse = {
  readonly __typename?: 'PushConsultationResponse';
  readonly rows: ReadonlyArray<SyncableConsultation>;
};

export type PushDispensationInput = {
  readonly rows: ReadonlyArray<DispensationSyncPushRow>;
};

export type PushDispensationResponse = {
  readonly __typename?: 'PushDispensationResponse';
  readonly rows: ReadonlyArray<SyncableDispensation>;
};

export type PushEpocusAuditEventsInput = {
  readonly rows: ReadonlyArray<EpocusAuditEventSyncPushRow>;
};

export type PushEpocusAuditEventsResult = {
  readonly __typename?: 'PushEpocusAuditEventsResult';
  readonly rows: ReadonlyArray<SyncableEpocusAuditEvent>;
};

export type PushEpocusBillingInput = {
  readonly rows: ReadonlyArray<EpocusBillingSyncPushRow>;
};

export type PushEpocusBillingResult = {
  readonly __typename?: 'PushEpocusBillingResult';
  readonly rows: ReadonlyArray<SyncableEpocusBilling>;
};

export type PushEpocusEncounterInput = {
  readonly rows: ReadonlyArray<EpocusEncounterSyncPushRow>;
};

export type PushEpocusEncounterResult = {
  readonly __typename?: 'PushEpocusEncounterResult';
  readonly rows: ReadonlyArray<SyncableEpocusEncounter>;
};

export type PushEpocusExamInput = {
  readonly rows: ReadonlyArray<EpocusExamSyncPushRow>;
};

export type PushEpocusExamResult = {
  readonly __typename?: 'PushEpocusExamResult';
  readonly rows: ReadonlyArray<SyncableEpocusExam>;
};

export type PushEpocusPatientConsentInput = {
  readonly rows: ReadonlyArray<EpocusPatientConsentSyncPushRow>;
};

export type PushEpocusPatientConsentResult = {
  readonly __typename?: 'PushEpocusPatientConsentResult';
  readonly rows: ReadonlyArray<SyncableEpocusPatientConsent>;
};

export type PushEpocusProbeAssociationInput = {
  readonly rows: ReadonlyArray<EpocusProbeAssociationSyncPushRow>;
};

export type PushEpocusProbeAssociationResult = {
  readonly __typename?: 'PushEpocusProbeAssociationResult';
  readonly rows: ReadonlyArray<SyncableEpocusProbeAssociation>;
};

export type PushEpocusReviewInput = {
  readonly rows: ReadonlyArray<EpocusReviewSyncPushRow>;
};

export type PushEpocusReviewResult = {
  readonly __typename?: 'PushEpocusReviewResult';
  readonly rows: ReadonlyArray<SyncableEpocusReview>;
};

export type PushImagingStudyInput = {
  readonly rows: ReadonlyArray<ImagingStudySyncPushRow>;
};

export type PushImagingStudyResponse = {
  readonly __typename?: 'PushImagingStudyResponse';
  readonly rows: ReadonlyArray<SyncableImagingStudy>;
};

export type PushInvestigationActivityInput = {
  readonly rows: ReadonlyArray<InvestigationActivitySyncPushRow>;
};

export type PushInvestigationActivityResponse = {
  readonly __typename?: 'PushInvestigationActivityResponse';
  readonly rows: ReadonlyArray<SyncableInvestigationActivity>;
};

export type PushInvestigationValidationInput = {
  readonly rows: ReadonlyArray<InvestigationValidationSyncPushRow>;
};

export type PushInvestigationValidationResponse = {
  readonly __typename?: 'PushInvestigationValidationResponse';
  readonly rows: ReadonlyArray<InvestigationValidation>;
};

export type PushInvoiceInput = {
  readonly rows: ReadonlyArray<InvoiceSyncPushRow>;
};

export type PushInvoiceResponse = {
  readonly __typename?: 'PushInvoiceResponse';
  /** Conflict rows contain the server's current state. Empty on full success. */
  readonly rows: ReadonlyArray<SyncableInvoice>;
};

export type PushNotificationBellStateInput = {
  readonly rows: ReadonlyArray<PushNotificationBellStateRow>;
};

export type PushNotificationBellStateResponse = {
  readonly __typename?: 'PushNotificationBellStateResponse';
  readonly rows: ReadonlyArray<NotificationBellState>;
};

export type PushNotificationBellStateRow = {
  readonly assumedMasterState?: InputMaybe<NotificationBellStateInput>;
  readonly newDocumentState: NotificationBellStateInput;
};

export type PushNotificationDismissalInput = {
  readonly rows: ReadonlyArray<PushNotificationDismissalRow>;
};

export type PushNotificationDismissalResponse = {
  readonly __typename?: 'PushNotificationDismissalResponse';
  readonly rows: ReadonlyArray<NotificationDismissal>;
};

export type PushNotificationDismissalRow = {
  readonly assumedMasterState?: InputMaybe<NotificationDismissalInput>;
  readonly newDocumentState: NotificationDismissalInput;
};

export type PushPatientInput = {
  readonly rows: ReadonlyArray<PatientSyncPushRow>;
};

export type PushPatientResponse = {
  readonly __typename?: 'PushPatientResponse';
  readonly rows: ReadonlyArray<SyncablePatient>;
};

export type PushPrescriptionInput = {
  readonly rows: ReadonlyArray<PrescriptionSyncPushRow>;
};

export type PushPrescriptionResponse = {
  readonly __typename?: 'PushPrescriptionResponse';
  readonly rows: ReadonlyArray<SyncablePrescription>;
};

export type PushPriceAcknowledgementInput = {
  readonly rows: ReadonlyArray<PriceAcknowledgementSyncPushRow>;
};

export type PushPriceAcknowledgementResponse = {
  readonly __typename?: 'PushPriceAcknowledgementResponse';
  /**
   * The current server state for any row that the caller's assumedMasterState
   * disagreed with. An empty array means every row was accepted.
   */
  readonly rows: ReadonlyArray<SyncablePriceAcknowledgement>;
};

export type PushReferralFeedbackInput = {
  readonly rows: ReadonlyArray<ReferralFeedbackSyncPushRow>;
};

export type PushReferralFeedbackResponse = {
  readonly __typename?: 'PushReferralFeedbackResponse';
  readonly rows: ReadonlyArray<SyncableReferralFeedback>;
};

export type PushReferralInput = {
  readonly rows: ReadonlyArray<ReferralSyncPushRow>;
};

export type PushReferralResponse = {
  readonly __typename?: 'PushReferralResponse';
  readonly rows: ReadonlyArray<SyncableReferral>;
};

export type Quantity = {
  readonly __typename?: 'Quantity';
  readonly unit?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['Float']>;
};

export type QuantityInput = {
  readonly unit: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly UiDefault?: Maybe<UiDefault>;
  readonly _empty?: Maybe<Scalars['String']>;
  readonly activeAccessionNumbers: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly administrationSchedules: AdministrationScheduleConnection;
  readonly aggregatePatientDiseases: ReadonlyArray<PatientDiseaseResponse>;
  readonly aiFindingsForAccessionNumber: ReadonlyArray<AiFinding>;
  readonly aiFindingsForImagingStudy: ReadonlyArray<AiFinding>;
  readonly ampBulkDownload: BulkDownloadResult;
  readonly ancEncounter: AncEncounter;
  readonly ancEncounters: AncEncounterPage;
  readonly ancPatientRiskRecord?: Maybe<AncPatientRiskRecord>;
  readonly ancPatientRiskRecords: ReadonlyArray<AncPatientRiskRecord>;
  readonly auth0UserLookup?: Maybe<User>;
  readonly catalogueInvestigationActivities: ReadonlyArray<Maybe<InvestigationActivityItem>>;
  readonly catalogueInvestigationActivitiesLastUpdated: Scalars['DateTime'];
  readonly childImmunisationRegister?: Maybe<PaginatedChildImmunisationRegister>;
  readonly clinic?: Maybe<Clinic>;
  readonly clinicInsurance?: Maybe<ClinicInsurance>;
  readonly clinicInsuranceDetailsForClaimsGeneration?: Maybe<ClinicInsurance>;
  readonly dataExportQueries: DataExportQueries;
  readonly dataExportRequests?: Maybe<ReadonlyArray<Maybe<DataExportRequest>>>;
  readonly dataExportResult?: Maybe<DataExportResult>;
  readonly deviceSecret: DeviceSecret;
  readonly diseases: DiseasesPage;
  readonly downloadRegisterRecords?: Maybe<RegisterRecordDownload>;
  readonly epocusBillerExportScope: EpocusBillerExportScope;
  readonly epocusBillerExports: ReadonlyArray<EpocusBillerExport>;
  /**
   * The day's billing picture for a program. The day is the encounter's clinical
   * date, not the billing row's dateOfService — that copy is client-authored
   * and null on most rows. Test scans are excluded.
   */
  readonly epocusBillingDay: EpocusBillingDay;
  readonly epocusBillingReport: EpocusBillingReport;
  /**
   * Reference data: the ultrasound devices ePOCUS knows about and what each
   * can scan, from a static table in this service.
   */
  readonly epocusDeviceCatalogue: ReadonlyArray<EpocusDevice>;
  readonly epocusDeviceSecret: EpocusDeviceSecret;
  /**
   * The audit trail for one encounter, oldest first. Readable by a QA or Program
   * Admin of the encounter's program, and by the two people the trail is about:
   * the performer who scanned it and the reviewer it is assigned to.
   */
  readonly epocusEncounterAuditTrail: ReadonlyArray<EpocusEncounterAuditEntry>;
  /**
   * Reference data: every exam type ePOCUS supports, so a client need not carry
   * its own copy of the enum.
   */
  readonly epocusExamTypes: ReadonlyArray<EpocusExamTypeInfo>;
  readonly epocusGateConfiguration: EpocusGateConfiguration;
  readonly epocusHealthcareContactConsent: Scalars['Boolean'];
  /**
   * Null when no ElephantOS user holds that address.
   *
   * Errors rather than returning null in three cases: the address is not a valid
   * email, the caller may not perform the lookup, or ElephantOS could not be
   * reached. Only the second is a permission error — api-admin decides it, since
   * the call carries the caller's own token and `usersByEmail` is
   * Elephant-level there, so holding `EPOCUS_ADMIN` alone is not enough to
   * resolve anyone while ePOCUS still borrows ElephantOS identity.
   */
  readonly epocusLinkableElephantUser?: Maybe<EpocusLinkableElephantUser>;
  readonly epocusLivePrivacyPolicy?: Maybe<EpocusPrivacyPolicy>;
  /**
   * Resolves the human token forwarded in x-epocus-on-behalf-of-token (the
   * admin's own Auth0 token, as the browser sends it) to the signed-in
   * ElephantOS user via the gateway, and joins their ePOCUS identity. Call once
   * at session open; every later machine token must carry elephantUserId as
   * onBehalfOf, and the identity mutations check the two agree.
   */
  readonly epocusOnboardingCaller: EpocusOnboardingCaller;
  /**
   * Names for the ids stamped on records — a scan's performer, a review's
   * reviewer. Ids the caller shares no program with are absent from the result
   * rather than refused, so one unresolvable performer does not fail a screen.
   */
  readonly epocusPeople: ReadonlyArray<EpocusPerson>;
  /** What was done to this program, and by whom. Newest first. */
  readonly epocusProgramAuditTrail: EpocusProgramAuditTrail;
  readonly epocusProgramCredentialing: EpocusProgramCredentialing;
  readonly epocusProgramDashboard: EpocusProgramDashboard;
  readonly epocusProgramIngress: EpocusProgramIngress;
  readonly epocusProgramMembers: ReadonlyArray<EpocusProgramMembership>;
  readonly epocusProgramQaWorkload: EpocusProgramQaWorkload;
  readonly epocusProgramWorklist: ReadonlyArray<EpocusProgramWorklistEntry>;
  readonly epocusPrograms: ReadonlyArray<EpocusProgram>;
  /**
   * What the seed library can offer a program: per exam type counts of stills
   * and cines, and the attribution the demo app must show for them. available is
   * false when the deployment has no library configured.
   */
  readonly epocusSeedLibrary: EpocusSeedLibrarySummary;
  /**
   * The program's own studies that already hold imagery, newest first, capped at
   * 50. Empty where the program has no imaged studies yet.
   */
  readonly epocusSeedableStudies: ReadonlyArray<EpocusSeedableStudy>;
  /**
   * The caller id the gateway stamped from the signed-in person's verified
   * token: EpocusUser.id on a standalone cell, the ElephantOS user id on a combo
   * one. epocusOnboardingCaller asks this through the gateway with the forwarded
   * token, so it resolves on cells that compose no api-admin.
   */
  readonly epocusSignedInPrincipalId: Scalars['ID'];
  /**
   * Every study received after since, newest first, at most 20, for a sender
   * whose StudyInstanceUID nobody on our side can know in advance. For a
   * platform admin or the agent it is not filtered to programId: an UNROUTED
   * or RECEIVED_NOT_PROCESSED study belongs to no program, and it is the one a
   * misconfigured device produces. Each row reports the program it actually
   * landed in; programId only has to name a program that exists.
   *
   * A program admin or QA admin sees only the rows that landed in a program
   * they administer, taken from the same newest-20 window, and may name only
   * such a program. Read-only.
   */
  readonly epocusStudiesSince: ReadonlyArray<EpocusStudyRouting>;
  /**
   * Where a study addressed to a program's AE title actually landed, by
   * StudyInstanceUID. Read-only.
   */
  readonly epocusStudyRouting: EpocusStudyRouting;
  /**
   * Answers who an Auth0 principal is from EpocusUser, for an ePOCUS-owned Auth0
   * tenant that has no ElephantOS user store to ask. Returns null for an address
   * with no user, and for a soft-deleted one. A disabled user is returned with
   * its status, so a failed login can tell "disabled" from "no such user".
   *
   * Keyed on email, not the Auth0 subject, mirroring ElephantOS: api-admin's
   * auth0UserLookup resolves findByEmail(decodedToken.email) and stores no
   * subject on its own user record. EpocusUser.email is unique, so this is as
   * selective as an id match, and it leaves Auth0 authoritative for the subject
   * rather than keeping a second copy of it here (PNE-650).
   */
  readonly epocusUserLookup?: Maybe<EpocusIdentity>;
  readonly epocusWorklistStations: ReadonlyArray<EpocusWorklistStation>;
  readonly facilityLocation?: Maybe<Location>;
  readonly facilityLocations: ReadonlyArray<Location>;
  readonly facilityQueue?: Maybe<PatientQueue>;
  readonly facilityQueues: ReadonlyArray<Maybe<PatientQueue>>;
  readonly generateImagingAssetUrl: ImagingAssetUrl;
  readonly getAmpById: Amp;
  readonly getAmpsByVmpId: ReadonlyArray<Amp>;
  readonly getCategories: ReadonlyArray<MedicationCategory>;
  readonly getDepartment?: Maybe<FacilityDepartment>;
  /** @deprecated Field no longer supported */
  readonly getDepartments?: Maybe<PaginatedDepartment>;
  readonly getDepartmentsForClinic: ReadonlyArray<Maybe<FacilityDepartment>>;
  readonly getForms: ReadonlyArray<ClinicalProductForm>;
  readonly getGenericDepartments: ReadonlyArray<Maybe<FacilityDepartment>>;
  readonly getLotsBySkuId: ReadonlyArray<Lot>;
  readonly getNonPharmaCategories: ReadonlyArray<NonPharmaCategory>;
  readonly getNonPharmaItemById: NonPharmaItem;
  readonly getPatient: GetPatientResponse;
  readonly getSkuById: Sku;
  readonly getVmpById: Vmp;
  readonly getVmpsByVtm: ReadonlyArray<Vmp>;
  readonly getVtmById: Vtm;
  readonly insuranceProviderByID?: Maybe<InsuranceProvider>;
  /** @deprecated Use insuranceProviderByID */
  readonly insuranceProviderByType?: Maybe<InsuranceProvider>;
  readonly insuranceProviders: ReadonlyArray<Maybe<InsuranceProvider>>;
  readonly inventoryHistory: InventoryHistoryPaged;
  /**
   * Due to a request being ownable by two different facilities - the receiver and the fulfiller -
   * instead of passing both optionally, we will instead take the facility available on the auth token.
   * This will then be compared with both of these fields on the MoveRequest.
   */
  readonly inventoryMoveRequest: InventoryMoveRequest;
  /**
   * Due to a request being ownable by two different facilities - the receiver and the fulfiller -
   * instead of passing both optionally, we will instead take the facility available on the auth token.
   * This will then be compared with both of these fields on the MoveRequest.
   */
  readonly inventoryMoveRequests: InventoryMoveRequestPaged;
  /** @deprecated Use 'inventorySearchTmp' */
  readonly inventorySearch: ReadonlyArray<InventorySummary>;
  readonly inventorySearchTmp: InventorySummaryConnection;
  readonly investigationActivitiesById: ReadonlyArray<Maybe<InvestigationActivity>>;
  readonly investigationActivitiesPaginatedOffset: InvestigationActivitiesPaginatedOffset;
  readonly investigationsForClaimGeneration?: Maybe<ReadonlyArray<Maybe<InvestigationActivity>>>;
  readonly invoice?: Maybe<Invoice>;
  readonly invoices: ReadonlyArray<Invoice>;
  readonly legacyRoles?: Maybe<ReadonlyArray<Maybe<LegacyRole>>>;
  readonly legacyToken: Scalars['String'];
  readonly listProgramUsers: ReadonlyArray<EpocusProgramMembership>;
  readonly lookupPatientId: LookupPatientIdResponse;
  readonly minInsuranceProviders: ReadonlyArray<Maybe<MinInsuranceProvider>>;
  /**
   * The scheduled orders a station may see. The station AE title is resolved to a
   * program through the device registry (a device AE title registered under
   * Settings → Probes) or the program's own AE title; the program's orders are
   * returned with every entry's scheduledStationAeTitle echoing the requested
   * station, as a C-FIND answer must. A station registered to no program gets no
   * entries.
   */
  readonly modalityWorklist: ReadonlyArray<ModalityWorklistEntry>;
  readonly myClinic?: Maybe<Clinic>;
  /**
   * The signed-in person's own ePOCUS profile.
   *
   * Every ePOCUS role can read it, because every ePOCUS role has a Settings
   * page. It is resolved from the id the caller's token carries, so there is no
   * argument to scope and nothing to authorise beyond being signed in as
   * somebody ePOCUS knows.
   */
  readonly myEpocusUser: EpocusUser;
  readonly myLegacyRole?: Maybe<LegacyRole>;
  readonly myUser?: Maybe<User>;
  readonly nigeriaDailyOutpatientRegister?: Maybe<PaginatedNigeriaDailyOutpatientRegister>;
  readonly nigeriaGeneralAttendanceRegister: PaginatedNigeriaGeneralAttendanceRegister;
  readonly nonPharmaItemBulkDownload: BulkDownloadResult;
  readonly ongoingInpatientVisits?: Maybe<PaginatedVisits>;
  readonly organisation?: Maybe<Organisation>;
  /** @deprecated Use prescriptions, this should never have existed */
  readonly outpatientPrescriptions?: Maybe<ReadonlyArray<Maybe<OutpatientPrescription>>>;
  readonly pastInpatientVisits?: Maybe<PaginatedVisits>;
  readonly patient?: Maybe<Patient>;
  /**
   * find a patient from this organisation using a Patient UUID (NB not the Elephant card ID).
   * TODO: why tf is this called patientByCardId when it gets a patient by uuid 😅
   */
  readonly patientByCardId?: Maybe<PatientByCardIdResult>;
  /** find a patient from this organisation by either an Elephant card id, or a passport id. */
  readonly patientByPassport?: Maybe<Patient>;
  readonly patientInvestigationValues: PatientInvestigationValue;
  readonly patientTriageStatus?: Maybe<TriageStatus>;
  readonly patientTriageStatuses?: Maybe<ReadonlyArray<Maybe<TriageStatus>>>;
  readonly patientsByUuid?: Maybe<ReadonlyArray<Maybe<Patient>>>;
  readonly prescription: InpatientPrescription;
  readonly prescriptions: PrescriptionConnection;
  readonly priceListV2: PriceListV2Queries;
  readonly productSearch: ReadonlyArray<ProductSearchResult>;
  readonly programConfig?: Maybe<EpocusProgramConfig>;
  /** Pull all Amps. Be aware responses are cached for 15 minutes. */
  readonly pullAmp: PullAmpResponse;
  readonly pullClinicInsurance: PullClinicInsuranceResponse;
  readonly pullClinicalProductCategory: PullClinicalProductCategoryResponse;
  readonly pullClinicalProductForm: PullClinicalProductFormResponse;
  readonly pullConsultation: PullConsultationResponse;
  readonly pullDisease: PullDiseaseResponse;
  readonly pullDispensation: PullDispensationResponse;
  readonly pullEpocusBilling: PullEpocusBillingResult;
  /** The caller's programs' studies (all of them for a platform admin), or one performer's when filtered. */
  readonly pullEpocusBillingStatus: PullEpocusBillingStatusResult;
  readonly pullEpocusConsentDocument: PullEpocusConsentDocumentResponse;
  readonly pullEpocusEncounter: PullEpocusEncounterResponse;
  readonly pullEpocusExam: PullEpocusExamResult;
  readonly pullEpocusPatientConsent: PullEpocusPatientConsentResponse;
  readonly pullEpocusProbeAssociation: PullEpocusProbeAssociationResponse;
  readonly pullEpocusReview: PullEpocusReviewResult;
  readonly pullExchangeRate: PullExchangeRateResponse;
  readonly pullFacility: PullFacilityResponse;
  readonly pullImagingInstance: PullImagingInstanceResponse;
  readonly pullImagingStudy: PullImagingStudyResponse;
  readonly pullInvestigationActivity: PullInvestigationActivityResponse;
  readonly pullInvestigationCatalogueItem: PullInvestigationCatalogueResponse;
  readonly pullInvoice: PullInvoiceResponse;
  /**
   * Also answers, with no documents, for a user who is not in any program yet
   * (PNE-801): the webapp asks this to decide between the product and
   * onboarding, and a refusal reads as the server being unreachable.
   */
  readonly pullMyEpocusPrograms: PullMyEpocusProgramsResponse;
  readonly pullNonPharmaCategory: PullNonPharmaCategoryResponse;
  /** Pull all NonPharmaItems. Be aware responses are cached for 15 minutes. */
  readonly pullNonPharmaItem: PullNonPharmaItemResponse;
  readonly pullNotificationBellState: PullNotificationBellStateResponse;
  readonly pullNotificationDismissal: PullNotificationDismissalResponse;
  readonly pullPatient: PullPatientResponse;
  readonly pullPrescription: PullPrescriptionResponse;
  readonly pullPrice: PullPriceResult;
  readonly pullPriceAcknowledgement: PullPriceAcknowledgementResult;
  readonly pullPriceListFacility: PullPriceListFacilityResult;
  readonly pullPriceListItem: PullPriceListItemResult;
  readonly pullPriceListItemExternalReference: PullPriceListItemExternalReferenceResult;
  readonly pullPriceListItemName: PullPriceListItemNameResult;
  readonly pullPriceListRevenueDepartment: PullPriceListRevenueDepartmentResult;
  readonly pullPriceListTariff: PullPriceListTariffResult;
  readonly pullReferral: PullReferralResponse;
  readonly pullReferralFeedback: PullReferralFeedbackResponse;
  readonly pullSymptom: PullSymptomResponse;
  /** Pull all Vmps. Be aware responses are cached for 15 minutes. */
  readonly pullVmp: PullVmpResponse;
  /** Pull all Vtms. Be aware responses are cached for 15 minutes. */
  readonly pullVtm: PullVtmResponse;
  readonly queueComparisonTime: Scalars['DateTime'];
  readonly queueForPatient?: Maybe<PatientQueue>;
  readonly receiveStockBulkDownload: BulkDownloadResult;
  readonly registerDownloadRequest: RegisterDownloadRequest;
  readonly registerDownloadRequests: RegisterDownloadRequestPage;
  readonly registerRecords?: Maybe<PaginatedRegisterRecord>;
  readonly reportMetadataList?: Maybe<ReportMetadataResult>;
  /** @deprecated Use priceListV2.revenueDepartments and their ids */
  readonly revenueDepartments?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly searchClinics?: Maybe<ReadonlyArray<Maybe<Clinic>>>;
  readonly searchOrganisations?: Maybe<ReadonlyArray<Maybe<Organisation>>>;
  readonly searchPatients?: Maybe<ReadonlyArray<Maybe<Patient>>>;
  readonly skuBulkDownload: BulkDownloadResult;
  readonly stockTake?: Maybe<StockTake>;
  readonly stockTakeBulkDownload: BulkDownloadResult;
  readonly stockTakes: StockTakesPage;
  readonly supplierBulkDownload: BulkDownloadResult;
  readonly supplierReadAll: ReadonlyArray<Supplier>;
  readonly testResultsPaginatedOffset: TestResultPaginatedOffset;
  readonly user?: Maybe<User>;
  readonly users?: Maybe<UserPage>;
  readonly usersByEmail?: Maybe<ReadonlyArray<Maybe<User>>>;
  readonly usersById?: Maybe<ReadonlyArray<Maybe<User>>>;
  readonly validateAmpBulkUpload?: Maybe<BulkUploadValidationResult>;
  readonly validateNonPharmaItemBulkUpload?: Maybe<BulkUploadValidationResult>;
  readonly validateReceiveStockBulkUpload?: Maybe<ReceiveBulkValidationResult>;
  readonly validateSkuBulkUpload?: Maybe<BulkUploadValidationResult>;
  readonly validateStockTakeBulkUpload?: Maybe<StockTakeBulkValidationResult>;
  readonly validateSupplierBulkUpload?: Maybe<BulkUploadValidationResult>;
  readonly validateVmpBulkUpload?: Maybe<BulkUploadValidationResult>;
  readonly validateVtmBulkUpload?: Maybe<BulkUploadValidationResult>;
  readonly visitById?: Maybe<Visit>;
  readonly visitWithFilteredNotes?: Maybe<Visit>;
  readonly visitsByInsuranceType?: Maybe<ReadonlyArray<Maybe<Visit>>>;
  readonly visitsByPatient?: Maybe<ReadonlyArray<Maybe<Visit>>>;
  readonly vmpBulkDownload: BulkDownloadResult;
  readonly vtmBulkDownload: BulkDownloadResult;
};


export type QueryUiDefaultArgs = {
  input: GetUiDefaultInput;
};


export type QueryAdministrationSchedulesArgs = {
  input: GetAdministrationSchedulesInput;
};


export type QueryAggregatePatientDiseasesArgs = {
  input: PatientDiseasesInput;
};


export type QueryAiFindingsForAccessionNumberArgs = {
  accessionNumber: Scalars['String'];
};


export type QueryAiFindingsForImagingStudyArgs = {
  imagingStudyId: Scalars['ID'];
};


export type QueryAncEncounterArgs = {
  input: QueryAncEncounterInput;
};


export type QueryAncEncountersArgs = {
  input: QueryAncEncountersInput;
};


export type QueryAncPatientRiskRecordArgs = {
  input: QueryAncPatientRiskRecordInput;
};


export type QueryAncPatientRiskRecordsArgs = {
  input: QueryAncPatientRiskRecordsInput;
};


export type QueryCatalogueInvestigationActivitiesArgs = {
  input?: InputMaybe<CatalogueInvestigationActivitiesInput>;
};


export type QueryChildImmunisationRegisterArgs = {
  input: ChildImmunisationRegisterInput;
};


export type QueryClinicArgs = {
  id: Scalars['String'];
};


export type QueryClinicInsuranceArgs = {
  clinicUuid?: InputMaybe<Scalars['String']>;
};


export type QueryClinicInsuranceDetailsForClaimsGenerationArgs = {
  input: ClinicInsuranceDetailsForClaimsInput;
};


export type QueryDataExportResultArgs = {
  input: DataExportResultInput;
};


export type QueryDeviceSecretArgs = {
  input: DeviceSecretInput;
};


export type QueryDownloadRegisterRecordsArgs = {
  input: DownloadRegisterInput;
};


export type QueryEpocusBillerExportScopeArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  programId: Scalars['ID'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryEpocusBillerExportsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['ID'];
};


export type QueryEpocusBillingDayArgs = {
  programId: Scalars['ID'];
  serviceDate: Scalars['DateTime'];
};


export type QueryEpocusBillingReportArgs = {
  examId: Scalars['ID'];
  programId: Scalars['ID'];
};


export type QueryEpocusDeviceSecretArgs = {
  purpose: EpocusDeviceSecretPurpose;
};


export type QueryEpocusEncounterAuditTrailArgs = {
  encounterId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryEpocusHealthcareContactConsentArgs = {
  elephantPatientIdentityValue: Scalars['ID'];
};


export type QueryEpocusLinkableElephantUserArgs = {
  email: Scalars['String'];
};


export type QueryEpocusPeopleArgs = {
  userIds: ReadonlyArray<Scalars['ID']>;
};


export type QueryEpocusProgramAuditTrailArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['ID'];
  since?: InputMaybe<Scalars['DateTime']>;
};


export type QueryEpocusProgramCredentialingArgs = {
  programId: Scalars['ID'];
};


export type QueryEpocusProgramDashboardArgs = {
  programId: Scalars['ID'];
  range: EpocusStatsRangeInput;
};


export type QueryEpocusProgramIngressArgs = {
  programId: Scalars['ID'];
};


export type QueryEpocusProgramMembersArgs = {
  programId: Scalars['ID'];
};


export type QueryEpocusProgramQaWorkloadArgs = {
  programId: Scalars['ID'];
};


export type QueryEpocusProgramWorklistArgs = {
  programId: Scalars['ID'];
};


export type QueryEpocusSeedLibraryArgs = {
  programId: Scalars['ID'];
};


export type QueryEpocusSeedableStudiesArgs = {
  programId: Scalars['ID'];
};


export type QueryEpocusStudiesSinceArgs = {
  programId?: InputMaybe<Scalars['ID']>;
  since: Scalars['DateTime'];
};


export type QueryEpocusStudyRoutingArgs = {
  studyInstanceUid: Scalars['String'];
};


export type QueryEpocusUserLookupArgs = {
  email: Scalars['String'];
};


export type QueryFacilityLocationArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};


export type QueryFacilityLocationsArgs = {
  input: FacilityLocationsInput;
};


export type QueryFacilityQueueArgs = {
  input: FacilityQueueInput;
};


export type QueryGenerateImagingAssetUrlArgs = {
  input: ImagingAssetUrlInput;
};


export type QueryGetAmpByIdArgs = {
  input: ProductIdInput;
};


export type QueryGetAmpsByVmpIdArgs = {
  input: AmpByVmpInput;
};


export type QueryGetDepartmentArgs = {
  _id: Scalars['ID'];
};


export type QueryGetDepartmentsArgs = {
  input: GetDepartmentsInput;
};


export type QueryGetDepartmentsForClinicArgs = {
  input: GetDepartmentsForClinicInput;
};


export type QueryGetLotsBySkuIdArgs = {
  input: GetLotsBySkuIdInput;
};


export type QueryGetNonPharmaItemByIdArgs = {
  input: ProductIdInput;
};


export type QueryGetPatientArgs = {
  input: GetPatientInput;
};


export type QueryGetSkuByIdArgs = {
  input: GetSkuByIdInput;
};


export type QueryGetVmpByIdArgs = {
  input: ProductIdInput;
};


export type QueryGetVmpsByVtmArgs = {
  input: ProductIdInput;
};


export type QueryGetVtmByIdArgs = {
  input: ProductIdInput;
};


export type QueryInsuranceProviderByIdArgs = {
  id: Scalars['ID'];
};


export type QueryInsuranceProviderByTypeArgs = {
  insuranceType: Scalars['String'];
};


export type QueryInsuranceProvidersArgs = {
  includeVisitValidation?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInventoryHistoryArgs = {
  input: InventoryHistoryInput;
  options?: InputMaybe<InventoryHistoryOptions>;
};


export type QueryInventoryMoveRequestArgs = {
  input: InventoryMoveRequestInput;
};


export type QueryInventoryMoveRequestsArgs = {
  input?: InputMaybe<InventoryMoveRequestsInput>;
  options?: InputMaybe<InventoryMoveRequestsOptions>;
};


export type QueryInventorySearchArgs = {
  input: InventorySearchInput;
  options?: InputMaybe<InventorySearchOptionsInput>;
};


export type QueryInventorySearchTmpArgs = {
  input: InventorySearchInput;
  options?: InputMaybe<InventorySearchOptionsInput>;
};


export type QueryInvestigationActivitiesByIdArgs = {
  input: InvestigationActivitiesByIdInput;
};


export type QueryInvestigationActivitiesPaginatedOffsetArgs = {
  input: InvestigationActivitiesInput;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryInvestigationsForClaimGenerationArgs = {
  ids: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type QueryInvoiceArgs = {
  invoiceId: Scalars['String'];
};


export type QueryInvoicesArgs = {
  patientUuid?: InputMaybe<Scalars['String']>;
};


export type QueryLegacyTokenArgs = {
  identityToken: Scalars['String'];
};


export type QueryListProgramUsersArgs = {
  programId: Scalars['ID'];
};


export type QueryLookupPatientIdArgs = {
  input: LookupPatientIdInput;
};


export type QueryMinInsuranceProvidersArgs = {
  includeVisitValidation?: InputMaybe<Scalars['Boolean']>;
};


export type QueryModalityWorklistArgs = {
  modality?: InputMaybe<Scalars['String']>;
  scheduledStationAeTitle?: InputMaybe<Scalars['String']>;
};


export type QueryNigeriaDailyOutpatientRegisterArgs = {
  input: NigeriaDailyOutpatientRegisterInput;
};


export type QueryNigeriaGeneralAttendanceRegisterArgs = {
  input: NigeriaGeneralAttendanceRegisterInput;
};


export type QueryOngoingInpatientVisitsArgs = {
  input: OngoingInpatientVisitsInput;
};


export type QueryOrganisationArgs = {
  id: Scalars['String'];
};


export type QueryOutpatientPrescriptionsArgs = {
  input: GetPrescriptionsInput;
};


export type QueryPastInpatientVisitsArgs = {
  input: PastInpatientVisitsInput;
};


export type QueryPatientArgs = {
  filters?: InputMaybe<PatientQueryFilters>;
  id: Scalars['String'];
};


export type QueryPatientByCardIdArgs = {
  searchWholeTerritory?: InputMaybe<Scalars['Boolean']>;
  uuid: Scalars['String'];
};


export type QueryPatientByPassportArgs = {
  input: PatientByPassportInput;
};


export type QueryPatientInvestigationValuesArgs = {
  options?: InputMaybe<PatientInvestigationValuesOptions>;
  params: PatientInvestigationValuesParams;
};


export type QueryPatientTriageStatusArgs = {
  input: PatientTriageStatusInput;
};


export type QueryPatientTriageStatusesArgs = {
  patientUuids: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type QueryPatientsByUuidArgs = {
  uuids: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type QueryPrescriptionArgs = {
  input: GetPrescriptionInput;
};


export type QueryPrescriptionsArgs = {
  input: GetPrescriptionsInput;
};


export type QueryProductSearchArgs = {
  input: ProductSearchInput;
};


export type QueryProgramConfigArgs = {
  programId: Scalars['ID'];
};


export type QueryPullAmpArgs = {
  input: PullAmpInput;
};


export type QueryPullClinicInsuranceArgs = {
  input: PullClinicInsuranceInput;
};


export type QueryPullClinicalProductCategoryArgs = {
  input: PullClinicalProductCategoryInput;
};


export type QueryPullClinicalProductFormArgs = {
  input: PullClinicalProductFormInput;
};


export type QueryPullConsultationArgs = {
  input: PullConsultationInput;
};


export type QueryPullDiseaseArgs = {
  input: PullDiseaseInput;
};


export type QueryPullDispensationArgs = {
  input: PullDispensationInput;
};


export type QueryPullEpocusBillingArgs = {
  input: PullEpocusBillingInput;
};


export type QueryPullEpocusBillingStatusArgs = {
  input: PullEpocusBillingStatusInput;
};


export type QueryPullEpocusConsentDocumentArgs = {
  input: PullEpocusConsentDocumentInput;
};


export type QueryPullEpocusEncounterArgs = {
  input: PullEpocusEncounterInput;
};


export type QueryPullEpocusExamArgs = {
  input: PullEpocusExamInput;
};


export type QueryPullEpocusPatientConsentArgs = {
  input: PullEpocusPatientConsentInput;
};


export type QueryPullEpocusProbeAssociationArgs = {
  input: PullEpocusProbeAssociationInput;
};


export type QueryPullEpocusReviewArgs = {
  input: PullEpocusReviewInput;
};


export type QueryPullExchangeRateArgs = {
  input: PullExchangeRateInput;
};


export type QueryPullFacilityArgs = {
  input: PullFacilityInput;
};


export type QueryPullImagingInstanceArgs = {
  input: PullImagingInstanceInput;
};


export type QueryPullImagingStudyArgs = {
  input: PullImagingStudyInput;
};


export type QueryPullInvestigationActivityArgs = {
  input: PullInvestigationActivityInput;
};


export type QueryPullInvestigationCatalogueItemArgs = {
  input: PullInvestigationCatalogueItemInput;
};


export type QueryPullInvoiceArgs = {
  input: PullInvoiceInput;
};


export type QueryPullMyEpocusProgramsArgs = {
  input: PullMyEpocusProgramsInput;
};


export type QueryPullNonPharmaCategoryArgs = {
  input: PullNonPharmaCategoryInput;
};


export type QueryPullNonPharmaItemArgs = {
  input: PullNonPharmaItemInput;
};


export type QueryPullNotificationBellStateArgs = {
  input: PullNotificationBellStateInput;
};


export type QueryPullNotificationDismissalArgs = {
  input: PullNotificationDismissalInput;
};


export type QueryPullPatientArgs = {
  input: PullPatientInput;
};


export type QueryPullPrescriptionArgs = {
  input: PullPrescriptionInput;
};


export type QueryPullPriceArgs = {
  input: PullPriceInput;
};


export type QueryPullPriceAcknowledgementArgs = {
  input: PullPriceAcknowledgementInput;
};


export type QueryPullPriceListFacilityArgs = {
  input: PullPriceListFacilityInput;
};


export type QueryPullPriceListItemArgs = {
  input: PullPriceListItemInput;
};


export type QueryPullPriceListItemExternalReferenceArgs = {
  input: PullPriceListItemExternalReferenceInput;
};


export type QueryPullPriceListItemNameArgs = {
  input: PullPriceListItemNameInput;
};


export type QueryPullPriceListRevenueDepartmentArgs = {
  input: PullPriceListRevenueDepartmentInput;
};


export type QueryPullPriceListTariffArgs = {
  input: PullPriceListTariffInput;
};


export type QueryPullReferralArgs = {
  input: PullReferralInput;
};


export type QueryPullReferralFeedbackArgs = {
  input: PullReferralFeedbackInput;
};


export type QueryPullSymptomArgs = {
  input: PullSymptomInput;
};


export type QueryPullVmpArgs = {
  input: PullVmpInput;
};


export type QueryPullVtmArgs = {
  input: PullVtmInput;
};


export type QueryQueueForPatientArgs = {
  input: QueueForPatientInput;
};


export type QueryReceiveStockBulkDownloadArgs = {
  facilityId: Scalars['ID'];
};


export type QueryRegisterDownloadRequestArgs = {
  id: Scalars['ID'];
};


export type QueryRegisterDownloadRequestsArgs = {
  input?: InputMaybe<RegisterDownloadRequestsInput>;
};


export type QueryRegisterRecordsArgs = {
  input: RegisterRecordsInput;
};


export type QueryReportMetadataListArgs = {
  input?: InputMaybe<ReportMetadataListInput>;
};


export type QuerySearchClinicsArgs = {
  clinic?: InputMaybe<SearchClinicInput>;
};


export type QuerySearchOrganisationsArgs = {
  organisation?: InputMaybe<SearchOrganisationInput>;
};


export type QuerySearchPatientsArgs = {
  isFuzzySearch?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  minScoreThreshold?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Int']>;
  patient: SearchPatientInput;
  searchWholeTerritory?: InputMaybe<Scalars['Boolean']>;
  useElastic?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStockTakeArgs = {
  input: StockTakeInput;
};


export type QueryStockTakeBulkDownloadArgs = {
  facilityId: Scalars['ID'];
  locationId: Scalars['ID'];
};


export type QueryStockTakesArgs = {
  input: StockTakesInput;
  options?: InputMaybe<StockTakesOptions>;
};


export type QueryTestResultsPaginatedOffsetArgs = {
  input: TestResultsInput;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryUserArgs = {
  _id: Scalars['String'];
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UsersFilters>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryUsersByEmailArgs = {
  emails: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type QueryUsersByIdArgs = {
  ids: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type QueryValidateAmpBulkUploadArgs = {
  input: BulkUploadInput;
};


export type QueryValidateNonPharmaItemBulkUploadArgs = {
  input: BulkUploadInput;
};


export type QueryValidateReceiveStockBulkUploadArgs = {
  input: ReceiveStockBulkValidateInput;
};


export type QueryValidateSkuBulkUploadArgs = {
  input: BulkUploadInput;
};


export type QueryValidateStockTakeBulkUploadArgs = {
  input: StockTakeBulkValidateInput;
};


export type QueryValidateSupplierBulkUploadArgs = {
  input: BulkUploadInput;
};


export type QueryValidateVmpBulkUploadArgs = {
  input: BulkUploadInput;
};


export type QueryValidateVtmBulkUploadArgs = {
  input: BulkUploadInput;
};


export type QueryVisitByIdArgs = {
  id: Scalars['ID'];
};


export type QueryVisitWithFilteredNotesArgs = {
  input: VisitWithFilteredNotesInput;
};


export type QueryVisitsByInsuranceTypeArgs = {
  input: VisitsByInsuranceTypeInput;
};


export type QueryVisitsByPatientArgs = {
  input: VisitsByPatientInput;
};

export type QueryAncEncounterInput = {
  readonly id?: InputMaybe<Scalars['ID']>;
};

export type QueryAncEncountersInput = {
  readonly options?: InputMaybe<AncEncountersFilterOptions>;
  readonly params?: InputMaybe<AncEncountersFilterParams>;
};

export type QueryAncPatientRiskRecordInput = {
  readonly patientId: Scalars['ID'];
};

export type QueryAncPatientRiskRecordsInput = {
  readonly patientIds: ReadonlyArray<Scalars['ID']>;
};

export type QueueForPatientInput = {
  readonly patientUuid: Scalars['ID'];
};

export type RateLimit = {
  readonly attempts?: InputMaybe<Scalars['Int']>;
};

export type RateMeasurement = {
  readonly __typename?: 'RateMeasurement';
  readonly unit: RateUnit;
  readonly value: Scalars['Int'];
};

export type RateMeasurementInput = {
  readonly unit: RateUnit;
  readonly value: Scalars['Int'];
};

export enum RateUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  MlHour = 'ML_HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ReceiveBulkRowValidation = {
  readonly __typename?: 'ReceiveBulkRowValidation';
  readonly errorMessage?: Maybe<Scalars['String']>;
  readonly expiryDate?: Maybe<Scalars['String']>;
  readonly hasError: Scalars['Boolean'];
  readonly locationName?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly rowIndex: Scalars['Int'];
  readonly skuId?: Maybe<Scalars['String']>;
  readonly skuName?: Maybe<Scalars['String']>;
};

export type ReceiveBulkValidationResult = {
  readonly __typename?: 'ReceiveBulkValidationResult';
  readonly rows: ReadonlyArray<ReceiveBulkRowValidation>;
  readonly totalErrors: Scalars['Int'];
  readonly totalMatched: Scalars['Int'];
  readonly totalSent: Scalars['Int'];
};

export type ReceiveStockBulkRowInput = {
  readonly expiryDate: Scalars['Date'];
  readonly locationId?: InputMaybe<Scalars['String']>;
  readonly quantity: Scalars['Int'];
  readonly skuId: Scalars['String'];
};

export type ReceiveStockBulkUploadInput = {
  readonly facilityId: Scalars['ID'];
  readonly rows: ReadonlyArray<ReceiveStockBulkRowInput>;
};

export type ReceiveStockBulkValidateInput = {
  readonly csv: Scalars['String'];
  readonly facilityId: Scalars['ID'];
};

export type ReceiveStockInput = {
  readonly expiryDate: Scalars['Date'];
  readonly facilityId: Scalars['String'];
  readonly locationId?: InputMaybe<Scalars['String']>;
  readonly quantity: Scalars['Int'];
  readonly skuId: Scalars['String'];
  readonly supplierId: Scalars['String'];
};

export type RecordPaymentInput = {
  readonly origin?: InputMaybe<PaymentOrigin>;
  readonly paidOn: Scalars['Date'];
  readonly patientId: Scalars['ID'];
  readonly receiptNumber?: InputMaybe<Scalars['String']>;
};

export type ReferralFeedbackSyncPushInput = {
  readonly feedbackType: ReferralFeedbackType;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMetaInput;
  readonly patientId: Scalars['ID'];
  readonly referralId: Scalars['ID'];
};

export type ReferralFeedbackSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<ReferralFeedbackSyncPushInput>;
  readonly newDocumentState: ReferralFeedbackSyncPushInput;
};

export enum ReferralFeedbackType {
  Appropriate = 'APPROPRIATE',
  InsufficientDetail = 'INSUFFICIENT_DETAIL',
  NotNeeded = 'NOT_NEEDED',
  WrongFacility = 'WRONG_FACILITY'
}

export type ReferralSyncPushInput = {
  readonly facilityId?: InputMaybe<Scalars['ID']>;
  readonly freeTextFacility?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMetaInput;
  readonly notes?: InputMaybe<Scalars['String']>;
  readonly patientId: Scalars['ID'];
  readonly reasons: ReadonlyArray<Scalars['String']>;
};

export type ReferralSyncPushRow = {
  readonly assumedMasterState?: InputMaybe<ReferralSyncPushInput>;
  readonly newDocumentState: ReferralSyncPushInput;
};

export type RefundDetails = {
  readonly __typename?: 'RefundDetails';
  readonly amount: Amount;
  readonly authCode?: Maybe<Scalars['String']>;
  readonly paymentMethod: PaymentMethod;
  readonly reason: Scalars['String'];
  readonly timestamp?: Maybe<Scalars['DateTime']>;
};

export type RefundInvoiceInput = {
  readonly _id: Scalars['String'];
  readonly amountToRefund: Scalars['Int'];
  readonly currencyExchange?: InputMaybe<CurrencyExchangeInput>;
  readonly reason?: InputMaybe<Scalars['String']>;
};

export type RegisterDownload = {
  readonly __typename?: 'RegisterDownload';
  readonly id: Scalars['ID'];
  readonly result?: Maybe<RegisterRecordDownload>;
  readonly status: RegisterDownloadStatus;
};

export type RegisterDownloadRequest = {
  readonly __typename?: 'RegisterDownloadRequest';
  readonly actor: User;
  readonly clinic: Clinic;
  readonly download?: Maybe<RegisterDownload>;
  readonly filters: DownloadRegisterFilters;
  readonly id: Scalars['ID'];
  readonly meta?: Maybe<Meta>;
  readonly registerType: RegisterType;
  readonly requestedAt: Scalars['DateTime'];
  readonly selectedColumns?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly success?: Maybe<Scalars['Boolean']>;
  readonly successfulAt?: Maybe<Scalars['DateTime']>;
};

export type RegisterDownloadRequestPage = {
  readonly __typename?: 'RegisterDownloadRequestPage';
  readonly limit?: Maybe<Scalars['Int']>;
  readonly offset?: Maybe<Scalars['Int']>;
  readonly requests: ReadonlyArray<Maybe<RegisterDownloadRequest>>;
};

export type RegisterDownloadRequestsInput = {
  readonly paginationOptions?: InputMaybe<PaginationOptions>;
};

export enum RegisterDownloadStatus {
  Complete = 'Complete',
  Error = 'Error',
  Expired = 'Expired',
  Processing = 'Processing'
}

export type RegisterRecord = {
  readonly __typename?: 'RegisterRecord';
  readonly _id: Scalars['ID'];
  readonly careActivities?: Maybe<ReadonlyArray<Maybe<CareActivity>>>;
  readonly date: Scalars['DateTime'];
  readonly patient: PatientRegisterDetails;
};

export type RegisterRecordDownload = {
  readonly __typename?: 'RegisterRecordDownload';
  readonly expiresAt?: Maybe<Scalars['DateTime']>;
  readonly password: Scalars['String'];
  readonly records: Scalars['String'];
};

export type RegisterRecordsInput = {
  readonly filterOptions: FilterOptions;
  readonly paginationOptions?: InputMaybe<PaginationOptions>;
  /** @deprecated All queries are now using RegisterRecordDatasource */
  readonly useAggregation?: InputMaybe<Scalars['Boolean']>;
};

export enum RegisterType {
  Anc = 'ANC',
  GenericOpd = 'GenericOPD',
  NigeriaDailyOutpatient = 'NigeriaDailyOutpatient',
  NigeriaGeneralAttendance = 'NigeriaGeneralAttendance'
}

export type RegistrationPaymentOverview = {
  readonly __typename?: 'RegistrationPaymentOverview';
  readonly lastPayment?: Maybe<Payment>;
  readonly status: PaymentStatus;
};

export type RejectInventoryMoveRequestInput = {
  readonly id: Scalars['ID'];
  readonly notes?: InputMaybe<Scalars['String']>;
};

export type RemovePatientFromLocationInput = {
  readonly locationID: Scalars['ID'];
  readonly patientID: Scalars['ID'];
};

export type RemoveQueuePatientInput = {
  readonly patientUuid: Scalars['ID'];
};

export type ReportListFilterInput = {
  readonly clinicUuid?: InputMaybe<Scalars['String']>;
};

export type ReportMetadata = {
  readonly __typename?: 'ReportMetadata';
  readonly clinicName: Scalars['String'];
  readonly clinicUuid: Scalars['ID'];
  readonly createdAt: Scalars['DateTime'];
  readonly endDate?: Maybe<Scalars['DateTime']>;
  readonly filename: Scalars['String'];
  readonly frequency: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly organisationUuid: Scalars['ID'];
  readonly startDate?: Maybe<Scalars['DateTime']>;
  readonly updatedAt: Scalars['DateTime'];
};

export type ReportMetadataListInput = {
  readonly pagination?: InputMaybe<PaginationInput>;
  readonly reportListFilter?: InputMaybe<ReportListFilterInput>;
};

export type ReportMetadataResult = {
  readonly __typename?: 'ReportMetadataResult';
  readonly limit?: Maybe<Scalars['Int']>;
  readonly offset?: Maybe<Scalars['Int']>;
  readonly reports?: Maybe<ReadonlyArray<Maybe<ReportMetadata>>>;
  readonly total?: Maybe<Scalars['Int']>;
};

export type RequestInventoryMoveInput = {
  readonly receivingFacilityId: Scalars['String'];
  readonly receivingLocationId: Scalars['String'];
  readonly skus: ReadonlyArray<RequestInventoryMoveInputSku>;
};

export type RequestInventoryMoveInputSku = {
  readonly quantityRequested: Scalars['Int'];
  readonly skuId: Scalars['ID'];
};

export type RequestRegisterDownloadInput = {
  readonly columnFilter?: InputMaybe<ReadonlyArray<DownloadColumnFilterValues>>;
  readonly filterOptions: DownloadRegisterFilterOptions;
  readonly registerType: RegisterType;
};

export type RequestSendPinInput = {
  readonly countryCode: Scalars['String'];
  readonly message: Scalars['String'];
  readonly patientUuid: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
};

export enum ResolverScope {
  ClaimsGenerate = 'CLAIMS_GENERATE',
  ImagingStudyCreate = 'IMAGING_STUDY_CREATE',
  InvoicesGenerate = 'INVOICES_GENERATE',
  LegacyInvoiceUserMapping = 'LEGACY_INVOICE_USER_MAPPING',
  PatientConversationDetailsRequest = 'PATIENT_CONVERSATION_DETAILS_REQUEST',
  PatientRegisterDetailsRequest = 'PATIENT_REGISTER_DETAILS_REQUEST'
}

export type RevenueDepartment = {
  readonly __typename?: 'RevenueDepartment';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type RevenueDepartmentsConnection = {
  readonly __typename?: 'RevenueDepartmentsConnection';
  readonly edges: ReadonlyArray<RevenueDepartment>;
};

export type ReviewStockTakeLotInput = {
  readonly facilityId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly reviewedQuantity: Scalars['Int'];
};

export enum Role {
  Admin = 'ADMIN',
  CashOfficer = 'CASH_OFFICER',
  Clinic = 'CLINIC',
  DataExporter = 'DATA_EXPORTER',
  Dispenser = 'DISPENSER',
  Doctor = 'DOCTOR',
  Elephant = 'ELEPHANT',
  Nurse = 'NURSE',
  Performer = 'PERFORMER',
  Pharmacist = 'PHARMACIST',
  ProgramAdmin = 'PROGRAM_ADMIN',
  QaAdmin = 'QA_ADMIN',
  Reviewer = 'REVIEWER',
  Root = 'ROOT',
  Sonographer = 'SONOGRAPHER',
  Technician = 'TECHNICIAN'
}

export enum Route {
  Buccal = 'BUCCAL',
  Ear = 'EAR',
  Eye = 'EYE',
  Inhalation = 'INHALATION',
  Intramuscular = 'INTRAMUSCULAR',
  Intravenous = 'INTRAVENOUS',
  Nasal = 'NASAL',
  Nasogastric = 'NASOGASTRIC',
  Oral = 'ORAL',
  Rectal = 'RECTAL',
  Subcutaneous = 'SUBCUTANEOUS',
  Sublingual = 'SUBLINGUAL',
  Topical = 'TOPICAL',
  Unknown = 'UNKNOWN',
  Vaginal = 'VAGINAL'
}

export type SearchClinicInput = {
  readonly name?: InputMaybe<Scalars['String']>;
  readonly organisation?: InputMaybe<Scalars['String']>;
};

export type SearchOrganisationInput = {
  readonly name?: InputMaybe<Scalars['String']>;
};

export type SearchPatientInput = {
  readonly address?: InputMaybe<AddressInput>;
  readonly dob?: InputMaybe<Scalars['Date']>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly gender?: InputMaybe<Gender>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly middleName?: InputMaybe<Scalars['String']>;
  readonly nationalIdNumber?: InputMaybe<Scalars['String']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum SearchProductType {
  Amps = 'amps',
  NonPharmas = 'non_pharmas',
  Vmps = 'vmps',
  Vtms = 'vtms'
}

export type SendPinInput = {
  readonly countryCode: Scalars['String'];
  readonly message: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
};

export type SetEpocusPerformerCredentialInput = {
  readonly performerId: Scalars['ID'];
  readonly programId: Scalars['ID'];
  readonly status: EpocusPerformerCredentialStatus;
  /**
   * The supervising clinician's principal id, or null to record that no
   * supervision is required. Omitting it is the same as null — this mutation
   * writes the whole credential, so a partial call would silently keep a
   * supervisor the admin believed they had cleared.
   */
  readonly supervisorId?: InputMaybe<Scalars['ID']>;
  /** Free-text unit or site label, or null to clear it. */
  readonly unit?: InputMaybe<Scalars['String']>;
};

export type SetEpocusPlatformRoleInput = {
  readonly epocusUserId: Scalars['ID'];
  /**
   * The role to grant. Omit, or pass null, to revoke — which is refused if it
   * would leave no active platform admin.
   */
  readonly platformRole?: InputMaybe<EpocusPlatformRole>;
};

export type SetEpocusProgramEnabledDeviceIdsInput = {
  /**
   * The device catalogue ids to enable, from the epocusDeviceCatalogue query.
   * Pass an empty list to return the program to unconfigured, which enables all
   * of them.
   */
  readonly enabledDeviceIds: ReadonlyArray<Scalars['String']>;
  readonly programId: Scalars['ID'];
};

export type SetEpocusProgramEnabledExamTypesInput = {
  /**
   * The exam types to enable. Pass an empty list to return the program to
   * unconfigured, which enables every type in its worksheet set.
   */
  readonly enabledExamTypes: ReadonlyArray<EpocusExamType>;
  readonly programId: Scalars['ID'];
};

export type SetInvoiceLineItemsV2Input = {
  readonly id: Scalars['ID'];
  readonly lineItems: ReadonlyArray<InvoiceLineItemV2Input>;
};

export type SetPatientTypeInput = {
  readonly _id: Scalars['String'];
  readonly inpatientDetails?: InputMaybe<InpatientDetailsInput>;
  readonly patientType: PatientType;
};

export type SetPricesInput = {
  readonly priceListId: Scalars['ID'];
  readonly updates: ReadonlyArray<SetPricesUpdate>;
};

export type SetPricesResponse = {
  readonly __typename?: 'SetPricesResponse';
  readonly processed: Scalars['Boolean'];
};

export type SetPricesUpdate = {
  readonly active?: InputMaybe<Scalars['Boolean']>;
  readonly itemId: Scalars['ID'];
  readonly revenueDepartmentId?: InputMaybe<Scalars['ID']>;
  readonly tariffId: Scalars['ID'];
  readonly value?: InputMaybe<Scalars['Int']>;
};

export type Sku = {
  readonly __typename?: 'Sku';
  readonly active: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTime'];
  readonly externalReferences: ReadonlyArray<SkuExternalReference>;
  /** @deprecated Use externalReferences */
  readonly foreignIdMappings: ReadonlyArray<ForeignIdMapping>;
  readonly id: Scalars['String'];
  readonly measurement?: Maybe<Measurement>;
  readonly name: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};


export type SkuExternalReferencesArgs = {
  origins?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type SkuExternalReference = {
  readonly __typename?: 'SkuExternalReference';
  readonly foreignId: Scalars['String'];
  readonly origin: Scalars['String'];
};

export type SkuExternalReferenceInput = {
  readonly foreignId: Scalars['String'];
  readonly origin: Scalars['String'];
};

export type SkuMeasurementInput = {
  readonly quantity: Scalars['Int'];
  readonly unit: Scalars['String'];
};

export type SpecificationReference = {
  readonly __typename?: 'SpecificationReference';
  readonly code: Scalars['String'];
  readonly display?: Maybe<Scalars['String']>;
  readonly system?: Maybe<Scalars['String']>;
};

export type SpecificationReferenceInput = {
  readonly code: Scalars['String'];
  readonly display?: InputMaybe<Scalars['String']>;
  readonly system?: InputMaybe<Scalars['String']>;
};

export type Stock = {
  readonly __typename?: 'Stock';
  readonly hasInventory: Scalars['Boolean'];
  readonly tag?: Maybe<StockLocationTag>;
};

export enum StockLocationTag {
  CheckInArea = 'CHECK_IN_AREA',
  Department = 'DEPARTMENT',
  DispensingArea = 'DISPENSING_AREA',
  ExternalFacility = 'EXTERNAL_FACILITY',
  Inpatient = 'INPATIENT',
  StorageArea = 'STORAGE_AREA'
}

/** StockTake has facilityId in the key so we can perform the necessary auth checks (i.e. validate the user has access to the facility the stock take is at) */
export type StockTake = {
  readonly __typename?: 'StockTake';
  readonly aggregateInfo: StockTakeAggregateInfo;
  readonly createdAt: Scalars['DateTime'];
  readonly facilityId: Scalars['ID'];
  readonly finalisedAt?: Maybe<Scalars['DateTime']>;
  readonly finalisedBy?: Maybe<User>;
  readonly finalisedByUserId?: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly initiatedBy: User;
  readonly initiatedByUserId: Scalars['ID'];
  readonly locationId: Scalars['ID'];
  /** Search for Lot level information within a stock take */
  readonly lots: StockTakeLotsPage;
};


/** StockTake has facilityId in the key so we can perform the necessary auth checks (i.e. validate the user has access to the facility the stock take is at) */
export type StockTakeLotsArgs = {
  input?: InputMaybe<StockTakeLotsInput>;
  options?: InputMaybe<StockTakeLotsOptions>;
};

export type StockTakeAggregateInfo = {
  readonly __typename?: 'StockTakeAggregateInfo';
  readonly reviewedLotCount: Scalars['Int'];
  readonly totalLotCount: Scalars['Int'];
  readonly totalNewLotsAdded: Scalars['Int'];
  readonly totalQuantityAdded: Scalars['Int'];
  readonly totalQuantityRemoved: Scalars['Int'];
};

export type StockTakeBulkRowInput = {
  readonly actualCount: Scalars['Int'];
  readonly lotId: Scalars['String'];
};

export type StockTakeBulkRowValidation = {
  readonly __typename?: 'StockTakeBulkRowValidation';
  readonly actualCount?: Maybe<Scalars['Int']>;
  readonly discrepancy?: Maybe<Scalars['Int']>;
  readonly errorMessage?: Maybe<Scalars['String']>;
  readonly expiryDate?: Maybe<Scalars['String']>;
  readonly hasError: Scalars['Boolean'];
  readonly lotId?: Maybe<Scalars['String']>;
  readonly modifiedSinceExport: Scalars['Boolean'];
  readonly rowIndex: Scalars['Int'];
  readonly skuName?: Maybe<Scalars['String']>;
  readonly systemQuantity?: Maybe<Scalars['Int']>;
  readonly willUpdate: Scalars['Boolean'];
};

export type StockTakeBulkUploadInput = {
  readonly facilityId: Scalars['ID'];
  readonly locationId: Scalars['ID'];
  readonly rows: ReadonlyArray<StockTakeBulkRowInput>;
};

export type StockTakeBulkUploadResult = {
  readonly __typename?: 'StockTakeBulkUploadResult';
  readonly errors: ReadonlyArray<BulkUploadError>;
  readonly stockTakeId?: Maybe<Scalars['ID']>;
  readonly totalErrors: Scalars['Int'];
  readonly totalSent: Scalars['Int'];
  readonly totalUpdated: Scalars['Int'];
};

export type StockTakeBulkValidateInput = {
  readonly csv: Scalars['String'];
  readonly facilityId: Scalars['ID'];
  readonly locationId: Scalars['ID'];
};

export type StockTakeBulkValidationResult = {
  readonly __typename?: 'StockTakeBulkValidationResult';
  readonly rows: ReadonlyArray<StockTakeBulkRowValidation>;
  readonly totalErrors: Scalars['Int'];
  readonly totalModifiedSinceExport: Scalars['Int'];
  readonly totalSent: Scalars['Int'];
  readonly totalToUpdate: Scalars['Int'];
  readonly totalUnchanged: Scalars['Int'];
};

export type StockTakeInput = {
  readonly facilityId: Scalars['ID'];
  readonly stockTakeId: Scalars['ID'];
};

/** Because the subtypes StockTakeLotUpdate and StockTakeLotAddition have common fields with different types e.g. reviewedQuantity and lot when querying these values you might have to alias them in your inline fragments. */
export type StockTakeLot = StockTakeLotAddition | StockTakeLotUpdate;

export type StockTakeLotAddition = {
  readonly __typename?: 'StockTakeLotAddition';
  readonly expiryDate: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly lastStockTakeAt?: Maybe<Scalars['Date']>;
  readonly lot?: Maybe<StockTakePartialLot>;
  readonly name: Scalars['String'];
  readonly quantityDifference: Scalars['Int'];
  readonly reviewedQuantity: Scalars['Int'];
  readonly skuId: Scalars['String'];
  readonly status: StockTakeLotStatus;
  readonly stockTake: StockTake;
  readonly userId: Scalars['ID'];
};

export enum StockTakeLotStatus {
  Completed = 'COMPLETED',
  Errored = 'ERRORED',
  Pending = 'PENDING'
}

export type StockTakeLotUpdate = {
  readonly __typename?: 'StockTakeLotUpdate';
  readonly id: Scalars['ID'];
  readonly initialQuantity: Scalars['Int'];
  readonly lastStockTakeAt?: Maybe<Scalars['Date']>;
  readonly lot: StockTakePartialLot;
  readonly name: Scalars['String'];
  readonly quantityDifference: Scalars['Int'];
  readonly reviewedQuantity?: Maybe<Scalars['Int']>;
  readonly status: StockTakeLotStatus;
  readonly stockTake: StockTake;
  readonly userId?: Maybe<Scalars['ID']>;
};

export type StockTakeLotsInput = {
  readonly name?: InputMaybe<Scalars['String']>;
  readonly reviewed?: InputMaybe<Scalars['Boolean']>;
  readonly skuId?: InputMaybe<Scalars['ID']>;
};

export type StockTakeLotsOptions = {
  readonly orderBy?: InputMaybe<StockTakeLotsSearchOrder>;
  readonly orderDirection?: InputMaybe<StockTakeSearchOrderDirection>;
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export type StockTakeLotsPage = {
  readonly __typename?: 'StockTakeLotsPage';
  readonly items: ReadonlyArray<StockTakeLot>;
  readonly reviewedCount: Scalars['Int'];
  readonly totalCount: Scalars['Int'];
};

export enum StockTakeLotsSearchOrder {
  ExpiryDate = 'EXPIRY_DATE',
  LastStockTakeAt = 'LAST_STOCK_TAKE_AT',
  Name = 'NAME',
  NameRelevance = 'NAME_RELEVANCE',
  QuantityDifference = 'QUANTITY_DIFFERENCE'
}

export type StockTakePartialLot = {
  readonly __typename?: 'StockTakePartialLot';
  readonly expiryDate: Scalars['Date'];
  readonly id: Scalars['String'];
  /**
   * Federated SKU reference. Lets callers resolve sku.externalReferences to
   * classify pharma vs non-pharma in stocktake views.
   */
  readonly sku: Sku;
  readonly skuId: Scalars['String'];
};

export enum StockTakeSearchOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StockTakesInput = {
  readonly createdAfter?: InputMaybe<Scalars['DateTime']>;
  readonly createdBefore?: InputMaybe<Scalars['DateTime']>;
  readonly facilityId: Scalars['ID'];
  readonly finalised?: InputMaybe<Scalars['Boolean']>;
  readonly locationId?: InputMaybe<Scalars['ID']>;
};

export type StockTakesOptions = {
  readonly pageNumber?: InputMaybe<Scalars['Int']>;
  readonly pageSize?: InputMaybe<Scalars['Int']>;
};

export type StockTakesPage = {
  readonly __typename?: 'StockTakesPage';
  readonly items: ReadonlyArray<StockTake>;
  readonly totalCount: Scalars['Int'];
};

/**
 * This type was once a part of the Stock V2 (which is EoL), but was later co-opted into use by
 * clinical products as a temporary measure.
 * When we get outpatient prescriptions onto api-prescription all this can be forgotten about.
 */
export type SubstituteMedication = {
  readonly __typename?: 'SubstituteMedication';
  /** @deprecated Legacy StockV2 attribute */
  readonly codification?: Maybe<Scalars['String']>;
  /** @deprecated Legacy StockV2 attribute */
  readonly dose?: Maybe<Dose>;
  /** @deprecated Legacy StockV2 attribute */
  readonly formulation?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  /**
   * The clinical product (VMP) id
   * @deprecated Legacy StockV2 attribute
   */
  readonly productId?: Maybe<Scalars['String']>;
  /** @deprecated Legacy StockV2 attribute */
  readonly strength?: Maybe<Scalars['String']>;
};

export type Supplier = {
  readonly __typename?: 'Supplier';
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
};

export type SupplierSearchInput = {
  readonly name: Scalars['String'];
};

export enum SupplyLevel {
  InStock = 'IN_STOCK',
  InStockButNotAtYourLocation = 'IN_STOCK_BUT_NOT_AT_YOUR_LOCATION',
  LowStock = 'LOW_STOCK',
  NeverBeenStocked = 'NEVER_BEEN_STOCKED',
  OutOfStock = 'OUT_OF_STOCK'
}

export type SymptomI18NSchema = {
  readonly __typename?: 'SymptomI18NSchema';
  readonly displayName: Scalars['String'];
  readonly keywords?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly locale: L10N;
};

export type SyncableAmount = {
  readonly __typename?: 'SyncableAmount';
  readonly currency: BillingCurrency;
  readonly value: Scalars['Float'];
};

export type SyncableAmountInput = {
  readonly currency: BillingCurrency;
  readonly value: Scalars['Float'];
};

export type SyncableAmp = {
  readonly __typename?: 'SyncableAmp';
  readonly id: Scalars['ID'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly meta: SyncableMeta;
  readonly productType: ProductType;
  readonly title: Scalars['String'];
  readonly vmpId: Scalars['String'];
};

export type SyncableBalance = {
  readonly __typename?: 'SyncableBalance';
  readonly currency: BillingCurrency;
  readonly due?: Maybe<Scalars['Float']>;
  readonly exempt?: Maybe<Scalars['Float']>;
  readonly paid?: Maybe<Scalars['Float']>;
  readonly total: Scalars['Float'];
  readonly waived?: Maybe<Scalars['Float']>;
};

export type SyncableBalanceInput = {
  readonly currency: BillingCurrency;
  readonly due?: InputMaybe<Scalars['Float']>;
  readonly exempt?: InputMaybe<Scalars['Float']>;
  readonly paid?: InputMaybe<Scalars['Float']>;
  readonly total: Scalars['Float'];
  readonly waived?: InputMaybe<Scalars['Float']>;
};

export type SyncableCheckpoint = {
  readonly __typename?: 'SyncableCheckpoint';
  readonly id: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};

export type SyncableCheckpointInput = {
  readonly id: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};

export type SyncableClaimedLineItem = {
  readonly __typename?: 'SyncableClaimedLineItem';
  readonly amountInPence: Scalars['Int'];
  readonly lineItemId: Scalars['ID'];
};

export type SyncableClaimedLineItemInput = {
  readonly amountInPence: Scalars['Int'];
  readonly lineItemId: Scalars['ID'];
};

export type SyncableClinicInsurance = {
  readonly __typename?: 'SyncableClinicInsurance';
  readonly dailyRebateAmount?: Maybe<Scalars['Float']>;
  readonly facilityId: Scalars['ID'];
  readonly healthProviderCode?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
};

export type SyncableClinicalProductCategory = {
  readonly __typename?: 'SyncableClinicalProductCategory';
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly title: ClinicalProductCategoryTitle;
};

export type SyncableClinicalProductForm = {
  readonly __typename?: 'SyncableClinicalProductForm';
  readonly existingNames: ReadonlyArray<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly meta: SyncableMeta;
  readonly snomedId?: Maybe<Scalars['String']>;
  readonly title: ClinicalProductFormTitle;
};

export type SyncableConsultation = {
  readonly __typename?: 'SyncableConsultation';
  readonly backdatedTo?: Maybe<Scalars['DateTime']>;
  readonly diseaseIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  readonly facilityId: Scalars['ID'];
  readonly freeTextDiagnoses: ReadonlyArray<FreeTextDiagnosis>;
  readonly id: Scalars['ID'];
  readonly isImmunisation?: Maybe<Scalars['Boolean']>;
  readonly isPerformedAtOtherClinic?: Maybe<Scalars['Boolean']>;
  readonly meta: SyncableMeta;
  readonly organisationId: Scalars['ID'];
  readonly patientId: Scalars['ID'];
  readonly plan?: Maybe<Scalars['String']>;
  readonly presentingComplaint?: Maybe<Scalars['String']>;
  readonly problem?: Maybe<Scalars['String']>;
  readonly symptomIds: ReadonlyArray<Scalars['ID']>;
};

export type SyncableCurrencyExchange = {
  readonly __typename?: 'SyncableCurrencyExchange';
  readonly exchangeRate: SyncableCurrencyExchangeRate;
  /**
   * Money converted from, in minor units. PAYMENT: the other currency handed over.
   * REFUND: the invoice currency refunded, equal to -amount.value.
   */
  readonly from: SyncableAmount;
  /**
   * Money converted to, in minor units. PAYMENT: the invoice currency credited, equal to
   * amount.value. REFUND: the other currency handed back.
   */
  readonly to: SyncableAmount;
};

export type SyncableCurrencyExchangeInput = {
  readonly exchangeRate: SyncableCurrencyExchangeRateInput;
  /**
   * Money converted from, in minor units. PAYMENT: the other currency handed over.
   * REFUND: the invoice currency refunded, equal to -amount.value.
   */
  readonly from: SyncableAmountInput;
  /**
   * Money converted to, in minor units. PAYMENT: the invoice currency credited, equal to
   * amount.value. REFUND: the other currency handed back.
   */
  readonly to: SyncableAmountInput;
};

/**
 * The rate applied: 1 baseCurrency = rate quoteCurrency. Base and quote follow FX quoting
 * (USD/LRD); they are not the invoice or home currency.
 */
export type SyncableCurrencyExchangeRate = {
  readonly __typename?: 'SyncableCurrencyExchangeRate';
  readonly baseCurrency: BillingCurrency;
  readonly effectiveDate: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly quoteCurrency: BillingCurrency;
  readonly rate: Scalars['String'];
};

/**
 * The rate applied: 1 baseCurrency = rate quoteCurrency. Base and quote follow FX quoting
 * (USD/LRD); they are not the invoice or home currency.
 */
export type SyncableCurrencyExchangeRateInput = {
  readonly baseCurrency: BillingCurrency;
  readonly effectiveDate: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly quoteCurrency: BillingCurrency;
  readonly rate: Scalars['String'];
};

export type SyncableDisease = {
  readonly __typename?: 'SyncableDisease';
  readonly catalogueCoding?: Maybe<DiseaseCatalogueCoding>;
  readonly category: Scalars['String'];
  /** The main ICD code for the disease */
  readonly code: Scalars['String'];
  /** The main ICD revision for the disease (ICD-10 or ICD-11) */
  readonly coding: Scalars['String'];
  readonly i18n: ReadonlyArray<I18NSchema>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
};

export type SyncableDispensation = {
  readonly __typename?: 'SyncableDispensation';
  readonly dispensationStrategy: DispensationStrategy;
  readonly dispensedByUserId: Scalars['ID'];
  readonly facilityId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly locationId: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly prescriptionId: Scalars['ID'];
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly skuId?: Maybe<Scalars['String']>;
};

export type SyncableElephantActor = {
  readonly __typename?: 'SyncableElephantActor';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type SyncableEpocusAuditEvent = {
  readonly __typename?: 'SyncableEpocusAuditEvent';
  readonly clientActionTime: Scalars['DateTime'];
  readonly entityId: Scalars['ID'];
  readonly entityType: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly serverReceivedAt: Scalars['DateTime'];
  readonly userId: Scalars['ID'];
  readonly verb: Scalars['String'];
};

export type SyncableEpocusBilling = {
  readonly __typename?: 'SyncableEpocusBilling';
  readonly billingMode?: Maybe<EpocusBillingMode>;
  readonly clinicalSetting?: Maybe<EpocusClinicalSetting>;
  readonly dateOfService?: Maybe<Scalars['DateTime']>;
  readonly diagnosisCodes: Scalars['JSON'];
  readonly documentationStatus?: Maybe<EpocusBillingDocumentationStatus>;
  readonly encounterId: Scalars['ID'];
  readonly examId?: Maybe<Scalars['String']>;
  readonly exportedAt?: Maybe<Scalars['DateTime']>;
  readonly facilityNpi?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly imagesStored: Scalars['Boolean'];
  readonly locked: Scalars['Boolean'];
  readonly meta: SyncableMeta;
  readonly patientDob?: Maybe<Scalars['DateTime']>;
  readonly patientMrn?: Maybe<Scalars['String']>;
  readonly payerName?: Maybe<Scalars['String']>;
  readonly performingPhysicianName?: Maybe<Scalars['String']>;
  readonly performingPhysicianNpi?: Maybe<Scalars['String']>;
  readonly policyNumber?: Maybe<Scalars['String']>;
  readonly procedureCodes: Scalars['JSON'];
  readonly programId?: Maybe<Scalars['ID']>;
  readonly renderingProviderUserId?: Maybe<Scalars['ID']>;
  readonly supervisingPhysicianNpi?: Maybe<Scalars['String']>;
};

/**
 * Built by the server whenever one of its inputs is written, and replicated
 * pull-only: devices read it for the badge and worklist tabs and never push it.
 */
export type SyncableEpocusBillingStatus = {
  readonly __typename?: 'SyncableEpocusBillingStatus';
  /** Set when an exported study changes in a way its biller sees; cleared when it is exported again. */
  readonly amendedAfterExportAt?: Maybe<Scalars['DateTime']>;
  readonly computedAt: Scalars['DateTime'];
  readonly encounterId: Scalars['ID'];
  readonly examCreatedAt?: Maybe<Scalars['DateTime']>;
  readonly examId: Scalars['ID'];
  readonly examSignedAt?: Maybe<Scalars['DateTime']>;
  /** The exam's worksheet, so a device can label the study without having synced the exam. */
  readonly examType?: Maybe<Scalars['String']>;
  /** Set while QA review holds the study back from billing. */
  readonly holdReason?: Maybe<EpocusBillingHoldReason>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly missingItems: ReadonlyArray<EpocusBillingMissingItem>;
  readonly performerId?: Maybe<Scalars['ID']>;
  readonly programId?: Maybe<Scalars['ID']>;
  /** Set when a hold landed on a study already exported; cleared when it is exported again. */
  readonly qaAfterExport?: Maybe<EpocusBillingHoldReason>;
  readonly status: EpocusBillingState;
};

export type SyncableEpocusConsentDocument = {
  readonly __typename?: 'SyncableEpocusConsentDocument';
  readonly id: Scalars['ID'];
  readonly items: ReadonlyArray<EpocusConsentItem>;
  readonly meta: SyncableMeta;
  readonly version: Scalars['Int'];
};

export type SyncableEpocusEncounter = {
  readonly __typename?: 'SyncableEpocusEncounter';
  readonly accessionNumber?: Maybe<Scalars['String']>;
  readonly assignedAt?: Maybe<Scalars['DateTime']>;
  /** Null means the encounter sits in the unassigned review pool. */
  readonly assignedReviewerId?: Maybe<Scalars['ID']>;
  readonly deviceName?: Maybe<Scalars['String']>;
  readonly deviceSerialNumber?: Maybe<Scalars['String']>;
  readonly dicomStudyId?: Maybe<Scalars['ID']>;
  readonly elephantPatientId?: Maybe<Scalars['String']>;
  readonly encounterDate?: Maybe<Scalars['DateTime']>;
  readonly escalatedAt?: Maybe<Scalars['DateTime']>;
  readonly escalationReason?: Maybe<Scalars['String']>;
  readonly examTypes: Scalars['JSON'];
  readonly id: Scalars['ID'];
  readonly imageCount: Scalars['Int'];
  readonly indication?: Maybe<Scalars['String']>;
  readonly location?: Maybe<Scalars['String']>;
  readonly matchTier?: Maybe<EpocusMatchTier>;
  readonly meta: SyncableMeta;
  readonly operatorName?: Maybe<Scalars['String']>;
  readonly patientDob?: Maybe<Scalars['DateTime']>;
  readonly patientGender?: Maybe<Scalars['String']>;
  /** @deprecated Renamed to elephantPatientId (PNE-598). Removed once primary-care-web has migrated. */
  readonly patientId?: Maybe<Scalars['String']>;
  readonly patientMrn?: Maybe<Scalars['String']>;
  readonly patientName?: Maybe<Scalars['String']>;
  readonly performerId?: Maybe<Scalars['ID']>;
  readonly programId?: Maybe<Scalars['ID']>;
  readonly requestNotes?: Maybe<Scalars['String']>;
  readonly requestPriority?: Maybe<EpocusRequestPriority>;
  readonly requestedAt?: Maybe<Scalars['DateTime']>;
  readonly requestedById?: Maybe<Scalars['ID']>;
  /** The exam type asked for, as the lowercase slug EpocusExam.examType uses. */
  readonly requestedExamType?: Maybe<Scalars['String']>;
  readonly reviewOutcome?: Maybe<EpocusReviewOutcome>;
  readonly status: EpocusEncounterStatus;
  readonly submittedForReviewAt?: Maybe<Scalars['DateTime']>;
};

export type SyncableEpocusExam = {
  readonly __typename?: 'SyncableEpocusExam';
  /**
   * Amendments and confirmations of the signed report, oldest first. Each
   * amendment keeps the worksheet it replaced. Only the clinician who signed
   * the report can add to them.
   */
  readonly amendments: Scalars['JSON'];
  readonly encounterId: Scalars['ID'];
  readonly examType: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly images: Scalars['JSON'];
  readonly meta: SyncableMeta;
  /** Excluded from billing, the fee estimate and reminders. Can still be signed and reviewed. */
  readonly nonBillable: Scalars['Boolean'];
  readonly nonBillableReason?: Maybe<EpocusNonBillableReason>;
  readonly signedAt?: Maybe<Scalars['DateTime']>;
  readonly signedByUserId?: Maybe<Scalars['ID']>;
  readonly status: Scalars['String'];
  readonly worksheetSummary: Scalars['JSON'];
};

export type SyncableEpocusPatientConsent = {
  readonly __typename?: 'SyncableEpocusPatientConsent';
  readonly audience: EpocusConsentAudience;
  readonly consentDocumentId: Scalars['ID'];
  readonly elephantPatientIdentityValue?: Maybe<Scalars['ID']>;
  readonly encounterId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly kind: EpocusConsentItemKind;
  readonly meta: SyncableMeta;
  readonly privacyPolicyId?: Maybe<Scalars['ID']>;
  readonly programId?: Maybe<Scalars['ID']>;
  readonly response: EpocusConsentResponse;
};

export type SyncableEpocusProbeAssociation = {
  readonly __typename?: 'SyncableEpocusProbeAssociation';
  readonly deviceAeTitle?: Maybe<Scalars['String']>;
  readonly deviceSerialNumber: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly performerId: Scalars['ID'];
  readonly performerName: Scalars['String'];
  readonly programId?: Maybe<Scalars['ID']>;
};

export type SyncableEpocusProgram = {
  readonly __typename?: 'SyncableEpocusProgram';
  /** Null follows clinicalSetting. */
  readonly billingModifierOverride?: Maybe<EpocusBillingModifierOverride>;
  readonly clinicalSetting: EpocusProgramClinicalSetting;
  readonly dimseAeTitle?: Maybe<Scalars['String']>;
  readonly elephantFacilityId?: Maybe<Scalars['String']>;
  /**
   * PNE-734 — the device catalogue ids a performer may pick in this program,
   * empty when unconfigured (which enables all of them). Replicated for the same
   * reason as enabledExamTypes: the New Encounter device picker has to narrow
   * offline. Pull-only, like the rest of this document — a performer reads their
   * program's configuration and never authors it, which is why
   * syncable-parity.test.ts keeps SyncableEpocusProgram in PULL_ONLY_TYPES.
   */
  readonly enabledDeviceIds: ReadonlyArray<Scalars['String']>;
  /**
   * PNE-568 — the exam types a performer may pick in this program, empty when
   * unconfigured (which enables every type in worksheetSet). Replicated rather
   * than fetched on demand so the New Encounter picker narrows correctly
   * offline, which is where most scans are started.
   */
  readonly enabledExamTypes: ReadonlyArray<EpocusExamType>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly name: Scalars['String'];
  readonly status: EpocusProgramStatus;
  /** Minutes to sign-off treated as on time. Null is unconfigured; display 30. */
  readonly turnaroundTargetMinutes?: Maybe<Scalars['Int']>;
  /**
   * The family of worksheets new exams are chosen from. Replicated for the same
   * reason as enabledExamTypes.
   */
  readonly worksheetSet: EpocusWorksheetSet;
};

export type SyncableEpocusReview = {
  readonly __typename?: 'SyncableEpocusReview';
  /**
   * Derived from interpretation (TRUE_POSITIVE and TRUE_NEGATIVE are true),
   * else from agreement (AGREE is true).
   * @deprecated Transitional since PNE-744. Read interpretation, then agreement.
   */
  readonly agree: Scalars['Boolean'];
  /**
   * Null on reviews written before this field existed.
   * @deprecated Superseded by interpretation (PNE-838). Read it only when interpretation is null.
   */
  readonly agreement?: Maybe<EpocusReviewAgreement>;
  readonly comment?: Maybe<Scalars['String']>;
  readonly examId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly imageQualityScore?: Maybe<Scalars['Int']>;
  /**
   * The reviewer's verdict (PNE-838). Null on reviews written before it existed
   * and on reviews pushed by a device on the previous release, which carry
   * agreement instead.
   */
  readonly interpretation?: Maybe<EpocusReviewInterpretation>;
  readonly meta: SyncableMeta;
  /** Transitional: mirrors imageQualityScore. */
  readonly qualityScore: Scalars['Float'];
  /**
   * The reviewer who owns this review. Authored by the server from the
   * authenticated caller on create, and refused to anyone else on update.
   */
  readonly reviewerId: Scalars['ID'];
  /** Non-null means the review is locked and a later push is not applied. */
  readonly signedAt?: Maybe<Scalars['DateTime']>;
  readonly tags: ReadonlyArray<Scalars['String']>;
};

export type SyncableExchangeRate = {
  readonly __typename?: 'SyncableExchangeRate';
  readonly baseCurrency: BillingCurrency;
  /** Decimal string: quote units per 1 base unit, as published. */
  readonly buying: Scalars['String'];
  /** Publication date at the source. */
  readonly effectiveDate: Scalars['Date'];
  readonly fetchedAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  /** Decimal string: exact mean of buying and selling. Stored for reference; currency exchanges apply selling. */
  readonly mid: Scalars['String'];
  readonly quoteCurrency: BillingCurrency;
  readonly selling: Scalars['String'];
  readonly source: ExchangeRateSource;
  readonly sourceUrl: Scalars['String'];
};

export type SyncableFacility = {
  readonly __typename?: 'SyncableFacility';
  readonly addresses: ReadonlyArray<Address>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly name: Scalars['String'];
  readonly organisation: Scalars['String'];
  readonly service?: Maybe<Scalars['String']>;
  readonly settings: ClinicSettings;
};

export type SyncableFacilitySnapshot = {
  readonly __typename?: 'SyncableFacilitySnapshot';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type SyncableI18nStringInput = {
  readonly en: Scalars['String'];
};

export type SyncableImagingInstance = {
  readonly __typename?: 'SyncableImagingInstance';
  readonly cineDurationMs?: Maybe<Scalars['Int']>;
  readonly cineS3Key?: Maybe<Scalars['String']>;
  readonly cineSizeBytes?: Maybe<Scalars['Int']>;
  readonly cineStatus?: Maybe<CineStatus>;
  readonly deviceManufacturer?: Maybe<Scalars['String']>;
  readonly deviceModelName?: Maybe<Scalars['String']>;
  readonly dicomPreset?: Maybe<Scalars['String']>;
  readonly dicomStudyId?: Maybe<Scalars['String']>;
  readonly elephantPatientId?: Maybe<Scalars['String']>;
  readonly externalId: Scalars['String'];
  readonly frameRate?: Maybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly imagingStudyAccessionNumber: Scalars['String'];
  readonly meta: SyncableMeta;
  readonly numberOfFrames?: Maybe<Scalars['Int']>;
  readonly physicalDeltaMm?: Maybe<Scalars['Float']>;
  readonly previewS3Key: Scalars['String'];
  readonly thumbnailS3Key: Scalars['String'];
};

export type SyncableImagingStudy = {
  readonly __typename?: 'SyncableImagingStudy';
  readonly accessionNumber: Scalars['String'];
  readonly elephantPatientId?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
};

export type SyncableInpatientDetails = {
  readonly __typename?: 'SyncableInpatientDetails';
  readonly admission?: Maybe<Scalars['DateTime']>;
  readonly dailyRebateAmount?: Maybe<Scalars['Float']>;
  readonly discharge?: Maybe<Scalars['DateTime']>;
  readonly inpatientNumber?: Maybe<Scalars['String']>;
  readonly ward?: Maybe<Scalars['String']>;
};

export type SyncableInpatientDetailsInput = {
  readonly admission?: InputMaybe<Scalars['DateTime']>;
  readonly dailyRebateAmount?: InputMaybe<Scalars['Float']>;
  readonly discharge?: InputMaybe<Scalars['DateTime']>;
  readonly inpatientNumber?: InputMaybe<Scalars['String']>;
  readonly ward?: InputMaybe<Scalars['String']>;
};

export type SyncableInsuranceDetails = {
  readonly __typename?: 'SyncableInsuranceDetails';
  readonly dependent?: Maybe<Dependent>;
  readonly insuranceNumber?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type SyncableInsuranceDetailsInput = {
  readonly dependent?: InputMaybe<Dependent>;
  readonly insuranceNumber?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type SyncableInvestigationActivity = {
  readonly __typename?: 'SyncableInvestigationActivity';
  readonly catalogueItem: SyncableInvestigationCatalogueItem;
  readonly clinicalEvent?: Maybe<ClinicalEvent>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly outcome?: Maybe<SyncableInvestigationRequestOutcome>;
  readonly patientId: Scalars['ID'];
  readonly request: SyncableInvestigationRequestOutcome;
};

export type SyncableInvestigationCatalogueItem = {
  readonly __typename?: 'SyncableInvestigationCatalogueItem';
  readonly activityType: Scalars['String'];
  readonly coding?: Maybe<CatalogueCoding>;
  readonly id: Scalars['ID'];
  readonly keywords?: Maybe<ReadonlyArray<Maybe<I18nString>>>;
  readonly meta?: Maybe<SyncableMeta>;
  readonly result?: Maybe<InvestigationItemResult>;
  readonly title: I18nString;
  readonly version: Scalars['Int'];
};

export type SyncableInvestigationRequestOutcome = {
  readonly __typename?: 'SyncableInvestigationRequestOutcome';
  readonly clinic: SyncableFacilitySnapshot;
  readonly meta?: Maybe<Meta>;
  readonly orderedProperties: ReadonlyArray<Maybe<Scalars['JSONObject']>>;
  readonly organisation: SyncableFacilitySnapshot;
  readonly performer: SyncableElephantActor;
};

export type SyncableInvoice = {
  readonly __typename?: 'SyncableInvoice';
  readonly balance: SyncableBalance;
  readonly facilityId: Scalars['ID'];
  readonly finalizedAt?: Maybe<Scalars['DateTime']>;
  readonly finalizedByUserId?: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly inpatientDetails?: Maybe<SyncableInpatientDetails>;
  readonly invoiceNumber: Scalars['String'];
  readonly invoiceStatus: InvoiceStatus;
  readonly lineItems: ReadonlyArray<SyncableLineItem>;
  readonly meta: SyncableMeta;
  readonly patientId: Scalars['ID'];
  readonly patientType: PatientType;
  readonly payers: ReadonlyArray<SyncablePayer>;
  readonly priceListLastSyncedAt?: Maybe<Scalars['DateTime']>;
  readonly transactions: ReadonlyArray<SyncableTransaction>;
};

export type SyncableInvoiceInput = {
  readonly balance: SyncableBalanceInput;
  readonly facilityId: Scalars['ID'];
  readonly finalizedAt?: InputMaybe<Scalars['DateTime']>;
  readonly finalizedByUserId?: InputMaybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly inpatientDetails?: InputMaybe<SyncableInpatientDetailsInput>;
  readonly invoiceNumber: Scalars['String'];
  readonly invoiceStatus: InvoiceStatus;
  readonly lineItems: ReadonlyArray<SyncableLineItemInput>;
  readonly meta: SyncableMetaInput;
  readonly patientId: Scalars['ID'];
  readonly patientType: PatientType;
  readonly payers: ReadonlyArray<SyncablePayerInput>;
  readonly priceListLastSyncedAt?: InputMaybe<Scalars['DateTime']>;
  readonly transactions: ReadonlyArray<SyncableTransactionInput>;
};

export type SyncableLineItem = {
  readonly __typename?: 'SyncableLineItem';
  readonly actorId?: Maybe<Scalars['String']>;
  readonly automated?: Maybe<Scalars['Boolean']>;
  readonly cost: Scalars['Float'];
  readonly disabled?: Maybe<Scalars['Boolean']>;
  readonly externalReference?: Maybe<PriceableItemExternalReference>;
  readonly id: Scalars['ID'];
  readonly idempotencyKey?: Maybe<Scalars['String']>;
  readonly incurredAt?: Maybe<Scalars['DateTime']>;
  readonly missingPrice?: Maybe<Scalars['Boolean']>;
  readonly priceListItemId?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly revenueDepartmentId?: Maybe<Scalars['String']>;
  readonly supplier?: Maybe<LineItemSupplier>;
  readonly tariffId?: Maybe<Scalars['String']>;
};

export type SyncableLineItemExternalReferenceInput = {
  readonly foreignId: Scalars['String'];
  readonly origin: PriceableItemOrigin;
};

export type SyncableLineItemInput = {
  readonly actorId?: InputMaybe<Scalars['String']>;
  readonly automated?: InputMaybe<Scalars['Boolean']>;
  readonly cost: Scalars['Float'];
  readonly disabled?: InputMaybe<Scalars['Boolean']>;
  readonly externalReference?: InputMaybe<SyncableLineItemExternalReferenceInput>;
  readonly externalReferenceForeignId?: InputMaybe<Scalars['String']>;
  readonly externalReferenceOrigin?: InputMaybe<PriceableItemOrigin>;
  readonly id: Scalars['ID'];
  readonly idempotencyKey?: InputMaybe<Scalars['String']>;
  readonly incurredAt?: InputMaybe<Scalars['DateTime']>;
  readonly missingPrice?: InputMaybe<Scalars['Boolean']>;
  readonly priceListItemId?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
  readonly revenueDepartmentId?: InputMaybe<Scalars['String']>;
  readonly supplier?: InputMaybe<LineItemSupplier>;
  readonly tariffId?: InputMaybe<Scalars['String']>;
};

export type SyncableMeta = {
  readonly __typename?: 'SyncableMeta';
  readonly createdAt: Scalars['DateTime'];
  readonly createdByUserId: Scalars['ID'];
  readonly deleted: Scalars['Boolean'];
  readonly updatedAt: Scalars['DateTime'];
  readonly updatedByUserId: Scalars['ID'];
};

export type SyncableMetaInput = {
  readonly createdAt: Scalars['DateTime'];
  readonly createdByUserId: Scalars['ID'];
  readonly deleted: Scalars['Boolean'];
  readonly updatedAt: Scalars['DateTime'];
  readonly updatedByUserId: Scalars['ID'];
};

export type SyncableNonPharmaCategory = {
  readonly __typename?: 'SyncableNonPharmaCategory';
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly title: NonPharmaCategoryTitle;
};

export type SyncableNonPharmaItem = {
  readonly __typename?: 'SyncableNonPharmaItem';
  readonly brand?: Maybe<Scalars['String']>;
  readonly categoryId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly meta: SyncableMeta;
  readonly productType: ProductType;
  readonly snomedId?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type SyncablePatient = {
  readonly __typename?: 'SyncablePatient';
  readonly address: SyncablePatientAddress;
  /** @deprecated Card functionality is online-only */
  readonly card?: Maybe<SyncablePatientCard>;
  readonly consent: Consent;
  readonly dob: Scalars['Date'];
  readonly education?: Maybe<Education>;
  readonly facilityId: Scalars['String'];
  readonly gender: Gender;
  readonly guardians?: Maybe<ReadonlyArray<Guardian>>;
  readonly id: Scalars['ID'];
  readonly insurance?: Maybe<Insurance>;
  readonly maritalStatus: SyncablePatientMaritalStatus;
  readonly meta: SyncableMeta;
  readonly name: SyncablePatientName;
  readonly nationalId?: Maybe<SyncablePatientNationalId>;
  readonly nationality: Scalars['String'];
  readonly newToFacility: Scalars['Boolean'];
  readonly nextOfKin?: Maybe<SyncablePatientNextOfKin>;
  readonly organisationId: Scalars['String'];
  readonly phone?: Maybe<SyncablePatientPhone>;
  readonly registrationFee?: Maybe<SyncablePatientRegistrationFee>;
};

export type SyncablePatientAddress = {
  readonly __typename?: 'SyncablePatientAddress';
  readonly country: Scalars['String'];
  readonly line1: Scalars['String'];
  readonly line2: Scalars['String'];
  readonly line3?: Maybe<Scalars['String']>;
  readonly line4: Scalars['String'];
};

export type SyncablePatientAddressInput = {
  readonly country: Scalars['String'];
  readonly line1: Scalars['String'];
  readonly line2: Scalars['String'];
  readonly line3?: InputMaybe<Scalars['String']>;
  readonly line4: Scalars['String'];
};

export type SyncablePatientCard = {
  readonly __typename?: 'SyncablePatientCard';
  readonly id?: Maybe<Scalars['ID']>;
  readonly url?: Maybe<Scalars['ID']>;
};

export type SyncablePatientCardInput = {
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly url?: InputMaybe<Scalars['String']>;
};

export enum SyncablePatientMaritalStatus {
  Divorced = 'divorced',
  Married = 'married',
  Single = 'single',
  Unknown = 'unknown',
  Widowed = 'widowed'
}

export type SyncablePatientName = {
  readonly __typename?: 'SyncablePatientName';
  readonly first: Scalars['String'];
  readonly last: Scalars['String'];
  readonly middle?: Maybe<Scalars['String']>;
};

export type SyncablePatientNameInput = {
  readonly first: Scalars['String'];
  readonly last: Scalars['String'];
  readonly middle?: InputMaybe<Scalars['String']>;
};

export type SyncablePatientNationalId = {
  readonly __typename?: 'SyncablePatientNationalId';
  readonly owner: NationalIdOwner;
  readonly value: Scalars['String'];
};

export type SyncablePatientNationalIdInput = {
  readonly owner?: InputMaybe<NationalIdOwner>;
  readonly value?: InputMaybe<Scalars['String']>;
};

export type SyncablePatientNextOfKin = {
  readonly __typename?: 'SyncablePatientNextOfKin';
  readonly address?: Maybe<SyncablePatientNextOfKinAddress>;
  readonly fullName: Scalars['String'];
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly relationship?: Maybe<Scalars['String']>;
};

export type SyncablePatientNextOfKinAddress = {
  readonly __typename?: 'SyncablePatientNextOfKinAddress';
  readonly country?: Maybe<Scalars['String']>;
  readonly line1?: Maybe<Scalars['String']>;
  readonly line2?: Maybe<Scalars['String']>;
  readonly line3?: Maybe<Scalars['String']>;
  readonly line4?: Maybe<Scalars['String']>;
};

export type SyncablePatientNextOfKinAddressInput = {
  readonly country?: InputMaybe<Scalars['String']>;
  readonly line1?: InputMaybe<Scalars['String']>;
  readonly line2?: InputMaybe<Scalars['String']>;
  readonly line3?: InputMaybe<Scalars['String']>;
  readonly line4?: InputMaybe<Scalars['String']>;
};

export type SyncablePatientNextOfKinInput = {
  readonly address?: InputMaybe<SyncablePatientNextOfKinAddressInput>;
  readonly fullName: Scalars['String'];
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly relationship?: InputMaybe<Scalars['String']>;
};

export type SyncablePatientPhone = {
  readonly __typename?: 'SyncablePatientPhone';
  readonly number: Scalars['String'];
  readonly ownership: ContactPointOwnership;
};

export type SyncablePatientPhoneInput = {
  readonly number: Scalars['String'];
  readonly ownership: ContactPointOwnership;
};

export type SyncablePatientRegistrationFee = {
  readonly __typename?: 'SyncablePatientRegistrationFee';
  readonly paidOn: Scalars['Date'];
  readonly receiptNumber?: Maybe<Scalars['String']>;
};

export type SyncablePatientRegistrationFeeInput = {
  readonly paidOn: Scalars['Date'];
  readonly receiptNumber?: InputMaybe<Scalars['String']>;
};

export type SyncablePayer = {
  readonly __typename?: 'SyncablePayer';
  readonly balance: SyncableBalance;
  readonly claimedLineItems: ReadonlyArray<SyncableClaimedLineItem>;
  readonly id: Scalars['ID'];
  readonly insuranceDetails?: Maybe<SyncableInsuranceDetails>;
  readonly name: Scalars['String'];
  readonly type: PayerType;
};

export type SyncablePayerInput = {
  readonly balance: SyncableBalanceInput;
  readonly claimedLineItems?: InputMaybe<ReadonlyArray<SyncableClaimedLineItemInput>>;
  readonly id: Scalars['ID'];
  readonly insuranceDetails?: InputMaybe<SyncableInsuranceDetailsInput>;
  readonly name: Scalars['String'];
  readonly type: PayerType;
};

export type SyncablePrescription = {
  readonly __typename?: 'SyncablePrescription';
  readonly administrationApproach: AdministrationApproach;
  readonly cancellationDetails?: Maybe<CancellationDetails>;
  readonly clinicalEvent: ClinicalEvent;
  readonly clinicalProduct?: Maybe<ClinicalProductRef>;
  readonly dosage: DoseMeasurement;
  readonly facilityId: Scalars['ID'];
  readonly frequency: Frequency;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly minimumDoseInterval?: Maybe<MinimumDoseInterval>;
  readonly note?: Maybe<Scalars['String']>;
  readonly patientId: Scalars['ID'];
  readonly prescribableItemFreeText?: Maybe<Scalars['String']>;
  readonly prescribableItemType: PrescribableItemType;
  readonly prescribedByUserId: Scalars['ID'];
  readonly rate?: Maybe<RateMeasurement>;
  readonly startsAt: Scalars['DateTime'];
  readonly stopsAt: Scalars['DateTime'];
};

export type SyncablePrice = {
  readonly __typename?: 'SyncablePrice';
  readonly id: Scalars['ID'];
  readonly itemId: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly priceListId: Scalars['ID'];
  readonly revenueDepartmentId: Scalars['ID'];
  readonly tariffId: Scalars['ID'];
  readonly value: Scalars['Int'];
};

export type SyncablePriceAcknowledgement = {
  readonly __typename?: 'SyncablePriceAcknowledgement';
  readonly acknowledgedAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly userId: Scalars['ID'];
};

export type SyncablePriceAcknowledgementInput = {
  readonly acknowledgedAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly meta: SyncablePriceAcknowledgementMetaInput;
  readonly userId: Scalars['ID'];
};

export type SyncablePriceAcknowledgementMetaInput = {
  readonly createdAt: Scalars['DateTime'];
  readonly createdByUserId: Scalars['ID'];
  readonly deleted: Scalars['Boolean'];
  readonly updatedAt: Scalars['DateTime'];
  readonly updatedByUserId: Scalars['ID'];
};

export type SyncablePriceListFacility = {
  readonly __typename?: 'SyncablePriceListFacility';
  readonly id: Scalars['ID'];
  readonly linkedOrganisationPriceListId?: Maybe<Scalars['ID']>;
  readonly meta: SyncableMeta;
  readonly organisationId: Scalars['ID'];
  readonly priceListId?: Maybe<Scalars['ID']>;
};

export type SyncablePriceListItem = {
  readonly __typename?: 'SyncablePriceListItem';
  readonly active: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
};

export type SyncablePriceListItemExternalReference = {
  readonly __typename?: 'SyncablePriceListItemExternalReference';
  readonly foreignId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly itemId: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly origin: PriceableItemOrigin;
};

export type SyncablePriceListItemName = {
  readonly __typename?: 'SyncablePriceListItemName';
  readonly id: Scalars['ID'];
  readonly itemId: Scalars['ID'];
  readonly language: PriceableItemLanguage;
  readonly meta: SyncableMeta;
  readonly name: Scalars['String'];
};

export type SyncablePriceListRevenueDepartment = {
  readonly __typename?: 'SyncablePriceListRevenueDepartment';
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly name: Scalars['String'];
};

export type SyncablePriceListTariff = {
  readonly __typename?: 'SyncablePriceListTariff';
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly name: Scalars['String'];
};

export type SyncableReferral = {
  readonly __typename?: 'SyncableReferral';
  readonly facilityId?: Maybe<Scalars['ID']>;
  readonly freeTextFacility?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly notes?: Maybe<Scalars['String']>;
  readonly patientId: Scalars['ID'];
  readonly reasons: ReadonlyArray<Scalars['String']>;
};

export type SyncableReferralFeedback = {
  readonly __typename?: 'SyncableReferralFeedback';
  readonly feedbackType: ReferralFeedbackType;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly patientId: Scalars['ID'];
  readonly referralId: Scalars['ID'];
};

export type SyncableSymptom = {
  readonly __typename?: 'SyncableSymptom';
  readonly externalCoding?: Maybe<ExternalCoding>;
  readonly i18n: ReadonlyArray<SymptomI18NSchema>;
  readonly id: Scalars['ID'];
  readonly meta: SyncableMeta;
  readonly name: Scalars['String'];
};

export type SyncableTransaction = {
  readonly __typename?: 'SyncableTransaction';
  readonly actionedByUserId?: Maybe<Scalars['ID']>;
  readonly amount?: Maybe<SyncableAmount>;
  readonly currencyExchange?: Maybe<SyncableCurrencyExchange>;
  readonly exemptionType?: Maybe<ExemptionType>;
  readonly id: Scalars['ID'];
  readonly notes?: Maybe<Scalars['String']>;
  readonly payerName?: Maybe<Scalars['String']>;
  readonly payerType?: Maybe<PayerType>;
  readonly paymentAuthCode?: Maybe<Scalars['String']>;
  readonly paymentMethod?: Maybe<PaymentMethod>;
  readonly refundAuthCode?: Maybe<Scalars['String']>;
  readonly refundPaymentMethod?: Maybe<PaymentMethod>;
  readonly refundReason?: Maybe<Scalars['String']>;
  readonly status: TransactionStatus;
  readonly timestamp: Scalars['DateTime'];
  readonly type: TransactionType;
  readonly uuid?: Maybe<Scalars['String']>;
};

export type SyncableTransactionInput = {
  readonly actionedByUserId?: InputMaybe<Scalars['ID']>;
  readonly amount?: InputMaybe<SyncableAmountInput>;
  readonly currencyExchange?: InputMaybe<SyncableCurrencyExchangeInput>;
  readonly exemptionType?: InputMaybe<ExemptionType>;
  readonly id: Scalars['ID'];
  readonly notes?: InputMaybe<Scalars['String']>;
  readonly payerName?: InputMaybe<Scalars['String']>;
  readonly payerType?: InputMaybe<PayerType>;
  readonly paymentAuthCode?: InputMaybe<Scalars['String']>;
  readonly paymentMethod?: InputMaybe<PaymentMethod>;
  readonly refundAuthCode?: InputMaybe<Scalars['String']>;
  readonly refundPaymentMethod?: InputMaybe<PaymentMethod>;
  readonly refundReason?: InputMaybe<Scalars['String']>;
  readonly status: TransactionStatus;
  readonly timestamp: Scalars['DateTime'];
  readonly type: TransactionType;
  readonly uuid?: InputMaybe<Scalars['String']>;
};

export type SyncableVmp = {
  readonly __typename?: 'SyncableVmp';
  readonly categoryId?: Maybe<Scalars['String']>;
  readonly formId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly legacyMedicationId?: Maybe<Scalars['String']>;
  readonly meta: SyncableMeta;
  readonly productType: ProductType;
  readonly snomedId?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly vtmId: Scalars['String'];
};

export type SyncableVtm = {
  readonly __typename?: 'SyncableVtm';
  readonly id: Scalars['ID'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly meta: SyncableMeta;
  readonly productType: ProductType;
  readonly snomedId?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type TakePaymentInput = {
  readonly _id: Scalars['String'];
  readonly transactions: ReadonlyArray<InputMaybe<TransactionInput>>;
};

export type TestResult = {
  readonly __typename?: 'TestResult';
  readonly _id: Scalars['ID'];
  readonly clinic: Scalars['ID'];
  readonly interpreter?: Maybe<Scalars['ID']>;
  readonly meta: Meta;
  readonly patient: Scalars['ID'];
  readonly results?: Maybe<ReadonlyArray<Maybe<TestResultResults>>>;
  readonly unit?: Maybe<Scalars['String']>;
  readonly uuid?: Maybe<Scalars['ID']>;
};

export type TestResultPaginatedOffset = {
  readonly __typename?: 'TestResultPaginatedOffset';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<TestResult>>;
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type TestResultResults = {
  readonly __typename?: 'TestResultResults';
  readonly investigation?: Maybe<Scalars['ID']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly result?: Maybe<ReadonlyArray<Maybe<TestResultResultsResult>>>;
};

export type TestResultResultsResult = {
  readonly __typename?: 'TestResultResultsResult';
  readonly displayName?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly unit?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['String']>;
};

export type TestResultsExportInput = {
  readonly options: TestResultsExportOptions;
  readonly params: TestResultsExportParams;
};

export type TestResultsExportOptions = {
  readonly clinicUuids: ReadonlyArray<Scalars['ID']>;
};

export type TestResultsExportPage = {
  readonly __typename?: 'TestResultsExportPage';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<TestResult>>;
};

export type TestResultsExportParams = {
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
};

export type TestResultsInput = {
  readonly interOrgFlag?: InputMaybe<Scalars['Boolean']>;
  readonly patientUuid: Scalars['ID'];
};

export enum TimeUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type Transaction = {
  readonly __typename?: 'Transaction';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly actionedBy?: Maybe<InvoiceUser>;
  readonly amount?: Maybe<Amount>;
  readonly currencyExchange?: Maybe<CurrencyExchange>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly payer?: Maybe<Payer>;
  readonly payment?: Maybe<PaymentDetails>;
  readonly refund?: Maybe<RefundDetails>;
  readonly status?: Maybe<TransactionStatus>;
  readonly timestamp?: Maybe<Scalars['DateTime']>;
  readonly type?: Maybe<TransactionType>;
};

export type TransactionInput = {
  readonly amount: AmountInput;
  readonly currencyExchange?: InputMaybe<CurrencyExchangeInput>;
  readonly payer: TransactionPayerInput;
  readonly payment?: InputMaybe<PaymentDetailsInput>;
};

export type TransactionPayerInput = {
  readonly name: Scalars['String'];
  readonly type: PayerType;
};

export enum TransactionStatus {
  Fail = 'FAIL',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum TransactionType {
  ChargeInsurer = 'CHARGE_INSURER',
  Exempt = 'EXEMPT',
  Payment = 'PAYMENT',
  Refund = 'REFUND',
  Void = 'VOID',
  Waiver = 'WAIVER'
}

export type TriageStatus = {
  readonly __typename?: 'TriageStatus';
  readonly _id: Scalars['ID'];
  readonly clinicUuid: Scalars['String'];
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly currentStatus?: Maybe<TriageStatusType>;
  readonly expiresAt?: Maybe<Scalars['DateTime']>;
  readonly isInAQueue?: Maybe<Scalars['Boolean']>;
  readonly isInpatient?: Maybe<Scalars['Boolean']>;
  readonly organisationUuid: Scalars['String'];
  readonly patientUuid: Scalars['String'];
  readonly performer: ElephantActor;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TriageStatusOfQueue = {
  readonly __typename?: 'TriageStatusOfQueue';
  readonly _id: Scalars['ID'];
  readonly clinicUuid: Scalars['String'];
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly currentStatus?: Maybe<Scalars['String']>;
  readonly expiresAt?: Maybe<Scalars['DateTime']>;
  readonly organisationUuid: Scalars['String'];
  readonly patientUuid: Scalars['String'];
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum TriageStatusType {
  Blue = 'BLUE',
  Green = 'GREEN',
  None = 'NONE',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type UiDefault = {
  readonly __typename?: 'UiDefault';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly namespace: Scalars['String'];
  readonly scope: DefaultScope;
  readonly value: Scalars['JSONObject'];
};

export type UpdateAmpInput = {
  readonly id: Scalars['String'];
  readonly keywords?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
};

export type UpdateAncEncounterInput = {
  readonly ageOfPregnancy?: InputMaybe<Scalars['Int']>;
  readonly aliveBirths?: InputMaybe<Scalars['Int']>;
  readonly associatedProblems?: InputMaybe<Scalars['String']>;
  readonly bloodGroup?: InputMaybe<AncBloodGroup>;
  readonly dangerSigns?: InputMaybe<ReadonlyArray<AncDangerSign>>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']>;
  readonly earlyInitiationOfBreastfeeding?: InputMaybe<Scalars['Boolean']>;
  readonly exclusiveBreastfeeding?: InputMaybe<Scalars['Boolean']>;
  readonly femaleGenitalMutilation?: InputMaybe<Scalars['Boolean']>;
  readonly gravidity?: InputMaybe<Scalars['Int']>;
  readonly hepatitisBInvestigation: ReadonlyArray<InputMaybe<AncInvestigationOutcome>>;
  readonly hepatitisCInvestigation: ReadonlyArray<InputMaybe<AncInvestigationOutcome>>;
  readonly hivTesting?: InputMaybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly iptpDoseOverride?: InputMaybe<Scalars['Int']>;
  readonly lastMenstrualPeriod?: InputMaybe<Scalars['DateTime']>;
  readonly livingChildren?: InputMaybe<Scalars['Int']>;
  readonly longLastingInsecticidalNet?: InputMaybe<Scalars['Boolean']>;
  readonly maritalStatus?: InputMaybe<AncMaritalStatus>;
  readonly maternalNutrition?: InputMaybe<Scalars['Boolean']>;
  readonly parityDeliveries?: InputMaybe<Scalars['Int']>;
  readonly parityMiscarriages?: InputMaybe<Scalars['Int']>;
  readonly priorPregnancies?: InputMaybe<ReadonlyArray<AncPriorPregnancyInput>>;
  readonly referralHospital?: InputMaybe<Scalars['String']>;
  readonly rhesusFactor?: InputMaybe<AncRhesusFactor>;
  readonly status?: InputMaybe<AncEncounterStatus>;
  readonly syphilisInvestigation: ReadonlyArray<InputMaybe<AncInvestigationOutcome>>;
  readonly visitNumber?: InputMaybe<Scalars['Int']>;
};

export type UpdateClinicInput = {
  readonly addresses?: InputMaybe<ReadonlyArray<InputMaybe<AddressInput>>>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly settings?: InputMaybe<UpdateClinicSettings>;
};

export type UpdateClinicSettings = {
  readonly billingMode?: InputMaybe<BillingMode>;
  readonly inventoryManagement?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCurrentVisitInput = {
  readonly patientId: Scalars['ID'];
  readonly visitInsuranceDetails?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateDepartmentInput = {
  readonly clinicId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly isInventoryLocation?: InputMaybe<Scalars['Boolean']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly orgId?: InputMaybe<Scalars['String']>;
  readonly tag?: InputMaybe<StockLocationTag>;
};

export type UpdateEpocusProgramInput = {
  /** Omit to leave unchanged. PORTAL is the only method wired up. */
  readonly billingDeliveryMethod?: InputMaybe<EpocusBillingDeliveryMethod>;
  /**
   * The local "HH:mm" a program treats as end of day. Display only — nothing
   * schedules against it. Omit to leave unchanged; pass null to clear.
   */
  readonly billingEndOfDayTime?: InputMaybe<Scalars['String']>;
  /**
   * Elephant admins only. Omit to leave unchanged; pass null to clear, so the
   * modifier follows clinicalSetting.
   */
  readonly billingModifierOverride?: InputMaybe<EpocusBillingModifierOverride>;
  /**
   * Where an encrypted-email batch would be sent. Omit to leave unchanged; pass
   * null to clear. Not required for PORTAL delivery.
   */
  readonly billingRecipientEmail?: InputMaybe<Scalars['String']>;
  /**
   * Who the end-of-day billing batch is addressed to. Omit to leave unchanged;
   * pass null to clear.
   */
  readonly billingRecipientName?: InputMaybe<Scalars['String']>;
  /** Elephant admins only. Omit to leave unchanged. */
  readonly clinicalSetting?: InputMaybe<EpocusProgramClinicalSetting>;
  /**
   * Supervised scans a performer completes before they are credentialed. Omit
   * to leave unchanged; pass null to unset. Stored under supervisedScans in the
   * config's credentialingThresholds and readable back as
   * programConfig.credentialingThreshold.
   */
  readonly credentialingThreshold?: InputMaybe<Scalars['Int']>;
  /**
   * Omit to leave unchanged. Does NOT re-derive dimseAeTitle: the title is
   * generated from the name once, at creation, and routes and field devices are
   * already keyed on it. This is a display-name correction only.
   */
  readonly name?: InputMaybe<Scalars['String']>;
  /**
   * Elephant admins only. Territory-agnostic, e.g. a US ZIP code; a US ZIP
   * sets the Medicare locality that prices this program's charge lines. Omit to
   * leave unchanged; pass null to clear, which leaves every line without an
   * estimate.
   */
  readonly postalCode?: InputMaybe<Scalars['String']>;
  readonly programId: Scalars['ID'];
  /**
   * Percentage of exams to sample for QA, 0-100. Omit to leave unchanged; pass
   * null to return it to unconfigured, which is distinct from 0 — 0 means
   * sample nothing.
   */
  readonly qaSamplingRatePercent?: InputMaybe<Scalars['Int']>;
  /**
   * Elephant admins only. Local HH:mm the daily incomplete-studies email goes
   * out. Omit to leave unchanged; pass null to return it to the default, 17:00.
   */
  readonly reminderEmailTime?: InputMaybe<Scalars['String']>;
  /**
   * Omit to leave unchanged. DISABLED stops routing to the program and strips
   * the ePOCUS role every membership of it granted; it does not release the AE
   * title, and it does not disable anyone's login.
   */
  readonly status?: InputMaybe<EpocusProgramStatus>;
  /**
   * Elephant admins only. IANA time zone the reminder email's send time is
   * read in. Omit to leave unchanged; pass null to return it to the default,
   * America/New_York.
   */
  readonly timezone?: InputMaybe<Scalars['String']>;
  /**
   * Minutes from submission to sign-off this program treats as on time. Omit to
   * leave unchanged; pass null to return it to unconfigured.
   */
  readonly turnaroundTargetMinutes?: InputMaybe<Scalars['Int']>;
  /** Elephant admins only. Omit to leave unchanged. */
  readonly worksheetSet?: InputMaybe<EpocusWorksheetSet>;
};

export type UpdateEpocusUserInput = {
  readonly epocusUserId: Scalars['ID'];
  /** Omit any of these to leave it unchanged. */
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  /**
   * DISABLED revokes this person's membership of this program. Their login,
   * profile and other program memberships are untouched — disabling the person
   * entirely is setEpocusUserEnabled.
   */
  readonly membershipStatus?: InputMaybe<EpocusMembershipStatus>;
  /** Null clears it. */
  readonly npi?: InputMaybe<Scalars['String']>;
  readonly programId: Scalars['ID'];
  readonly role?: InputMaybe<EpocusRole>;
  readonly telephone?: InputMaybe<Scalars['String']>;
};

export type UpdateInpatientDepartmentInput = {
  readonly departmentId: Scalars['ID'];
  readonly patientUuid?: InputMaybe<Scalars['ID']>;
  readonly visitId?: InputMaybe<Scalars['ID']>;
};

export type UpdateInpatientLocationInput = {
  readonly locationId: Scalars['ID'];
  readonly patientUuid?: InputMaybe<Scalars['ID']>;
  readonly visitId?: InputMaybe<Scalars['ID']>;
};

export type UpdateLotInput = {
  readonly expiryDate: Scalars['Date'];
  readonly facilityId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly quantity: Scalars['Int'];
  readonly reasonForChange: ChangeReason;
  readonly reasonForChangeText?: InputMaybe<Scalars['String']>;
};

export type UpdateMyEpocusUserInput = {
  /** Omit any of these to leave it unchanged. */
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  /**
   * Null clears it; omitting it leaves it alone. Billing status is recomputed
   * for every study you rendered.
   */
  readonly npi?: InputMaybe<Scalars['String']>;
  /** Omit to leave unchanged. */
  readonly reminderEmailEnabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Local HH:mm in your program's time zone. Null returns it to the program's
   * send time; omitting it leaves it alone.
   */
  readonly reminderEmailTime?: InputMaybe<Scalars['String']>;
  /** Null clears it; omitting it leaves it alone. */
  readonly telephone?: InputMaybe<Scalars['String']>;
};

export type UpdateNonPharmaItemInput = {
  readonly brand?: InputMaybe<Scalars['String']>;
  readonly categoryId: Scalars['String'];
  readonly id: Scalars['String'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly snomedId?: InputMaybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type UpdateOrganisationInput = {
  readonly addresses?: InputMaybe<ReadonlyArray<InputMaybe<AddressInput>>>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly settings?: InputMaybe<UpdateOrganisationSettingsInput>;
};

export type UpdateOrganisationSettingsInput = {
  readonly billingMode?: InputMaybe<BillingMode>;
};

export type UpdatePatientDiagnosesInLocationInput = {
  readonly diagnoses: ReadonlyArray<I18nStringInput>;
  readonly locationID: Scalars['ID'];
  readonly patientID: Scalars['ID'];
};

export type UpdatePatientInput = {
  readonly accessToHealthRecords?: InputMaybe<Scalars['Boolean']>;
  readonly address?: InputMaybe<AddressInput>;
  readonly consent?: InputMaybe<ConsentInput>;
  readonly dob?: InputMaybe<Scalars['Date']>;
  readonly education?: InputMaybe<EducationInput>;
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly gender?: InputMaybe<Gender>;
  readonly insurance?: InputMaybe<InsuranceInput>;
  readonly isNew?: InputMaybe<Scalars['Boolean']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly locale?: InputMaybe<Scalars['String']>;
  readonly maritalStatus?: InputMaybe<MaritalStatus>;
  readonly middleName?: InputMaybe<Scalars['String']>;
  readonly nationalIdMeta?: InputMaybe<NationalIdMetaInput>;
  readonly nationalIdNumber?: InputMaybe<Scalars['String']>;
  readonly nationality?: InputMaybe<Scalars['String']>;
  readonly nextOfKin?: InputMaybe<NextOfKinInput>;
  readonly patientHasInsurance?: InputMaybe<PatientHasInsurance>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly phoneOwnership?: InputMaybe<ContactPointOwnership>;
};

export type UpdatePatientInsuranceDetailsInput = {
  readonly insurance: InsuranceInput;
  readonly uuid: Scalars['String'];
};

export type UpdatePatientTriageStatus = {
  readonly doNotExpire?: InputMaybe<Scalars['Boolean']>;
  readonly newTriageStatus: TriageStatusType;
  readonly triageStatusId: Scalars['ID'];
};

export type UpdateSkuInput = {
  readonly id: Scalars['ID'];
  readonly measurement?: InputMaybe<SkuMeasurementInput>;
  readonly name: Scalars['String'];
};

export type UpdateUserInput = {
  readonly _id: Scalars['String'];
  readonly clinic?: InputMaybe<Scalars['String']>;
  readonly consent?: InputMaybe<UpdateUserInputConsent>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly password?: InputMaybe<Scalars['String']>;
  readonly person?: InputMaybe<PersonInput>;
  readonly role_id?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInputConsent = {
  readonly marketing?: InputMaybe<Scalars['Boolean']>;
  readonly privacyPolicy?: InputMaybe<Scalars['Boolean']>;
  /**
   * While we're storing all consent in Auth0, we don't have need for this. One cannot pass the
   * login consent form without both this and {privacyPolicy} being true.
   * We should however use it in the API as it clears up the confusion between what is being
   * consented to in the front end, and when we come later saving this value in our own DB instead,
   * which will need to be done to solve for not exporting non-consenting user data, we can have
   * clarity.
   */
  readonly softwareTermsOfUse?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateVmpInput = {
  readonly categoryId?: InputMaybe<Scalars['String']>;
  readonly formulationId: Scalars['String'];
  readonly id: Scalars['String'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly legacyMedicationId?: InputMaybe<Scalars['String']>;
  readonly snomedId?: InputMaybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type UpdateVtmInput = {
  readonly id: Scalars['String'];
  readonly keywords?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly snomedId?: InputMaybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type UpsertItemPriceInput = {
  readonly revenueDepartmentId: Scalars['ID'];
  readonly tariffId: Scalars['ID'];
  readonly value: Scalars['Int'];
};

export type UpsertPriceableItemInput = {
  readonly externalReference: PriceableItemExternalReferenceInput;
  readonly name: Scalars['String'];
  readonly prices: ReadonlyArray<UpsertItemPriceInput>;
};

export type UpsertPricesAndPriceableItemsInput = {
  readonly language: PriceableItemLanguage;
  readonly priceListId: Scalars['ID'];
  readonly priceableItems: ReadonlyArray<UpsertPriceableItemInput>;
};

export type UpsertPricesAndPriceableItemsResponse = {
  readonly __typename?: 'UpsertPricesAndPriceableItemsResponse';
  /** @deprecated Contains a bug. See TODO in resolver. */
  readonly items: ReadonlyArray<PriceableItem>;
  readonly totalItemsUpserted: Scalars['Int'];
  readonly totalPricesUpserted: Scalars['Int'];
};

export type UpsertUiDefaultInput = {
  readonly name: Scalars['String'];
  readonly namespace: Scalars['String'];
  readonly scope: DefaultScope;
  readonly value: Scalars['JSONObject'];
};

export type User = {
  readonly __typename?: 'User';
  readonly _id: Scalars['ID'];
  readonly blocks?: Maybe<Blocks>;
  readonly clinic?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly meta?: Maybe<UserMeta>;
  readonly mfa?: Maybe<Mfa>;
  readonly organisation?: Maybe<Scalars['String']>;
  readonly person?: Maybe<UserPerson>;
  readonly role?: Maybe<LegacyRole>;
  readonly role_id?: Maybe<Scalars['String']>;
  /** @deprecated Use _id instead */
  readonly uuid?: Maybe<Scalars['String']>;
};

export type UserMeta = {
  readonly __typename?: 'UserMeta';
  readonly active?: Maybe<Scalars['Boolean']>;
  readonly created?: Maybe<Scalars['DateTime']>;
  readonly updated?: Maybe<Scalars['DateTime']>;
};

export type UserMutationResponse = {
  readonly __typename?: 'UserMutationResponse';
  readonly didSucceed?: Maybe<Scalars['Boolean']>;
};

export type UserPage = {
  readonly __typename?: 'UserPage';
  readonly limit?: Maybe<Scalars['Int']>;
  readonly page?: Maybe<Scalars['Int']>;
  readonly pages?: Maybe<Scalars['Int']>;
  readonly total?: Maybe<Scalars['Int']>;
  readonly users?: Maybe<ReadonlyArray<Maybe<User>>>;
};

export type UserPerson = {
  readonly __typename?: 'UserPerson';
  readonly consent: UserPersonConsent;
  readonly dob?: Maybe<Scalars['String']>;
  readonly firstname?: Maybe<Scalars['String']>;
  readonly gender?: Maybe<Scalars['String']>;
  readonly languages?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lastname?: Maybe<Scalars['String']>;
  readonly middlename?: Maybe<Scalars['String']>;
  readonly telephone?: Maybe<Scalars['String']>;
  /** @deprecated Use `consent`. */
  readonly whatsappConsent: Scalars['Boolean'];
};

export type UserPersonConsent = {
  readonly __typename?: 'UserPersonConsent';
  readonly marketing: Scalars['Boolean'];
  readonly whatsapp: Scalars['Boolean'];
};

export type UsersFilters = {
  readonly clinic?: InputMaybe<Scalars['String']>;
  readonly organisation?: InputMaybe<Scalars['String']>;
};

export type Visit = {
  readonly __typename?: 'Visit';
  readonly _id: Scalars['ID'];
  readonly active?: Maybe<Scalars['Boolean']>;
  readonly admissionEvent?: Maybe<VisitCareEvent>;
  readonly careEvents: ReadonlyArray<Maybe<VisitCareEvent>>;
  readonly clinic?: Maybe<Scalars['String']>;
  readonly currentDepartment?: Maybe<VisitDepartmentSnapshot>;
  readonly currentLocation?: Maybe<VisitLocationSnapshot>;
  readonly dischargeEvent?: Maybe<VisitCareEvent>;
  readonly expiryStrategy?: Maybe<VisitExpiryStrategy>;
  readonly inpatientDepartments?: Maybe<ReadonlyArray<Maybe<VisitDepartmentSnapshot>>>;
  readonly inpatientLocations?: Maybe<ReadonlyArray<Maybe<VisitLocationSnapshot>>>;
  readonly inpatientMedicineAdministered?: Maybe<ReadonlyArray<Maybe<VisitMedicineAdministered>>>;
  readonly insuranceList?: Maybe<ReadonlyArray<Maybe<InsuranceListItem>>>;
  readonly isCurrent?: Maybe<Scalars['Boolean']>;
  readonly meta?: Maybe<VisitMeta>;
  readonly patient?: Maybe<VisitPatient>;
  readonly uuid?: Maybe<Scalars['ID']>;
  readonly vitals?: Maybe<VisitPatientVitals>;
};


export type VisitCareEventsArgs = {
  input?: InputMaybe<VisitCareEventsInput>;
};

export type VisitCareEvent = {
  readonly __typename?: 'VisitCareEvent';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly catalogueItem?: Maybe<Scalars['JSONObject']>;
  readonly created?: Maybe<Scalars['DateTime']>;
  readonly department?: Maybe<VisitDepartmentSnapshot>;
  readonly diagnosisList?: Maybe<ReadonlyArray<Maybe<Diagnosis>>>;
  readonly investigationActivity?: Maybe<VisitInvestigationActivity>;
  readonly location?: Maybe<VisitLocationSnapshot>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly originatingService?: Maybe<Scalars['String']>;
  readonly outcome?: Maybe<DischargeOutcome>;
  readonly performer?: Maybe<VisitElephantActor>;
  readonly prescriptionUuid?: Maybe<Scalars['String']>;
  readonly type?: Maybe<VisitCareEventAction>;
};

export enum VisitCareEventAction {
  Detention = 'DETENTION',
  Diagnosis = 'DIAGNOSIS',
  InpatientAdmission = 'INPATIENT_ADMISSION',
  InpatientCareNote = 'INPATIENT_CARE_NOTE',
  InpatientDischarge = 'INPATIENT_DISCHARGE',
  InpatientMoveDepartment = 'INPATIENT_MOVE_DEPARTMENT',
  InpatientUpdateLocation = 'INPATIENT_UPDATE_LOCATION',
  InvestigationOutcome = 'INVESTIGATION_OUTCOME',
  InvestigationRequest = 'INVESTIGATION_REQUEST',
  InvestigationResults = 'INVESTIGATION_RESULTS',
  MedicineAdministered = 'MEDICINE_ADMINISTERED',
  MedicineDispensed = 'MEDICINE_DISPENSED',
  MedicinePrescribed = 'MEDICINE_PRESCRIBED',
  MedicineStopped = 'MEDICINE_STOPPED'
}

export type VisitCareEventInput = {
  readonly careEventAction: VisitCareEventAction;
  readonly careEventId: Scalars['String'];
  readonly created: Scalars['DateTime'];
  readonly originatingService?: InputMaybe<Scalars['String']>;
  readonly prescriptionUuid?: InputMaybe<Scalars['String']>;
};

export type VisitCareEventsInput = {
  readonly types: ReadonlyArray<VisitCareEventAction>;
};

export type VisitCatalogueCoding = {
  readonly __typename?: 'VisitCatalogueCoding';
  readonly loinc?: Maybe<SpecificationReference>;
};

export type VisitDepartmentSnapshot = {
  readonly __typename?: 'VisitDepartmentSnapshot';
  readonly _id: Scalars['ID'];
  readonly careEventCreatedAt?: Maybe<Scalars['DateTime']>;
  readonly performer?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type VisitElephantActor = {
  readonly __typename?: 'VisitElephantActor';
  readonly _id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly role?: Maybe<Scalars['String']>;
};

export enum VisitExpiryStrategy {
  Midnight = 'MIDNIGHT',
  UntilDischarged = 'UNTIL_DISCHARGED'
}

export type VisitFacilitySnapshot = {
  readonly __typename?: 'VisitFacilitySnapshot';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly name: Scalars['String'];
  readonly uuid: Scalars['ID'];
};

export type VisitInsurance = {
  readonly __typename?: 'VisitInsurance';
  readonly insuranceProvider?: Maybe<InsuranceProvider>;
  readonly insuranceType: Scalars['String'];
  readonly name?: Maybe<Scalars['String']>;
  readonly visitValidation?: Maybe<VisitValidation>;
};

export type VisitInvestigationActivity = {
  readonly __typename?: 'VisitInvestigationActivity';
  readonly _id: Scalars['ID'];
  readonly catalogueItem: VisitInvestigationActivityItem;
  readonly meta: Meta;
  readonly outcome?: Maybe<VisitInvestigationRequestOutcome>;
  readonly request?: Maybe<VisitInvestigationRequestOutcome>;
  readonly void: Scalars['Boolean'];
};

export type VisitInvestigationActivityItem = {
  readonly __typename?: 'VisitInvestigationActivityItem';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly activityType: Scalars['String'];
  readonly coding?: Maybe<VisitCatalogueCoding>;
  readonly keywords?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly meta?: Maybe<Meta>;
  readonly result?: Maybe<VisitInvestigationItemResult>;
  readonly title?: Maybe<Scalars['String']>;
};

export type VisitInvestigationItemResult = {
  readonly __typename?: 'VisitInvestigationItemResult';
  readonly resultSchema: Scalars['JSONObject'];
};

export type VisitInvestigationLocationSnapshot = {
  readonly __typename?: 'VisitInvestigationLocationSnapshot';
  readonly _id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type VisitInvestigationRequestOutcome = {
  readonly __typename?: 'VisitInvestigationRequestOutcome';
  readonly _id: Scalars['ID'];
  readonly clinic: VisitFacilitySnapshot;
  readonly location?: Maybe<VisitInvestigationLocationSnapshot>;
  readonly meta: Meta;
  readonly orderedProperties: ReadonlyArray<Maybe<Scalars['JSONObject']>>;
  readonly organisation: VisitFacilitySnapshot;
  readonly performer: VisitElephantActor;
};

export type VisitLocationSnapshot = {
  readonly __typename?: 'VisitLocationSnapshot';
  readonly _id: Scalars['ID'];
  readonly bedCount?: Maybe<Scalars['Int']>;
  readonly color?: Maybe<Scalars['String']>;
  readonly created?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly performer?: Maybe<Scalars['String']>;
};

export type VisitMedicineAdministered = {
  readonly __typename?: 'VisitMedicineAdministered';
  readonly created?: Maybe<Scalars['String']>;
  readonly dosageUnit?: Maybe<Scalars['String']>;
  readonly dosageValue?: Maybe<Scalars['Float']>;
  readonly prescriber?: Maybe<Scalars['String']>;
  readonly skuId: Scalars['String'];
  readonly skuName?: Maybe<Scalars['String']>;
  readonly totalAdministeredQuantity?: Maybe<Scalars['Int']>;
};

export type VisitMeta = {
  readonly __typename?: 'VisitMeta';
  readonly created?: Maybe<Scalars['DateTime']>;
};

export type VisitPatient = {
  readonly __typename?: 'VisitPatient';
  readonly _id?: Maybe<Scalars['ID']>;
  readonly dob?: Maybe<Scalars['Date']>;
  readonly gender?: Maybe<Gender>;
  readonly name?: Maybe<Scalars['String']>;
  readonly uuid: Scalars['ID'];
};

export type VisitPatientVital = {
  readonly __typename?: 'VisitPatientVital';
  readonly id: Scalars['ID'];
  readonly values: ReadonlyArray<Maybe<VitalLineItem>>;
  readonly visitId: Scalars['ID'];
};

export type VisitPatientVitals = {
  readonly __typename?: 'VisitPatientVitals';
  readonly bpDiastolic?: Maybe<VisitPatientVital>;
  readonly bpSystolic?: Maybe<VisitPatientVital>;
  readonly heartRate?: Maybe<VisitPatientVital>;
  readonly id: Scalars['ID'];
  readonly oxygenSaturation?: Maybe<VisitPatientVital>;
  readonly respiratoryRate?: Maybe<VisitPatientVital>;
  readonly temperature?: Maybe<VisitPatientVital>;
};

export type VisitValidation = {
  readonly __typename?: 'VisitValidation';
  readonly expiryStrategy?: Maybe<VisitExpiryStrategy>;
};

export type VisitWithFilteredNotesInput = {
  readonly id: Scalars['ID'];
  readonly role: VisitWithFilteredNotesRole;
};

export enum VisitWithFilteredNotesRole {
  Doctor = 'DOCTOR',
  Nurse = 'NURSE'
}

export type VisitsByInsuranceTypeInput = {
  readonly end?: InputMaybe<Scalars['DateTime']>;
  readonly insuranceType: Scalars['String'];
  readonly start?: InputMaybe<Scalars['DateTime']>;
};

export type VisitsByPatientInput = {
  readonly patientUuid: Scalars['String'];
};

export type VitalLineItem = {
  readonly __typename?: 'VitalLineItem';
  readonly clinic: VisitFacilitySnapshot;
  readonly id: Scalars['ID'];
  readonly location?: Maybe<VisitInvestigationLocationSnapshot>;
  readonly meta: Meta;
  readonly organisation: VisitFacilitySnapshot;
  readonly performer: VisitElephantActor;
  readonly unit?: Maybe<Scalars['String']>;
  readonly value: Scalars['String'];
};

export type Vmp = ClinicalProduct & ClinicalProductInventorySummary & {
  readonly __typename?: 'Vmp';
  readonly category?: Maybe<MedicationCategory>;
  readonly formulation: ClinicalProductForm;
  readonly id: Scalars['String'];
  readonly inventory: ExternalReferenceInventorySummary;
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly legacyMedicationId?: Maybe<Scalars['String']>;
  readonly meta: ProductMeta;
  readonly productType: ProductType;
  readonly snomedId?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly vtmId: Scalars['String'];
};


export type VmpInventoryArgs = {
  input: ClinicalProductInventorySummaryInput;
};

export type VoidCardError = BaseError & {
  readonly __typename?: 'VoidCardError';
  readonly message: Scalars['String'];
  readonly path: ReadonlyArray<Scalars['String']>;
};

export type VoidInvoiceInput = {
  readonly _id: Scalars['String'];
  readonly reason?: InputMaybe<Scalars['String']>;
};

export type Vtm = ClinicalProduct & {
  readonly __typename?: 'Vtm';
  readonly id: Scalars['String'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly meta: ProductMeta;
  readonly productType: ProductType;
  readonly snomedId?: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type UpdateUserEnabledStateInput = {
  readonly _id: Scalars['String'];
  readonly enabled: Scalars['Boolean'];
};
